import { jsx as m, Fragment as Oe, jsxs as O } from "react/jsx-runtime";
import * as _ from "react";
import Tr, { forwardRef as ie, useCallback as Y, useRef as ue, useEffect as le, useImperativeHandle as Bn, useLayoutEffect as Si, useState as J, Fragment as nt, createElement as Ni, useMemo as kn } from "react";
import yn from "rehype-raw";
import { useTranslation as Te, getI18n as vn } from "react-i18next";
import Li from "react-stay-scrolled";
import Ai from "copy-to-clipboard";
import { toast as Ti, ToastContainer as Mi } from "react-toastify";
import { QuestionType as Q } from "@law-connect/types";
import Pi, { createPortal as Fi } from "react-dom";
import './index.css';const Ri = "_textareaInput_zkc54_76", Bi = {
  textareaInput: Ri
}, Di = ie((e, n) => {
  var o;
  const { value: t = "", disabled: r, onChange: i } = e, l = Y((a) => {
    r || i(a.target.value);
  }, [r, i]);
  return /* @__PURE__ */ m(
    "textarea",
    {
      ref: n,
      ...e.props,
      className: `${Bi.textareaInput} ${(o = e.props) == null ? void 0 : o.className}`,
      onChange: l,
      disabled: r,
      value: t
    }
  );
}), $i = "_message_iowuy_76", Oi = {
  message: $i
};
function zi(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const Hi = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Vi = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, ji = {};
function Mt(e, n) {
  return (ji.jsx ? Vi : Hi).test(e);
}
const qi = /[ \t\n\f\r]/g;
function Wi(e) {
  return typeof e == "object" ? e.type === "text" ? Pt(e.value) : !1 : Pt(e);
}
function Pt(e) {
  return e.replace(qi, "") === "";
}
class xn {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, t, r) {
    this.property = n, this.normal = t, r && (this.space = r);
  }
}
xn.prototype.property = {};
xn.prototype.normal = {};
xn.prototype.space = null;
function Mr(e, n) {
  const t = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(t, e[i].property), Object.assign(r, e[i].normal);
  return new xn(t, r, n);
}
function tt(e) {
  return e.toLowerCase();
}
class Se {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, t) {
    this.property = n, this.attribute = t;
  }
}
Se.prototype.space = null;
Se.prototype.boolean = !1;
Se.prototype.booleanish = !1;
Se.prototype.overloadedBoolean = !1;
Se.prototype.number = !1;
Se.prototype.commaSeparated = !1;
Se.prototype.spaceSeparated = !1;
Se.prototype.commaOrSpaceSeparated = !1;
Se.prototype.mustUseProperty = !1;
Se.prototype.defined = !1;
let Zi = 0;
const q = Ye(), se = Ye(), Pr = Ye(), F = Ye(), te = Ye(), tn = Ye(), xe = Ye();
function Ye() {
  return 2 ** ++Zi;
}
const rt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: q,
  booleanish: se,
  commaOrSpaceSeparated: xe,
  commaSeparated: tn,
  number: F,
  overloadedBoolean: Pr,
  spaceSeparated: te
}, Symbol.toStringTag, { value: "Module" })), zn = Object.keys(rt);
class dt extends Se {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, t, r, i) {
    let l = -1;
    if (super(n, t), Ft(this, "space", i), typeof r == "number")
      for (; ++l < zn.length; ) {
        const o = zn[l];
        Ft(this, zn[l], (r & rt[o]) === rt[o]);
      }
  }
}
dt.prototype.defined = !0;
function Ft(e, n, t) {
  t && (e[n] = t);
}
const Ui = {}.hasOwnProperty;
function on(e) {
  const n = {}, t = {};
  let r;
  for (r in e.properties)
    if (Ui.call(e.properties, r)) {
      const i = e.properties[r], l = new dt(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (l.mustUseProperty = !0), n[r] = l, t[tt(r)] = r, t[tt(l.attribute)] = r;
    }
  return new xn(n, t, e.space);
}
const Fr = on({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Rr = on({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Br(e, n) {
  return n in e ? e[n] : n;
}
function Dr(e, n) {
  return Br(e, n.toLowerCase());
}
const $r = on({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Dr,
  properties: { xmlns: null, xmlnsXLink: null }
}), Or = on({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: se,
    ariaAutoComplete: null,
    ariaBusy: se,
    ariaChecked: se,
    ariaColCount: F,
    ariaColIndex: F,
    ariaColSpan: F,
    ariaControls: te,
    ariaCurrent: null,
    ariaDescribedBy: te,
    ariaDetails: null,
    ariaDisabled: se,
    ariaDropEffect: te,
    ariaErrorMessage: null,
    ariaExpanded: se,
    ariaFlowTo: te,
    ariaGrabbed: se,
    ariaHasPopup: null,
    ariaHidden: se,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: te,
    ariaLevel: F,
    ariaLive: null,
    ariaModal: se,
    ariaMultiLine: se,
    ariaMultiSelectable: se,
    ariaOrientation: null,
    ariaOwns: te,
    ariaPlaceholder: null,
    ariaPosInSet: F,
    ariaPressed: se,
    ariaReadOnly: se,
    ariaRelevant: null,
    ariaRequired: se,
    ariaRoleDescription: te,
    ariaRowCount: F,
    ariaRowIndex: F,
    ariaRowSpan: F,
    ariaSelected: se,
    ariaSetSize: F,
    ariaSort: null,
    ariaValueMax: F,
    ariaValueMin: F,
    ariaValueNow: F,
    ariaValueText: null,
    role: null
  }
}), Qi = on({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Dr,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: tn,
    acceptCharset: te,
    accessKey: te,
    action: null,
    allow: null,
    allowFullScreen: q,
    allowPaymentRequest: q,
    allowUserMedia: q,
    alt: null,
    as: null,
    async: q,
    autoCapitalize: null,
    autoComplete: te,
    autoFocus: q,
    autoPlay: q,
    blocking: te,
    capture: null,
    charSet: null,
    checked: q,
    cite: null,
    className: te,
    cols: F,
    colSpan: null,
    content: null,
    contentEditable: se,
    controls: q,
    controlsList: te,
    coords: F | tn,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: q,
    defer: q,
    dir: null,
    dirName: null,
    disabled: q,
    download: Pr,
    draggable: se,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: q,
    formTarget: null,
    headers: te,
    height: F,
    hidden: q,
    high: F,
    href: null,
    hrefLang: null,
    htmlFor: te,
    httpEquiv: te,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: q,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: q,
    itemId: null,
    itemProp: te,
    itemRef: te,
    itemScope: q,
    itemType: te,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: q,
    low: F,
    manifest: null,
    max: null,
    maxLength: F,
    media: null,
    method: null,
    min: null,
    minLength: F,
    multiple: q,
    muted: q,
    name: null,
    nonce: null,
    noModule: q,
    noValidate: q,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: q,
    optimum: F,
    pattern: null,
    ping: te,
    placeholder: null,
    playsInline: q,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: q,
    referrerPolicy: null,
    rel: te,
    required: q,
    reversed: q,
    rows: F,
    rowSpan: F,
    sandbox: te,
    scope: null,
    scoped: q,
    seamless: q,
    selected: q,
    shadowRootClonable: q,
    shadowRootDelegatesFocus: q,
    shadowRootMode: null,
    shape: null,
    size: F,
    sizes: null,
    slot: null,
    span: F,
    spellCheck: se,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: F,
    step: null,
    style: null,
    tabIndex: F,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: q,
    useMap: null,
    value: se,
    width: F,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: te,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: F,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: F,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: q,
    // Lists. Use CSS to reduce space between items instead
    declare: q,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: F,
    // `<img>` and `<object>`
    leftMargin: F,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: F,
    // `<body>`
    marginWidth: F,
    // `<body>`
    noResize: q,
    // `<frame>`
    noHref: q,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: q,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: q,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: F,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: se,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: F,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: F,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: q,
    disableRemotePlayback: q,
    prefix: null,
    property: null,
    results: F,
    security: null,
    unselectable: null
  }
}), Yi = on({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Br,
  properties: {
    about: xe,
    accentHeight: F,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: F,
    amplitude: F,
    arabicForm: null,
    ascent: F,
    attributeName: null,
    attributeType: null,
    azimuth: F,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: F,
    by: null,
    calcMode: null,
    capHeight: F,
    className: te,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: F,
    diffuseConstant: F,
    direction: null,
    display: null,
    dur: null,
    divisor: F,
    dominantBaseline: null,
    download: q,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: F,
    enableBackground: null,
    end: null,
    event: null,
    exponent: F,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: F,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: tn,
    g2: tn,
    glyphName: tn,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: F,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: F,
    horizOriginX: F,
    horizOriginY: F,
    id: null,
    ideographic: F,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: F,
    k: F,
    k1: F,
    k2: F,
    k3: F,
    k4: F,
    kernelMatrix: xe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: F,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: F,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: F,
    overlineThickness: F,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: F,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: te,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: F,
    pointsAtY: F,
    pointsAtZ: F,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: xe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: xe,
    rev: xe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: xe,
    requiredFeatures: xe,
    requiredFonts: xe,
    requiredFormats: xe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: F,
    specularExponent: F,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: F,
    strikethroughThickness: F,
    string: null,
    stroke: null,
    strokeDashArray: xe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: F,
    strokeOpacity: F,
    strokeWidth: null,
    style: null,
    surfaceScale: F,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: xe,
    tabIndex: F,
    tableValues: null,
    target: null,
    targetX: F,
    targetY: F,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: xe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: F,
    underlineThickness: F,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: F,
    values: null,
    vAlphabetic: F,
    vMathematical: F,
    vectorEffect: null,
    vHanging: F,
    vIdeographic: F,
    version: null,
    vertAdvY: F,
    vertOriginX: F,
    vertOriginY: F,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: F,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Ki = /^data[-\w.:]+$/i, Rt = /-[a-z]/g, Xi = /[A-Z]/g;
function Ji(e, n) {
  const t = tt(n);
  let r = n, i = Se;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && Ki.test(n)) {
    if (n.charAt(4) === "-") {
      const l = n.slice(5).replace(Rt, el);
      r = "data" + l.charAt(0).toUpperCase() + l.slice(1);
    } else {
      const l = n.slice(4);
      if (!Rt.test(l)) {
        let o = l.replace(Xi, Gi);
        o.charAt(0) !== "-" && (o = "-" + o), n = "data" + o;
      }
    }
    i = dt;
  }
  return new i(r, n);
}
function Gi(e) {
  return "-" + e.toLowerCase();
}
function el(e) {
  return e.charAt(1).toUpperCase();
}
const nl = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, tl = Mr([Rr, Fr, $r, Or, Qi], "html"), ht = Mr([Rr, Fr, $r, Or, Yi], "svg");
function rl(e) {
  return e.join(" ").trim();
}
var Bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function il(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var zr = {}, Dt = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, ll = /\n/g, ol = /^\s*/, al = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, sl = /^:\s*/, cl = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, ul = /^[;\s]*/, pl = /^\s+|\s+$/g, dl = `
`, $t = "/", Ot = "*", Qe = "", hl = "comment", fl = "declaration", ml = function(e, n) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  n = n || {};
  var t = 1, r = 1;
  function i(y) {
    var x = y.match(ll);
    x && (t += x.length);
    var b = y.lastIndexOf(dl);
    r = ~b ? y.length - b : r + y.length;
  }
  function l() {
    var y = { line: t, column: r };
    return function(x) {
      return x.position = new o(y), c(), x;
    };
  }
  function o(y) {
    this.start = y, this.end = { line: t, column: r }, this.source = n.source;
  }
  o.prototype.content = e;
  function a(y) {
    var x = new Error(
      n.source + ":" + t + ":" + r + ": " + y
    );
    if (x.reason = y, x.filename = n.source, x.line = t, x.column = r, x.source = e, !n.silent) throw x;
  }
  function s(y) {
    var x = y.exec(e);
    if (x) {
      var b = x[0];
      return i(b), e = e.slice(b.length), x;
    }
  }
  function c() {
    s(ol);
  }
  function u(y) {
    var x;
    for (y = y || []; x = d(); )
      x !== !1 && y.push(x);
    return y;
  }
  function d() {
    var y = l();
    if (!($t != e.charAt(0) || Ot != e.charAt(1))) {
      for (var x = 2; Qe != e.charAt(x) && (Ot != e.charAt(x) || $t != e.charAt(x + 1)); )
        ++x;
      if (x += 2, Qe === e.charAt(x - 1))
        return a("End of comment missing");
      var b = e.slice(2, x - 2);
      return r += 2, i(b), e = e.slice(x), r += 2, y({
        type: hl,
        comment: b
      });
    }
  }
  function h() {
    var y = l(), x = s(al);
    if (x) {
      if (d(), !s(sl)) return a("property missing ':'");
      var b = s(cl), w = y({
        type: fl,
        property: zt(x[0].replace(Dt, Qe)),
        value: b ? zt(b[0].replace(Dt, Qe)) : Qe
      });
      return s(ul), w;
    }
  }
  function p() {
    var y = [];
    u(y);
    for (var x; x = h(); )
      x !== !1 && (y.push(x), u(y));
    return y;
  }
  return c(), p();
};
function zt(e) {
  return e ? e.replace(pl, Qe) : Qe;
}
var gl = Bt && Bt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(zr, "__esModule", { value: !0 });
var yl = gl(ml);
function wl(e, n) {
  var t = null;
  if (!e || typeof e != "string")
    return t;
  var r = (0, yl.default)(e), i = typeof n == "function";
  return r.forEach(function(l) {
    if (l.type === "declaration") {
      var o = l.property, a = l.value;
      i ? n(o, a, l) : a && (t = t || {}, t[o] = a);
    }
  }), t;
}
var Ht = zr.default = wl;
const Cl = Ht.default || Ht, Hr = Vr("end"), ft = Vr("start");
function Vr(e) {
  return n;
  function n(t) {
    const r = t && t.position && t.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function vl(e) {
  const n = ft(e), t = Hr(e);
  if (n && t)
    return { start: n, end: t };
}
function mn(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Vt(e.position) : "start" in e || "end" in e ? Vt(e) : "line" in e || "column" in e ? it(e) : "";
}
function it(e) {
  return jt(e && e.line) + ":" + jt(e && e.column);
}
function Vt(e) {
  return it(e && e.start) + "-" + it(e && e.end);
}
function jt(e) {
  return e && typeof e == "number" ? e : 1;
}
class de extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, r) {
    super(), typeof t == "string" && (r = t, t = void 0);
    let i = "", l = {}, o = !1;
    if (t && ("line" in t && "column" in t ? l = { place: t } : "start" in t && "end" in t ? l = { place: t } : "type" in t ? l = {
      ancestors: [t],
      place: t.position
    } : l = { ...t }), typeof n == "string" ? i = n : !l.cause && n && (o = !0, i = n.message, l.cause = n), !l.ruleId && !l.source && typeof r == "string") {
      const s = r.indexOf(":");
      s === -1 ? l.ruleId = r : (l.source = r.slice(0, s), l.ruleId = r.slice(s + 1));
    }
    if (!l.place && l.ancestors && l.ancestors) {
      const s = l.ancestors[l.ancestors.length - 1];
      s && (l.place = s.position);
    }
    const a = l.place && "start" in l.place ? l.place.start : l.place;
    this.ancestors = l.ancestors || void 0, this.cause = l.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = a ? a.line : void 0, this.name = mn(l.place) || "1:1", this.place = l.place || void 0, this.reason = this.message, this.ruleId = l.ruleId || void 0, this.source = l.source || void 0, this.stack = o && l.cause && typeof l.cause.stack == "string" ? l.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
de.prototype.file = "";
de.prototype.name = "";
de.prototype.reason = "";
de.prototype.message = "";
de.prototype.stack = "";
de.prototype.column = void 0;
de.prototype.line = void 0;
de.prototype.ancestors = void 0;
de.prototype.cause = void 0;
de.prototype.fatal = void 0;
de.prototype.place = void 0;
de.prototype.ruleId = void 0;
de.prototype.source = void 0;
const mt = {}.hasOwnProperty, xl = /* @__PURE__ */ new Map(), bl = /[A-Z]/g, _l = /-([a-z])/g, kl = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), Il = /* @__PURE__ */ new Set(["td", "th"]), jr = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function El(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let r;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = Fl(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = Pl(t, n.jsx, n.jsxs);
  }
  const i = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: r,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? ht : tl,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, l = qr(i, e, void 0);
  return l && typeof l != "string" ? l : i.create(
    e,
    i.Fragment,
    { children: l || void 0 },
    void 0
  );
}
function qr(e, n, t) {
  if (n.type === "element")
    return Sl(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return Nl(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return Al(e, n, t);
  if (n.type === "mdxjsEsm")
    return Ll(e, n);
  if (n.type === "root")
    return Tl(e, n, t);
  if (n.type === "text")
    return Ml(e, n);
}
function Sl(e, n, t) {
  const r = e.schema;
  let i = r;
  n.tagName.toLowerCase() === "svg" && r.space === "html" && (i = ht, e.schema = i), e.ancestors.push(n);
  const l = Zr(e, n.tagName, !1), o = Rl(e, n);
  let a = yt(e, n);
  return kl.has(n.tagName) && (a = a.filter(function(s) {
    return typeof s == "string" ? !Wi(s) : !0;
  })), Wr(e, o, l, n), gt(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function Nl(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const r = n.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  wn(e, n.position);
}
function Ll(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  wn(e, n.position);
}
function Al(e, n, t) {
  const r = e.schema;
  let i = r;
  n.name === "svg" && r.space === "html" && (i = ht, e.schema = i), e.ancestors.push(n);
  const l = n.name === null ? e.Fragment : Zr(e, n.name, !0), o = Bl(e, n), a = yt(e, n);
  return Wr(e, o, l, n), gt(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function Tl(e, n, t) {
  const r = {};
  return gt(r, yt(e, n)), e.create(n, e.Fragment, r, t);
}
function Ml(e, n) {
  return n.value;
}
function Wr(e, n, t, r) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = r);
}
function gt(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function Pl(e, n, t) {
  return r;
  function r(i, l, o, a) {
    const c = Array.isArray(o.children) ? t : n;
    return a ? c(l, o, a) : c(l, o);
  }
}
function Fl(e, n) {
  return t;
  function t(r, i, l, o) {
    const a = Array.isArray(l.children), s = ft(r);
    return n(
      i,
      l,
      o,
      a,
      {
        columnNumber: s ? s.column - 1 : void 0,
        fileName: e,
        lineNumber: s ? s.line : void 0
      },
      void 0
    );
  }
}
function Rl(e, n) {
  const t = {};
  let r, i;
  for (i in n.properties)
    if (i !== "children" && mt.call(n.properties, i)) {
      const l = Dl(e, i, n.properties[i]);
      if (l) {
        const [o, a] = l;
        e.tableCellAlignToStyle && o === "align" && typeof a == "string" && Il.has(n.tagName) ? r = a : t[o] = a;
      }
    }
  if (r) {
    const l = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    l[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return t;
}
function Bl(e, n) {
  const t = {};
  for (const r of n.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const l = r.data.estree.body[0];
        l.type;
        const o = l.expression;
        o.type;
        const a = o.properties[0];
        a.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        wn(e, n.position);
    else {
      const i = r.name;
      let l;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, l = e.evaluater.evaluateExpression(a.expression);
        } else
          wn(e, n.position);
      else
        l = r.value === null ? !0 : r.value;
      t[i] = /** @type {Props[keyof Props]} */
      l;
    }
  return t;
}
function yt(e, n) {
  const t = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : xl;
  for (; ++r < n.children.length; ) {
    const l = n.children[r];
    let o;
    if (e.passKeys) {
      const s = l.type === "element" ? l.tagName : l.type === "mdxJsxFlowElement" || l.type === "mdxJsxTextElement" ? l.name : void 0;
      if (s) {
        const c = i.get(s) || 0;
        o = s + "-" + c, i.set(s, c + 1);
      }
    }
    const a = qr(e, l, o);
    a !== void 0 && t.push(a);
  }
  return t;
}
function Dl(e, n, t) {
  const r = Ji(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = r.commaSeparated ? zi(t) : rl(t)), r.property === "style") {
      let i = typeof t == "object" ? t : $l(e, String(t));
      return e.stylePropertyNameCase === "css" && (i = Ol(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? nl[r.property] || r.property : r.attribute,
      t
    ];
  }
}
function $l(e, n) {
  const t = {};
  try {
    Cl(n, r);
  } catch (i) {
    if (!e.ignoreInvalidStyle) {
      const l = (
        /** @type {Error} */
        i
      ), o = new de("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: l,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw o.file = e.filePath || void 0, o.url = jr + "#cannot-parse-style-attribute", o;
    }
  }
  return t;
  function r(i, l) {
    let o = i;
    o.slice(0, 2) !== "--" && (o.slice(0, 4) === "-ms-" && (o = "ms-" + o.slice(4)), o = o.replace(_l, Hl)), t[o] = l;
  }
}
function Zr(e, n, t) {
  let r;
  if (!t)
    r = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const i = n.split(".");
    let l = -1, o;
    for (; ++l < i.length; ) {
      const a = Mt(i[l]) ? { type: "Identifier", name: i[l] } : { type: "Literal", value: i[l] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: a,
        computed: !!(l && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = o;
  } else
    r = Mt(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (r.type === "Literal") {
    const i = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return mt.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  wn(e);
}
function wn(e, n) {
  const t = new de(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = jr + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function Ol(e) {
  const n = {};
  let t;
  for (t in e)
    mt.call(e, t) && (n[zl(t)] = e[t]);
  return n;
}
function zl(e) {
  let n = e.replace(bl, Vl);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function Hl(e, n) {
  return n.toUpperCase();
}
function Vl(e) {
  return "-" + e.toLowerCase();
}
const Hn = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, jl = {};
function ql(e, n) {
  const t = jl, r = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, i = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return Ur(e, r, i);
}
function Ur(e, n, t) {
  if (Wl(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return qt(e.children, n, t);
  }
  return Array.isArray(e) ? qt(e, n, t) : "";
}
function qt(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Ur(e[i], n, t);
  return r.join("");
}
function Wl(e) {
  return !!(e && typeof e == "object");
}
const Wt = document.createElement("i");
function wt(e) {
  const n = "&" + e + ";";
  Wt.innerHTML = n;
  const t = Wt.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function ze(e, n, t, r) {
  const i = e.length;
  let l = 0, o;
  if (n < 0 ? n = -n > i ? 0 : i + n : n = n > i ? i : n, t = t > 0 ? t : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(n, t), e.splice(...o);
  else
    for (t && e.splice(n, t); l < r.length; )
      o = r.slice(l, l + 1e4), o.unshift(n, 0), e.splice(...o), l += 1e4, n += 1e4;
}
function Ee(e, n) {
  return e.length > 0 ? (ze(e, e.length, 0, n), e) : n;
}
const Zt = {}.hasOwnProperty;
function Zl(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    Ul(n, e[t]);
  return n;
}
function Ul(e, n) {
  let t;
  for (t in n) {
    const i = (Zt.call(e, t) ? e[t] : void 0) || (e[t] = {}), l = n[t];
    let o;
    if (l)
      for (o in l) {
        Zt.call(i, o) || (i[o] = []);
        const a = l[o];
        Ql(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function Ql(e, n) {
  let t = -1;
  const r = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : r).push(n[t]);
  ze(e, 0, 0, r);
}
function Qr(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function rn(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Fe = qe(/[A-Za-z]/), be = qe(/[\dA-Za-z]/), Yl = qe(/[#-'*+\--9=?A-Z^-~]/);
function lt(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ot = qe(/\d/), Kl = qe(/[\dA-Fa-f]/), Xl = qe(/[!-/:-@[-`{-~]/);
function H(e) {
  return e !== null && e < -2;
}
function ye(e) {
  return e !== null && (e < 0 || e === 32);
}
function K(e) {
  return e === -2 || e === -1 || e === 32;
}
const Jl = qe(new RegExp("\\p{P}|\\p{S}", "u")), Gl = qe(/\s/);
function qe(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function an(e) {
  const n = [];
  let t = -1, r = 0, i = 0;
  for (; ++t < e.length; ) {
    const l = e.charCodeAt(t);
    let o = "";
    if (l === 37 && be(e.charCodeAt(t + 1)) && be(e.charCodeAt(t + 2)))
      i = 2;
    else if (l < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(l)) || (o = String.fromCharCode(l));
    else if (l > 55295 && l < 57344) {
      const a = e.charCodeAt(t + 1);
      l < 56320 && a > 56319 && a < 57344 ? (o = String.fromCharCode(l, a), i = 1) : o = "�";
    } else
      o = String.fromCharCode(l);
    o && (n.push(e.slice(r, t), encodeURIComponent(o)), r = t + i + 1, o = ""), i && (t += i, i = 0);
  }
  return n.join("") + e.slice(r);
}
function re(e, n, t, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let l = 0;
  return o;
  function o(s) {
    return K(s) ? (e.enter(t), a(s)) : n(s);
  }
  function a(s) {
    return K(s) && l++ < i ? (e.consume(s), a) : (e.exit(t), n(s));
  }
}
const eo = {
  tokenize: no
};
function no(e) {
  const n = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let t;
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), re(e, n, "linePrefix");
  }
  function i(a) {
    return e.enter("paragraph"), l(a);
  }
  function l(a) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = s), t = s, o(a);
  }
  function o(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return H(a) ? (e.consume(a), e.exit("chunkText"), l) : (e.consume(a), o);
  }
}
const to = {
  tokenize: ro
}, Ut = {
  tokenize: io
};
function ro(e) {
  const n = this, t = [];
  let r = 0, i, l, o;
  return a;
  function a(C) {
    if (r < t.length) {
      const M = t[r];
      return n.containerState = M[1], e.attempt(
        M[0].continuation,
        s,
        c
      )(C);
    }
    return c(C);
  }
  function s(C) {
    if (r++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, i && I();
      const M = n.events.length;
      let L = M, v;
      for (; L--; )
        if (n.events[L][0] === "exit" && n.events[L][1].type === "chunkFlow") {
          v = n.events[L][1].end;
          break;
        }
      w(r);
      let S = M;
      for (; S < n.events.length; )
        n.events[S][1].end = Object.assign({}, v), S++;
      return ze(
        n.events,
        L + 1,
        0,
        n.events.slice(M)
      ), n.events.length = S, c(C);
    }
    return a(C);
  }
  function c(C) {
    if (r === t.length) {
      if (!i)
        return h(C);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return y(C);
      n.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(
      Ut,
      u,
      d
    )(C);
  }
  function u(C) {
    return i && I(), w(r), h(C);
  }
  function d(C) {
    return n.parser.lazy[n.now().line] = r !== t.length, o = n.now().offset, y(C);
  }
  function h(C) {
    return n.containerState = {}, e.attempt(
      Ut,
      p,
      y
    )(C);
  }
  function p(C) {
    return r++, t.push([n.currentConstruct, n.containerState]), h(C);
  }
  function y(C) {
    if (C === null) {
      i && I(), w(0), e.consume(C);
      return;
    }
    return i = i || n.parser.flow(n.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: l,
      _tokenizer: i
    }), x(C);
  }
  function x(C) {
    if (C === null) {
      b(e.exit("chunkFlow"), !0), w(0), e.consume(C);
      return;
    }
    return H(C) ? (e.consume(C), b(e.exit("chunkFlow")), r = 0, n.interrupt = void 0, a) : (e.consume(C), x);
  }
  function b(C, M) {
    const L = n.sliceStream(C);
    if (M && L.push(null), C.previous = l, l && (l.next = C), l = C, i.defineSkip(C.start), i.write(L), n.parser.lazy[C.start.line]) {
      let v = i.events.length;
      for (; v--; )
        if (
          // The token starts before the line ending…
          i.events[v][1].start.offset < o && // …and either is not ended yet…
          (!i.events[v][1].end || // …or ends after it.
          i.events[v][1].end.offset > o)
        )
          return;
      const S = n.events.length;
      let P = S, E, R;
      for (; P--; )
        if (n.events[P][0] === "exit" && n.events[P][1].type === "chunkFlow") {
          if (E) {
            R = n.events[P][1].end;
            break;
          }
          E = !0;
        }
      for (w(r), v = S; v < n.events.length; )
        n.events[v][1].end = Object.assign({}, R), v++;
      ze(
        n.events,
        P + 1,
        0,
        n.events.slice(S)
      ), n.events.length = v;
    }
  }
  function w(C) {
    let M = t.length;
    for (; M-- > C; ) {
      const L = t[M];
      n.containerState = L[1], L[0].exit.call(n, e);
    }
    t.length = C;
  }
  function I() {
    i.write([null]), l = void 0, i = void 0, n.containerState._closeFlow = void 0;
  }
}
function io(e, n, t) {
  return re(
    e,
    e.attempt(this.parser.constructs.document, n, t),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Qt(e) {
  if (e === null || ye(e) || Gl(e))
    return 1;
  if (Jl(e))
    return 2;
}
function Ct(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const l = e[i].resolveAll;
    l && !r.includes(l) && (n = l(n, t), r.push(l));
  }
  return n;
}
const at = {
  name: "attention",
  tokenize: oo,
  resolveAll: lo
};
function lo(e, n) {
  let t = -1, r, i, l, o, a, s, c, u;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (r = t; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        n.sliceSerialize(e[r][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          s = e[r][1].end.offset - e[r][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, e[r][1].end), h = Object.assign({}, e[t][1].start);
          Yt(d, -s), Yt(h, s), o = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, e[r][1].end)
          }, a = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[t][1].start),
            end: h
          }, l = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[t][1].start)
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: Object.assign({}, o.start),
            end: Object.assign({}, a.end)
          }, e[r][1].end = Object.assign({}, o.start), e[t][1].start = Object.assign({}, a.end), c = [], e[r][1].end.offset - e[r][1].start.offset && (c = Ee(c, [["enter", e[r][1], n], ["exit", e[r][1], n]])), c = Ee(c, [["enter", i, n], ["enter", o, n], ["exit", o, n], ["enter", l, n]]), c = Ee(c, Ct(n.parser.constructs.insideSpan.null, e.slice(r + 1, t), n)), c = Ee(c, [["exit", l, n], ["enter", a, n], ["exit", a, n], ["exit", i, n]]), e[t][1].end.offset - e[t][1].start.offset ? (u = 2, c = Ee(c, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : u = 0, ze(e, r - 1, t - r + 3, c), t = r + c.length - u - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function oo(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Qt(r);
  let l;
  return o;
  function o(s) {
    return l = s, e.enter("attentionSequence"), a(s);
  }
  function a(s) {
    if (s === l)
      return e.consume(s), a;
    const c = e.exit("attentionSequence"), u = Qt(s), d = !u || u === 2 && i || t.includes(s), h = !i || i === 2 && u || t.includes(r);
    return c._open = !!(l === 42 ? d : d && (i || !h)), c._close = !!(l === 42 ? h : h && (u || !d)), n(s);
  }
}
function Yt(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const ao = {
  name: "autolink",
  tokenize: so
};
function so(e, n, t) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), l;
  }
  function l(p) {
    return Fe(p) ? (e.consume(p), o) : p === 64 ? t(p) : c(p);
  }
  function o(p) {
    return p === 43 || p === 45 || p === 46 || be(p) ? (r = 1, a(p)) : c(p);
  }
  function a(p) {
    return p === 58 ? (e.consume(p), r = 0, s) : (p === 43 || p === 45 || p === 46 || be(p)) && r++ < 32 ? (e.consume(p), a) : (r = 0, c(p));
  }
  function s(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), n) : p === null || p === 32 || p === 60 || lt(p) ? t(p) : (e.consume(p), s);
  }
  function c(p) {
    return p === 64 ? (e.consume(p), u) : Yl(p) ? (e.consume(p), c) : t(p);
  }
  function u(p) {
    return be(p) ? d(p) : t(p);
  }
  function d(p) {
    return p === 46 ? (e.consume(p), r = 0, u) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(p);
  }
  function h(p) {
    if ((p === 45 || be(p)) && r++ < 63) {
      const y = p === 45 ? h : d;
      return e.consume(p), y;
    }
    return t(p);
  }
}
const Dn = {
  tokenize: co,
  partial: !0
};
function co(e, n, t) {
  return r;
  function r(l) {
    return K(l) ? re(e, i, "linePrefix")(l) : i(l);
  }
  function i(l) {
    return l === null || H(l) ? n(l) : t(l);
  }
}
const Yr = {
  name: "blockQuote",
  tokenize: uo,
  continuation: {
    tokenize: po
  },
  exit: ho
};
function uo(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), l;
    }
    return t(o);
  }
  function l(o) {
    return K(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(o));
  }
}
function po(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return K(o) ? re(e, l, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : l(o);
  }
  function l(o) {
    return e.attempt(Yr, n, t)(o);
  }
}
function ho(e) {
  e.exit("blockQuote");
}
const Kr = {
  name: "characterEscape",
  tokenize: fo
};
function fo(e, n, t) {
  return r;
  function r(l) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(l), e.exit("escapeMarker"), i;
  }
  function i(l) {
    return Xl(l) ? (e.enter("characterEscapeValue"), e.consume(l), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(l);
  }
}
const Xr = {
  name: "characterReference",
  tokenize: mo
};
function mo(e, n, t) {
  const r = this;
  let i = 0, l, o;
  return a;
  function a(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), s;
  }
  function s(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), l = 31, o = be, u(d));
  }
  function c(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), l = 6, o = Kl, u) : (e.enter("characterReferenceValue"), l = 7, o = ot, u(d));
  }
  function u(d) {
    if (d === 59 && i) {
      const h = e.exit("characterReferenceValue");
      return o === be && !wt(r.sliceSerialize(h)) ? t(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return o(d) && i++ < l ? (e.consume(d), u) : t(d);
  }
}
const Kt = {
  tokenize: yo,
  partial: !0
}, Xt = {
  name: "codeFenced",
  tokenize: go,
  concrete: !0
};
function go(e, n, t) {
  const r = this, i = {
    tokenize: L,
    partial: !0
  };
  let l = 0, o = 0, a;
  return s;
  function s(v) {
    return c(v);
  }
  function c(v) {
    const S = r.events[r.events.length - 1];
    return l = S && S[1].type === "linePrefix" ? S[2].sliceSerialize(S[1], !0).length : 0, a = v, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(v);
  }
  function u(v) {
    return v === a ? (o++, e.consume(v), u) : o < 3 ? t(v) : (e.exit("codeFencedFenceSequence"), K(v) ? re(e, d, "whitespace")(v) : d(v));
  }
  function d(v) {
    return v === null || H(v) ? (e.exit("codeFencedFence"), r.interrupt ? n(v) : e.check(Kt, x, M)(v)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(v));
  }
  function h(v) {
    return v === null || H(v) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(v)) : K(v) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), re(e, p, "whitespace")(v)) : v === 96 && v === a ? t(v) : (e.consume(v), h);
  }
  function p(v) {
    return v === null || H(v) ? d(v) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), y(v));
  }
  function y(v) {
    return v === null || H(v) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(v)) : v === 96 && v === a ? t(v) : (e.consume(v), y);
  }
  function x(v) {
    return e.attempt(i, M, b)(v);
  }
  function b(v) {
    return e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), w;
  }
  function w(v) {
    return l > 0 && K(v) ? re(e, I, "linePrefix", l + 1)(v) : I(v);
  }
  function I(v) {
    return v === null || H(v) ? e.check(Kt, x, M)(v) : (e.enter("codeFlowValue"), C(v));
  }
  function C(v) {
    return v === null || H(v) ? (e.exit("codeFlowValue"), I(v)) : (e.consume(v), C);
  }
  function M(v) {
    return e.exit("codeFenced"), n(v);
  }
  function L(v, S, P) {
    let E = 0;
    return R;
    function R($) {
      return v.enter("lineEnding"), v.consume($), v.exit("lineEnding"), k;
    }
    function k($) {
      return v.enter("codeFencedFence"), K($) ? re(v, A, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)($) : A($);
    }
    function A($) {
      return $ === a ? (v.enter("codeFencedFenceSequence"), T($)) : P($);
    }
    function T($) {
      return $ === a ? (E++, v.consume($), T) : E >= o ? (v.exit("codeFencedFenceSequence"), K($) ? re(v, D, "whitespace")($) : D($)) : P($);
    }
    function D($) {
      return $ === null || H($) ? (v.exit("codeFencedFence"), S($)) : P($);
    }
  }
}
function yo(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? t(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
const Vn = {
  name: "codeIndented",
  tokenize: Co
}, wo = {
  tokenize: vo,
  partial: !0
};
function Co(e, n, t) {
  const r = this;
  return i;
  function i(c) {
    return e.enter("codeIndented"), re(e, l, "linePrefix", 5)(c);
  }
  function l(c) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? o(c) : t(c);
  }
  function o(c) {
    return c === null ? s(c) : H(c) ? e.attempt(wo, o, s)(c) : (e.enter("codeFlowValue"), a(c));
  }
  function a(c) {
    return c === null || H(c) ? (e.exit("codeFlowValue"), o(c)) : (e.consume(c), a);
  }
  function s(c) {
    return e.exit("codeIndented"), n(c);
  }
}
function vo(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? t(o) : H(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : re(e, l, "linePrefix", 5)(o);
  }
  function l(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : H(o) ? i(o) : t(o);
  }
}
const xo = {
  name: "codeText",
  tokenize: ko,
  resolve: bo,
  previous: _o
};
function bo(e) {
  let n = e.length - 4, t = 3, r, i;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (r = t; ++r < n; )
      if (e[r][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (r = t - 1, n++; ++r <= n; )
    i === void 0 ? r !== n && e[r][1].type !== "lineEnding" && (i = r) : (r === n || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), n -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function _o(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function ko(e, n, t) {
  let r = 0, i, l;
  return o;
  function o(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(d);
  }
  function a(d) {
    return d === 96 ? (e.consume(d), r++, a) : (e.exit("codeTextSequence"), s(d));
  }
  function s(d) {
    return d === null ? t(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), s) : d === 96 ? (l = e.enter("codeTextSequence"), i = 0, u(d)) : H(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), s) : (e.enter("codeTextData"), c(d));
  }
  function c(d) {
    return d === null || d === 32 || d === 96 || H(d) ? (e.exit("codeTextData"), s(d)) : (e.consume(d), c);
  }
  function u(d) {
    return d === 96 ? (e.consume(d), i++, u) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), n(d)) : (l.type = "codeTextData", c(d));
  }
}
class Io {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const r = t ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(n, r) : n > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, r) {
    const i = t || 0;
    this.setCursor(Math.trunc(n));
    const l = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && un(this.left, r), l.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), un(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), un(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        un(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        un(this.left, t.reverse());
      }
  }
}
function un(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function Jr(e) {
  const n = {};
  let t = -1, r, i, l, o, a, s, c;
  const u = new Io(e);
  for (; ++t < u.length; ) {
    for (; t in n; )
      t = n[t];
    if (r = u.get(t), t && r[1].type === "chunkFlow" && u.get(t - 1)[1].type === "listItemPrefix" && (s = r[1]._tokenizer.events, l = 0, l < s.length && s[l][1].type === "lineEndingBlank" && (l += 2), l < s.length && s[l][1].type === "content"))
      for (; ++l < s.length && s[l][1].type !== "content"; )
        s[l][1].type === "chunkText" && (s[l][1]._isInFirstContentOfListItem = !0, l++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(n, Eo(u, t)), t = n[t], c = !0);
    else if (r[1]._container) {
      for (l = t, i = void 0; l-- && (o = u.get(l), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = l);
      i && (r[1].end = Object.assign({}, u.get(i)[1].start), a = u.slice(i, t), a.unshift(r), u.splice(i, t - i + 1, a));
    }
  }
  return ze(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !c;
}
function Eo(e, n) {
  const t = e.get(n)[1], r = e.get(n)[2];
  let i = n - 1;
  const l = [], o = t._tokenizer || r.parser[t.contentType](t.start), a = o.events, s = [], c = {};
  let u, d, h = -1, p = t, y = 0, x = 0;
  const b = [x];
  for (; p; ) {
    for (; e.get(++i)[1] !== p; )
      ;
    l.push(i), p._tokenizer || (u = r.sliceStream(p), p.next || u.push(null), d && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = p, p = p.next;
  }
  for (p = t; ++h < a.length; )
    // Find a void token that includes a break.
    a[h][0] === "exit" && a[h - 1][0] === "enter" && a[h][1].type === a[h - 1][1].type && a[h][1].start.line !== a[h][1].end.line && (x = h + 1, b.push(x), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : b.pop(), h = b.length; h--; ) {
    const w = a.slice(b[h], b[h + 1]), I = l.pop();
    s.push([I, I + w.length - 1]), e.splice(I, 2, w);
  }
  for (s.reverse(), h = -1; ++h < s.length; )
    c[y + s[h][0]] = y + s[h][1], y += s[h][1] - s[h][0] - 1;
  return c;
}
const So = {
  tokenize: Ao,
  resolve: Lo
}, No = {
  tokenize: To,
  partial: !0
};
function Lo(e) {
  return Jr(e), e;
}
function Ao(e, n) {
  let t;
  return r;
  function r(a) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), i(a);
  }
  function i(a) {
    return a === null ? l(a) : H(a) ? e.check(No, o, l)(a) : (e.consume(a), i);
  }
  function l(a) {
    return e.exit("chunkContent"), e.exit("content"), n(a);
  }
  function o(a) {
    return e.consume(a), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, i;
  }
}
function To(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), re(e, l, "linePrefix");
  }
  function l(o) {
    if (o === null || H(o))
      return t(o);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : e.interrupt(r.parser.constructs.flow, t, n)(o);
  }
}
function Gr(e, n, t, r, i, l, o, a, s) {
  const c = s || Number.POSITIVE_INFINITY;
  let u = 0;
  return d;
  function d(w) {
    return w === 60 ? (e.enter(r), e.enter(i), e.enter(l), e.consume(w), e.exit(l), h) : w === null || w === 32 || w === 41 || lt(w) ? t(w) : (e.enter(r), e.enter(o), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), x(w));
  }
  function h(w) {
    return w === 62 ? (e.enter(l), e.consume(w), e.exit(l), e.exit(i), e.exit(r), n) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), p(w));
  }
  function p(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(a), h(w)) : w === null || w === 60 || H(w) ? t(w) : (e.consume(w), w === 92 ? y : p);
  }
  function y(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), p) : p(w);
  }
  function x(w) {
    return !u && (w === null || w === 41 || ye(w)) ? (e.exit("chunkString"), e.exit(a), e.exit(o), e.exit(r), n(w)) : u < c && w === 40 ? (e.consume(w), u++, x) : w === 41 ? (e.consume(w), u--, x) : w === null || w === 32 || w === 40 || lt(w) ? t(w) : (e.consume(w), w === 92 ? b : x);
  }
  function b(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), x) : x(w);
  }
}
function ei(e, n, t, r, i, l) {
  const o = this;
  let a = 0, s;
  return c;
  function c(p) {
    return e.enter(r), e.enter(i), e.consume(p), e.exit(i), e.enter(l), u;
  }
  function u(p) {
    return a > 999 || p === null || p === 91 || p === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !a && "_hiddenFootnoteSupport" in o.parser.constructs ? t(p) : p === 93 ? (e.exit(l), e.enter(i), e.consume(p), e.exit(i), e.exit(r), n) : H(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), d(p));
  }
  function d(p) {
    return p === null || p === 91 || p === 93 || H(p) || a++ > 999 ? (e.exit("chunkString"), u(p)) : (e.consume(p), s || (s = !K(p)), p === 92 ? h : d);
  }
  function h(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), a++, d) : d(p);
  }
}
function ni(e, n, t, r, i, l) {
  let o;
  return a;
  function a(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(r), e.enter(i), e.consume(h), e.exit(i), o = h === 40 ? 41 : h, s) : t(h);
  }
  function s(h) {
    return h === o ? (e.enter(i), e.consume(h), e.exit(i), e.exit(r), n) : (e.enter(l), c(h));
  }
  function c(h) {
    return h === o ? (e.exit(l), s(o)) : h === null ? t(h) : H(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), re(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === o || h === null || H(h) ? (e.exit("chunkString"), c(h)) : (e.consume(h), h === 92 ? d : u);
  }
  function d(h) {
    return h === o || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function gn(e, n) {
  let t;
  return r;
  function r(i) {
    return H(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t = !0, r) : K(i) ? re(
      e,
      r,
      t ? "linePrefix" : "lineSuffix"
    )(i) : n(i);
  }
}
const Mo = {
  name: "definition",
  tokenize: Fo
}, Po = {
  tokenize: Ro,
  partial: !0
};
function Fo(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(p) {
    return e.enter("definition"), o(p);
  }
  function o(p) {
    return ei.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function a(p) {
    return i = rn(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), s) : t(p);
  }
  function s(p) {
    return ye(p) ? gn(e, c)(p) : c(p);
  }
  function c(p) {
    return Gr(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function u(p) {
    return e.attempt(Po, d, d)(p);
  }
  function d(p) {
    return K(p) ? re(e, h, "whitespace")(p) : h(p);
  }
  function h(p) {
    return p === null || H(p) ? (e.exit("definition"), r.parser.defined.push(i), n(p)) : t(p);
  }
}
function Ro(e, n, t) {
  return r;
  function r(a) {
    return ye(a) ? gn(e, i)(a) : t(a);
  }
  function i(a) {
    return ni(e, l, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function l(a) {
    return K(a) ? re(e, o, "whitespace")(a) : o(a);
  }
  function o(a) {
    return a === null || H(a) ? n(a) : t(a);
  }
}
const Bo = {
  name: "hardBreakEscape",
  tokenize: Do
};
function Do(e, n, t) {
  return r;
  function r(l) {
    return e.enter("hardBreakEscape"), e.consume(l), i;
  }
  function i(l) {
    return H(l) ? (e.exit("hardBreakEscape"), n(l)) : t(l);
  }
}
const $o = {
  name: "headingAtx",
  tokenize: zo,
  resolve: Oo
};
function Oo(e, n) {
  let t = e.length - 2, r = 3, i, l;
  return e[r][1].type === "whitespace" && (r += 2), t - 2 > r && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (r === t - 1 || t - 4 > r && e[t - 2][1].type === "whitespace") && (t -= r + 1 === t ? 2 : 4), t > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[t][1].end
  }, l = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, ze(e, r, t - r + 1, [["enter", i, n], ["enter", l, n], ["exit", l, n], ["exit", i, n]])), e;
}
function zo(e, n, t) {
  let r = 0;
  return i;
  function i(u) {
    return e.enter("atxHeading"), l(u);
  }
  function l(u) {
    return e.enter("atxHeadingSequence"), o(u);
  }
  function o(u) {
    return u === 35 && r++ < 6 ? (e.consume(u), o) : u === null || ye(u) ? (e.exit("atxHeadingSequence"), a(u)) : t(u);
  }
  function a(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), s(u)) : u === null || H(u) ? (e.exit("atxHeading"), n(u)) : K(u) ? re(e, a, "whitespace")(u) : (e.enter("atxHeadingText"), c(u));
  }
  function s(u) {
    return u === 35 ? (e.consume(u), s) : (e.exit("atxHeadingSequence"), a(u));
  }
  function c(u) {
    return u === null || u === 35 || ye(u) ? (e.exit("atxHeadingText"), a(u)) : (e.consume(u), c);
  }
}
const Ho = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Jt = ["pre", "script", "style", "textarea"], Vo = {
  name: "htmlFlow",
  tokenize: Zo,
  resolveTo: Wo,
  concrete: !0
}, jo = {
  tokenize: Qo,
  partial: !0
}, qo = {
  tokenize: Uo,
  partial: !0
};
function Wo(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Zo(e, n, t) {
  const r = this;
  let i, l, o, a, s;
  return c;
  function c(f) {
    return u(f);
  }
  function u(f) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(f), d;
  }
  function d(f) {
    return f === 33 ? (e.consume(f), h) : f === 47 ? (e.consume(f), l = !0, x) : f === 63 ? (e.consume(f), i = 3, r.interrupt ? n : g) : Fe(f) ? (e.consume(f), o = String.fromCharCode(f), b) : t(f);
  }
  function h(f) {
    return f === 45 ? (e.consume(f), i = 2, p) : f === 91 ? (e.consume(f), i = 5, a = 0, y) : Fe(f) ? (e.consume(f), i = 4, r.interrupt ? n : g) : t(f);
  }
  function p(f) {
    return f === 45 ? (e.consume(f), r.interrupt ? n : g) : t(f);
  }
  function y(f) {
    const W = "CDATA[";
    return f === W.charCodeAt(a++) ? (e.consume(f), a === W.length ? r.interrupt ? n : A : y) : t(f);
  }
  function x(f) {
    return Fe(f) ? (e.consume(f), o = String.fromCharCode(f), b) : t(f);
  }
  function b(f) {
    if (f === null || f === 47 || f === 62 || ye(f)) {
      const W = f === 47, ee = o.toLowerCase();
      return !W && !l && Jt.includes(ee) ? (i = 1, r.interrupt ? n(f) : A(f)) : Ho.includes(o.toLowerCase()) ? (i = 6, W ? (e.consume(f), w) : r.interrupt ? n(f) : A(f)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? t(f) : l ? I(f) : C(f));
    }
    return f === 45 || be(f) ? (e.consume(f), o += String.fromCharCode(f), b) : t(f);
  }
  function w(f) {
    return f === 62 ? (e.consume(f), r.interrupt ? n : A) : t(f);
  }
  function I(f) {
    return K(f) ? (e.consume(f), I) : R(f);
  }
  function C(f) {
    return f === 47 ? (e.consume(f), R) : f === 58 || f === 95 || Fe(f) ? (e.consume(f), M) : K(f) ? (e.consume(f), C) : R(f);
  }
  function M(f) {
    return f === 45 || f === 46 || f === 58 || f === 95 || be(f) ? (e.consume(f), M) : L(f);
  }
  function L(f) {
    return f === 61 ? (e.consume(f), v) : K(f) ? (e.consume(f), L) : C(f);
  }
  function v(f) {
    return f === null || f === 60 || f === 61 || f === 62 || f === 96 ? t(f) : f === 34 || f === 39 ? (e.consume(f), s = f, S) : K(f) ? (e.consume(f), v) : P(f);
  }
  function S(f) {
    return f === s ? (e.consume(f), s = null, E) : f === null || H(f) ? t(f) : (e.consume(f), S);
  }
  function P(f) {
    return f === null || f === 34 || f === 39 || f === 47 || f === 60 || f === 61 || f === 62 || f === 96 || ye(f) ? L(f) : (e.consume(f), P);
  }
  function E(f) {
    return f === 47 || f === 62 || K(f) ? C(f) : t(f);
  }
  function R(f) {
    return f === 62 ? (e.consume(f), k) : t(f);
  }
  function k(f) {
    return f === null || H(f) ? A(f) : K(f) ? (e.consume(f), k) : t(f);
  }
  function A(f) {
    return f === 45 && i === 2 ? (e.consume(f), U) : f === 60 && i === 1 ? (e.consume(f), G) : f === 62 && i === 4 ? (e.consume(f), z) : f === 63 && i === 3 ? (e.consume(f), g) : f === 93 && i === 5 ? (e.consume(f), fe) : H(f) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(jo, V, T)(f)) : f === null || H(f) ? (e.exit("htmlFlowData"), T(f)) : (e.consume(f), A);
  }
  function T(f) {
    return e.check(qo, D, V)(f);
  }
  function D(f) {
    return e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), $;
  }
  function $(f) {
    return f === null || H(f) ? T(f) : (e.enter("htmlFlowData"), A(f));
  }
  function U(f) {
    return f === 45 ? (e.consume(f), g) : A(f);
  }
  function G(f) {
    return f === 47 ? (e.consume(f), o = "", ce) : A(f);
  }
  function ce(f) {
    if (f === 62) {
      const W = o.toLowerCase();
      return Jt.includes(W) ? (e.consume(f), z) : A(f);
    }
    return Fe(f) && o.length < 8 ? (e.consume(f), o += String.fromCharCode(f), ce) : A(f);
  }
  function fe(f) {
    return f === 93 ? (e.consume(f), g) : A(f);
  }
  function g(f) {
    return f === 62 ? (e.consume(f), z) : f === 45 && i === 2 ? (e.consume(f), g) : A(f);
  }
  function z(f) {
    return f === null || H(f) ? (e.exit("htmlFlowData"), V(f)) : (e.consume(f), z);
  }
  function V(f) {
    return e.exit("htmlFlow"), n(f);
  }
}
function Uo(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return H(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l) : t(o);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
function Qo(e, n, t) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Dn, n, t);
  }
}
const Yo = {
  name: "htmlText",
  tokenize: Ko
};
function Ko(e, n, t) {
  const r = this;
  let i, l, o;
  return a;
  function a(g) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(g), s;
  }
  function s(g) {
    return g === 33 ? (e.consume(g), c) : g === 47 ? (e.consume(g), L) : g === 63 ? (e.consume(g), C) : Fe(g) ? (e.consume(g), P) : t(g);
  }
  function c(g) {
    return g === 45 ? (e.consume(g), u) : g === 91 ? (e.consume(g), l = 0, y) : Fe(g) ? (e.consume(g), I) : t(g);
  }
  function u(g) {
    return g === 45 ? (e.consume(g), p) : t(g);
  }
  function d(g) {
    return g === null ? t(g) : g === 45 ? (e.consume(g), h) : H(g) ? (o = d, G(g)) : (e.consume(g), d);
  }
  function h(g) {
    return g === 45 ? (e.consume(g), p) : d(g);
  }
  function p(g) {
    return g === 62 ? U(g) : g === 45 ? h(g) : d(g);
  }
  function y(g) {
    const z = "CDATA[";
    return g === z.charCodeAt(l++) ? (e.consume(g), l === z.length ? x : y) : t(g);
  }
  function x(g) {
    return g === null ? t(g) : g === 93 ? (e.consume(g), b) : H(g) ? (o = x, G(g)) : (e.consume(g), x);
  }
  function b(g) {
    return g === 93 ? (e.consume(g), w) : x(g);
  }
  function w(g) {
    return g === 62 ? U(g) : g === 93 ? (e.consume(g), w) : x(g);
  }
  function I(g) {
    return g === null || g === 62 ? U(g) : H(g) ? (o = I, G(g)) : (e.consume(g), I);
  }
  function C(g) {
    return g === null ? t(g) : g === 63 ? (e.consume(g), M) : H(g) ? (o = C, G(g)) : (e.consume(g), C);
  }
  function M(g) {
    return g === 62 ? U(g) : C(g);
  }
  function L(g) {
    return Fe(g) ? (e.consume(g), v) : t(g);
  }
  function v(g) {
    return g === 45 || be(g) ? (e.consume(g), v) : S(g);
  }
  function S(g) {
    return H(g) ? (o = S, G(g)) : K(g) ? (e.consume(g), S) : U(g);
  }
  function P(g) {
    return g === 45 || be(g) ? (e.consume(g), P) : g === 47 || g === 62 || ye(g) ? E(g) : t(g);
  }
  function E(g) {
    return g === 47 ? (e.consume(g), U) : g === 58 || g === 95 || Fe(g) ? (e.consume(g), R) : H(g) ? (o = E, G(g)) : K(g) ? (e.consume(g), E) : U(g);
  }
  function R(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || be(g) ? (e.consume(g), R) : k(g);
  }
  function k(g) {
    return g === 61 ? (e.consume(g), A) : H(g) ? (o = k, G(g)) : K(g) ? (e.consume(g), k) : E(g);
  }
  function A(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? t(g) : g === 34 || g === 39 ? (e.consume(g), i = g, T) : H(g) ? (o = A, G(g)) : K(g) ? (e.consume(g), A) : (e.consume(g), D);
  }
  function T(g) {
    return g === i ? (e.consume(g), i = void 0, $) : g === null ? t(g) : H(g) ? (o = T, G(g)) : (e.consume(g), T);
  }
  function D(g) {
    return g === null || g === 34 || g === 39 || g === 60 || g === 61 || g === 96 ? t(g) : g === 47 || g === 62 || ye(g) ? E(g) : (e.consume(g), D);
  }
  function $(g) {
    return g === 47 || g === 62 || ye(g) ? E(g) : t(g);
  }
  function U(g) {
    return g === 62 ? (e.consume(g), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(g);
  }
  function G(g) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), ce;
  }
  function ce(g) {
    return K(g) ? re(e, fe, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(g) : fe(g);
  }
  function fe(g) {
    return e.enter("htmlTextData"), o(g);
  }
}
const vt = {
  name: "labelEnd",
  tokenize: ta,
  resolveTo: na,
  resolveAll: ea
}, Xo = {
  tokenize: ra
}, Jo = {
  tokenize: ia
}, Go = {
  tokenize: la
};
function ea(e) {
  let n = -1;
  for (; ++n < e.length; ) {
    const t = e[n][1];
    (t.type === "labelImage" || t.type === "labelLink" || t.type === "labelEnd") && (e.splice(n + 1, t.type === "labelImage" ? 4 : 2), t.type = "data", n++);
  }
  return e;
}
function na(e, n) {
  let t = e.length, r = 0, i, l, o, a;
  for (; t--; )
    if (i = e[t][1], l) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[t][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[t][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (l = t, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = t);
  const s = {
    type: e[l][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[l][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, c = {
    type: "label",
    start: Object.assign({}, e[l][1].start),
    end: Object.assign({}, e[o][1].end)
  }, u = {
    type: "labelText",
    start: Object.assign({}, e[l + r + 2][1].end),
    end: Object.assign({}, e[o - 2][1].start)
  };
  return a = [["enter", s, n], ["enter", c, n]], a = Ee(a, e.slice(l + 1, l + r + 3)), a = Ee(a, [["enter", u, n]]), a = Ee(a, Ct(n.parser.constructs.insideSpan.null, e.slice(l + r + 4, o - 3), n)), a = Ee(a, [["exit", u, n], e[o - 2], e[o - 1], ["exit", c, n]]), a = Ee(a, e.slice(o + 1)), a = Ee(a, [["exit", s, n]]), ze(e, l, e.length, a), e;
}
function ta(e, n, t) {
  const r = this;
  let i = r.events.length, l, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      l = r.events[i][1];
      break;
    }
  return a;
  function a(h) {
    return l ? l._inactive ? d(h) : (o = r.parser.defined.includes(rn(r.sliceSerialize({
      start: l.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), s) : t(h);
  }
  function s(h) {
    return h === 40 ? e.attempt(Xo, u, o ? u : d)(h) : h === 91 ? e.attempt(Jo, u, o ? c : d)(h) : o ? u(h) : d(h);
  }
  function c(h) {
    return e.attempt(Go, u, d)(h);
  }
  function u(h) {
    return n(h);
  }
  function d(h) {
    return l._balanced = !0, t(h);
  }
}
function ra(e, n, t) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return ye(d) ? gn(e, l)(d) : l(d);
  }
  function l(d) {
    return d === 41 ? u(d) : Gr(e, o, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function o(d) {
    return ye(d) ? gn(e, s)(d) : u(d);
  }
  function a(d) {
    return t(d);
  }
  function s(d) {
    return d === 34 || d === 39 || d === 40 ? ni(e, c, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : u(d);
  }
  function c(d) {
    return ye(d) ? gn(e, u)(d) : u(d);
  }
  function u(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), n) : t(d);
  }
}
function ia(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return ei.call(r, e, l, o, "reference", "referenceMarker", "referenceString")(a);
  }
  function l(a) {
    return r.parser.defined.includes(rn(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? n(a) : t(a);
  }
  function o(a) {
    return t(a);
  }
}
function la(e, n, t) {
  return r;
  function r(l) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), i;
  }
  function i(l) {
    return l === 93 ? (e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), e.exit("reference"), n) : t(l);
  }
}
const oa = {
  name: "labelStartImage",
  tokenize: aa,
  resolveAll: vt.resolveAll
};
function aa(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), l;
  }
  function l(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), o) : t(a);
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(a) : n(a);
  }
}
const sa = {
  name: "labelStartLink",
  tokenize: ca,
  resolveAll: vt.resolveAll
};
function ca(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), l;
  }
  function l(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(o) : n(o);
  }
}
const jn = {
  name: "lineEnding",
  tokenize: ua
};
function ua(e, n) {
  return t;
  function t(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), re(e, n, "linePrefix");
  }
}
const Tn = {
  name: "thematicBreak",
  tokenize: pa
};
function pa(e, n, t) {
  let r = 0, i;
  return l;
  function l(c) {
    return e.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return i = c, a(c);
  }
  function a(c) {
    return c === i ? (e.enter("thematicBreakSequence"), s(c)) : r >= 3 && (c === null || H(c)) ? (e.exit("thematicBreak"), n(c)) : t(c);
  }
  function s(c) {
    return c === i ? (e.consume(c), r++, s) : (e.exit("thematicBreakSequence"), K(c) ? re(e, a, "whitespace")(c) : a(c));
  }
}
const ge = {
  name: "list",
  tokenize: fa,
  continuation: {
    tokenize: ma
  },
  exit: ya
}, da = {
  tokenize: wa,
  partial: !0
}, ha = {
  tokenize: ga,
  partial: !0
};
function fa(e, n, t) {
  const r = this, i = r.events[r.events.length - 1];
  let l = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return a;
  function a(p) {
    const y = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (y === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : ot(p)) {
      if (r.containerState.type || (r.containerState.type = y, e.enter(y, {
        _container: !0
      })), y === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(Tn, t, c)(p) : c(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(p);
    }
    return t(p);
  }
  function s(p) {
    return ot(p) && ++o < 10 ? (e.consume(p), s) : (!r.interrupt || o < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), c(p)) : t(p);
  }
  function c(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      Dn,
      // Can’t be empty when interrupting.
      r.interrupt ? t : u,
      e.attempt(da, h, d)
    );
  }
  function u(p) {
    return r.containerState.initialBlankLine = !0, l++, h(p);
  }
  function d(p) {
    return K(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), h) : t(p);
  }
  function h(p) {
    return r.containerState.size = l + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(p);
  }
}
function ma(e, n, t) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Dn, i, l);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, re(e, n, "listItemIndent", r.containerState.size + 1)(a);
  }
  function l(a) {
    return r.containerState.furtherBlankLines || !K(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(ha, n, o)(a));
  }
  function o(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, re(e, e.attempt(ge, n, t), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function ga(e, n, t) {
  const r = this;
  return re(e, i, "listItemIndent", r.containerState.size + 1);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? n(l) : t(l);
  }
}
function ya(e) {
  e.exit(this.containerState.type);
}
function wa(e, n, t) {
  const r = this;
  return re(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return !K(l) && o && o[1].type === "listItemPrefixWhitespace" ? n(l) : t(l);
  }
}
const Gt = {
  name: "setextUnderline",
  tokenize: va,
  resolveTo: Ca
};
function Ca(e, n) {
  let t = e.length, r, i, l;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        r = t;
        break;
      }
      e[t][1].type === "paragraph" && (i = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !l && e[t][1].type === "definition" && (l = t);
  const o = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", l ? (e.splice(i, 0, ["enter", o, n]), e.splice(l + 1, 0, ["exit", e[r][1], n]), e[r][1].end = Object.assign({}, e[l][1].end)) : e[r][1] = o, e.push(["exit", o, n]), e;
}
function va(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(c) {
    let u = r.events.length, d;
    for (; u--; )
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        d = r.events[u][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = c, o(c)) : t(c);
  }
  function o(c) {
    return e.enter("setextHeadingLineSequence"), a(c);
  }
  function a(c) {
    return c === i ? (e.consume(c), a) : (e.exit("setextHeadingLineSequence"), K(c) ? re(e, s, "lineSuffix")(c) : s(c));
  }
  function s(c) {
    return c === null || H(c) ? (e.exit("setextHeadingLine"), n(c)) : t(c);
  }
}
const xa = {
  tokenize: ba
};
function ba(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    Dn,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      re(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(So, i)
        ),
        "linePrefix"
      )
    )
  );
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(l), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const _a = {
  resolveAll: ri()
}, ka = ti("string"), Ia = ti("text");
function ti(e) {
  return {
    tokenize: n,
    resolveAll: ri(
      e === "text" ? Ea : void 0
    )
  };
  function n(t) {
    const r = this, i = this.parser.constructs[e], l = t.attempt(i, o, a);
    return o;
    function o(u) {
      return c(u) ? l(u) : a(u);
    }
    function a(u) {
      if (u === null) {
        t.consume(u);
        return;
      }
      return t.enter("data"), t.consume(u), s;
    }
    function s(u) {
      return c(u) ? (t.exit("data"), l(u)) : (t.consume(u), s);
    }
    function c(u) {
      if (u === null)
        return !0;
      const d = i[u];
      let h = -1;
      if (d)
        for (; ++h < d.length; ) {
          const p = d[h];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ri(e) {
  return n;
  function n(t, r) {
    let i = -1, l;
    for (; ++i <= t.length; )
      l === void 0 ? t[i] && t[i][1].type === "data" && (l = i, i++) : (!t[i] || t[i][1].type !== "data") && (i !== l + 2 && (t[l][1].end = t[i - 1][1].end, t.splice(l + 2, i - l - 2), i = l + 2), l = void 0);
    return e ? e(t, r) : t;
  }
}
function Ea(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const r = e[t - 1][1], i = n.sliceStream(r);
      let l = i.length, o = -1, a = 0, s;
      for (; l--; ) {
        const c = i[l];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32; )
            a++, o--;
          if (o) break;
          o = -1;
        } else if (c === -2)
          s = !0, a++;
        else if (c !== -1) {
          l++;
          break;
        }
      }
      if (a) {
        const c = {
          type: t === e.length || s || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a,
            _index: r.start._index + l,
            _bufferIndex: l ? o : r.start._bufferIndex + o
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, c.start), r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(
          t,
          0,
          ["enter", c, n],
          ["exit", c, n]
        ), t += 2);
      }
      t++;
    }
  return e;
}
function Sa(e, n, t) {
  let r = Object.assign(
    t ? Object.assign({}, t) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, l = [];
  let o = [], a = [];
  const s = {
    consume: I,
    enter: C,
    exit: M,
    attempt: S(L),
    check: S(v),
    interrupt: S(v, {
      interrupt: !0
    })
  }, c = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: p,
    sliceSerialize: h,
    now: y,
    defineSkip: x,
    write: d
  };
  let u = n.tokenize.call(c, s);
  return n.resolveAll && l.push(n), c;
  function d(k) {
    return o = Ee(o, k), b(), o[o.length - 1] !== null ? [] : (P(n, 0), c.events = Ct(l, c.events, c), c.events);
  }
  function h(k, A) {
    return La(p(k), A);
  }
  function p(k) {
    return Na(o, k);
  }
  function y() {
    const { line: k, column: A, offset: T, _index: D, _bufferIndex: $ } = r;
    return {
      line: k,
      column: A,
      offset: T,
      _index: D,
      _bufferIndex: $
    };
  }
  function x(k) {
    i[k.line] = k.column, R();
  }
  function b() {
    let k;
    for (; r._index < o.length; ) {
      const A = o[r._index];
      if (typeof A == "string")
        for (k = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === k && r._bufferIndex < A.length; )
          w(A.charCodeAt(r._bufferIndex));
      else
        w(A);
    }
  }
  function w(k) {
    u = u(k);
  }
  function I(k) {
    H(k) ? (r.line++, r.column = 1, r.offset += k === -3 ? 2 : 1, R()) : k !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = k;
  }
  function C(k, A) {
    const T = A || {};
    return T.type = k, T.start = y(), c.events.push(["enter", T, c]), a.push(T), T;
  }
  function M(k) {
    const A = a.pop();
    return A.end = y(), c.events.push(["exit", A, c]), A;
  }
  function L(k, A) {
    P(k, A.from);
  }
  function v(k, A) {
    A.restore();
  }
  function S(k, A) {
    return T;
    function T(D, $, U) {
      let G, ce, fe, g;
      return Array.isArray(D) ? V(D) : "tokenize" in D ? (
        // @ts-expect-error Looks like a construct.
        V([D])
      ) : z(D);
      function z(X) {
        return pe;
        function pe(we) {
          const Re = we !== null && X[we], Ke = we !== null && X.null, _n = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Re) ? Re : Re ? [Re] : [],
            ...Array.isArray(Ke) ? Ke : Ke ? [Ke] : []
          ];
          return V(_n)(we);
        }
      }
      function V(X) {
        return G = X, ce = 0, X.length === 0 ? U : f(X[ce]);
      }
      function f(X) {
        return pe;
        function pe(we) {
          return g = E(), fe = X, X.partial || (c.currentConstruct = X), X.name && c.parser.constructs.disable.null.includes(X.name) ? ee() : X.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            A ? Object.assign(Object.create(c), A) : c,
            s,
            W,
            ee
          )(we);
        }
      }
      function W(X) {
        return k(fe, g), $;
      }
      function ee(X) {
        return g.restore(), ++ce < G.length ? f(G[ce]) : U;
      }
    }
  }
  function P(k, A) {
    k.resolveAll && !l.includes(k) && l.push(k), k.resolve && ze(
      c.events,
      A,
      c.events.length - A,
      k.resolve(c.events.slice(A), c)
    ), k.resolveTo && (c.events = k.resolveTo(c.events, c));
  }
  function E() {
    const k = y(), A = c.previous, T = c.currentConstruct, D = c.events.length, $ = Array.from(a);
    return {
      restore: U,
      from: D
    };
    function U() {
      r = k, c.previous = A, c.currentConstruct = T, c.events.length = D, a = $, R();
    }
  }
  function R() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function Na(e, n) {
  const t = n.start._index, r = n.start._bufferIndex, i = n.end._index, l = n.end._bufferIndex;
  let o;
  if (t === i)
    o = [e[t].slice(r, l)];
  else {
    if (o = e.slice(t, i), r > -1) {
      const a = o[0];
      typeof a == "string" ? o[0] = a.slice(r) : o.shift();
    }
    l > 0 && o.push(e[i].slice(0, l));
  }
  return o;
}
function La(e, n) {
  let t = -1;
  const r = [];
  let i;
  for (; ++t < e.length; ) {
    const l = e[t];
    let o;
    if (typeof l == "string")
      o = l;
    else
      switch (l) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = n ? " " : "	";
          break;
        }
        case -1: {
          if (!n && i) continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(l);
      }
    i = l === -2, r.push(o);
  }
  return r.join("");
}
const Aa = {
  42: ge,
  43: ge,
  45: ge,
  48: ge,
  49: ge,
  50: ge,
  51: ge,
  52: ge,
  53: ge,
  54: ge,
  55: ge,
  56: ge,
  57: ge,
  62: Yr
}, Ta = {
  91: Mo
}, Ma = {
  [-2]: Vn,
  [-1]: Vn,
  32: Vn
}, Pa = {
  35: $o,
  42: Tn,
  45: [Gt, Tn],
  60: Vo,
  61: Gt,
  95: Tn,
  96: Xt,
  126: Xt
}, Fa = {
  38: Xr,
  92: Kr
}, Ra = {
  [-5]: jn,
  [-4]: jn,
  [-3]: jn,
  33: oa,
  38: Xr,
  42: at,
  60: [ao, Yo],
  91: sa,
  92: [Bo, Kr],
  93: vt,
  95: at,
  96: xo
}, Ba = {
  null: [at, _a]
}, Da = {
  null: [42, 95]
}, $a = {
  null: []
}, Oa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Da,
  contentInitial: Ta,
  disable: $a,
  document: Aa,
  flow: Pa,
  flowInitial: Ma,
  insideSpan: Ba,
  string: Fa,
  text: Ra
}, Symbol.toStringTag, { value: "Module" }));
function za(e) {
  const t = (
    /** @type {FullNormalizedExtension} */
    Zl([Oa, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: t,
    content: i(eo),
    document: i(to),
    flow: i(xa),
    string: i(ka),
    text: i(Ia)
  };
  return r;
  function i(l) {
    return o;
    function o(a) {
      return Sa(r, l, a);
    }
  }
}
function Ha(e) {
  for (; !Jr(e); )
    ;
  return e;
}
const er = /[\0\t\n\r]/g;
function Va() {
  let e = 1, n = "", t = !0, r;
  return i;
  function i(l, o, a) {
    const s = [];
    let c, u, d, h, p;
    for (l = n + (typeof l == "string" ? l.toString() : new TextDecoder(o || void 0).decode(l)), d = 0, n = "", t && (l.charCodeAt(0) === 65279 && d++, t = void 0); d < l.length; ) {
      if (er.lastIndex = d, c = er.exec(l), h = c && c.index !== void 0 ? c.index : l.length, p = l.charCodeAt(h), !c) {
        n = l.slice(d);
        break;
      }
      if (p === 10 && d === h && r)
        s.push(-3), r = void 0;
      else
        switch (r && (s.push(-5), r = void 0), d < h && (s.push(l.slice(d, h)), e += h - d), p) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, s.push(-2); e++ < u; ) s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = h + 1;
    }
    return a && (r && s.push(-5), n && s.push(n), s.push(null)), s;
  }
}
const ja = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function qa(e) {
  return e.replace(ja, Wa);
}
function Wa(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const i = t.charCodeAt(1), l = i === 120 || i === 88;
    return Qr(t.slice(l ? 2 : 1), l ? 16 : 10);
  }
  return wt(t) || e;
}
const ii = {}.hasOwnProperty;
function Za(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), Ua(t)(Ha(za(t).document().write(Va()(e, n, !0))));
}
function Ua(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(At),
      autolinkProtocol: E,
      autolinkEmail: E,
      atxHeading: l(St),
      blockQuote: l(Ke),
      characterEscape: E,
      characterReference: E,
      codeFenced: l(_n),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: l(_n, o),
      codeText: l(wi, o),
      codeTextData: E,
      data: E,
      codeFlowValue: E,
      definition: l(Ci),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: l(vi),
      hardBreakEscape: l(Nt),
      hardBreakTrailing: l(Nt),
      htmlFlow: l(Lt, o),
      htmlFlowData: E,
      htmlText: l(Lt, o),
      htmlTextData: E,
      image: l(xi),
      label: o,
      link: l(At),
      listItem: l(bi),
      listItemValue: h,
      listOrdered: l(Tt, d),
      listUnordered: l(Tt),
      paragraph: l(_i),
      reference: f,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: l(St),
      strong: l(ki),
      thematicBreak: l(Ei)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: L,
      autolink: s(),
      autolinkEmail: Re,
      autolinkProtocol: we,
      blockQuote: s(),
      characterEscapeValue: R,
      characterReferenceMarkerHexadecimal: ee,
      characterReferenceMarkerNumeric: ee,
      characterReferenceValue: X,
      characterReference: pe,
      codeFenced: s(b),
      codeFencedFence: x,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: y,
      codeFlowValue: R,
      codeIndented: s(w),
      codeText: s($),
      codeTextData: R,
      data: R,
      definition: s(),
      definitionDestinationString: M,
      definitionLabelString: I,
      definitionTitleString: C,
      emphasis: s(),
      hardBreakEscape: s(A),
      hardBreakTrailing: s(A),
      htmlFlow: s(T),
      htmlFlowData: R,
      htmlText: s(D),
      htmlTextData: R,
      image: s(G),
      label: fe,
      labelText: ce,
      lineEnding: k,
      link: s(U),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: W,
      resourceDestinationString: g,
      resourceTitleString: z,
      resource: V,
      setextHeading: s(P),
      setextHeadingLineSequence: S,
      setextHeadingText: v,
      strong: s(),
      thematicBreak: s()
    }
  };
  li(n, (e || {}).mdastExtensions || []);
  const t = {};
  return r;
  function r(N) {
    let B = {
      type: "root",
      children: []
    };
    const j = {
      stack: [B],
      tokenStack: [],
      config: n,
      enter: a,
      exit: c,
      buffer: o,
      resume: u,
      data: t
    }, Z = [];
    let ne = -1;
    for (; ++ne < N.length; )
      if (N[ne][1].type === "listOrdered" || N[ne][1].type === "listUnordered")
        if (N[ne][0] === "enter")
          Z.push(ne);
        else {
          const Ne = Z.pop();
          ne = i(N, Ne, ne);
        }
    for (ne = -1; ++ne < N.length; ) {
      const Ne = n[N[ne][0]];
      ii.call(Ne, N[ne][1].type) && Ne[N[ne][1].type].call(Object.assign({
        sliceSerialize: N[ne][2].sliceSerialize
      }, j), N[ne][1]);
    }
    if (j.tokenStack.length > 0) {
      const Ne = j.tokenStack[j.tokenStack.length - 1];
      (Ne[1] || nr).call(j, void 0, Ne[0]);
    }
    for (B.position = {
      start: He(N.length > 0 ? N[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: He(N.length > 0 ? N[N.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, ne = -1; ++ne < n.transforms.length; )
      B = n.transforms[ne](B) || B;
    return B;
  }
  function i(N, B, j) {
    let Z = B - 1, ne = -1, Ne = !1, We, Be, sn, cn;
    for (; ++Z <= j; ) {
      const Ce = N[Z];
      switch (Ce[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Ce[0] === "enter" ? ne++ : ne--, cn = void 0;
          break;
        }
        case "lineEndingBlank": {
          Ce[0] === "enter" && (We && !cn && !ne && !sn && (sn = Z), cn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          cn = void 0;
      }
      if (!ne && Ce[0] === "enter" && Ce[1].type === "listItemPrefix" || ne === -1 && Ce[0] === "exit" && (Ce[1].type === "listUnordered" || Ce[1].type === "listOrdered")) {
        if (We) {
          let Xe = Z;
          for (Be = void 0; Xe--; ) {
            const De = N[Xe];
            if (De[1].type === "lineEnding" || De[1].type === "lineEndingBlank") {
              if (De[0] === "exit") continue;
              Be && (N[Be][1].type = "lineEndingBlank", Ne = !0), De[1].type = "lineEnding", Be = Xe;
            } else if (!(De[1].type === "linePrefix" || De[1].type === "blockQuotePrefix" || De[1].type === "blockQuotePrefixWhitespace" || De[1].type === "blockQuoteMarker" || De[1].type === "listItemIndent")) break;
          }
          sn && (!Be || sn < Be) && (We._spread = !0), We.end = Object.assign({}, Be ? N[Be][1].start : Ce[1].end), N.splice(Be || Z, 0, ["exit", We, Ce[2]]), Z++, j++;
        }
        if (Ce[1].type === "listItemPrefix") {
          const Xe = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Ce[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          We = Xe, N.splice(Z, 0, ["enter", Xe, Ce[2]]), Z++, j++, sn = void 0, cn = !0;
        }
      }
    }
    return N[B][1]._spread = Ne, j;
  }
  function l(N, B) {
    return j;
    function j(Z) {
      a.call(this, N(Z), Z), B && B.call(this, Z);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(N, B, j) {
    this.stack[this.stack.length - 1].children.push(N), this.stack.push(N), this.tokenStack.push([B, j]), N.position = {
      start: He(B.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(N) {
    return B;
    function B(j) {
      N && N.call(this, j), c.call(this, j);
    }
  }
  function c(N, B) {
    const j = this.stack.pop(), Z = this.tokenStack.pop();
    if (Z)
      Z[0].type !== N.type && (B ? B.call(this, N, Z[0]) : (Z[1] || nr).call(this, N, Z[0]));
    else throw new Error("Cannot close `" + N.type + "` (" + mn({
      start: N.start,
      end: N.end
    }) + "): it’s not open");
    j.position.end = He(N.end);
  }
  function u() {
    return ql(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(N) {
    if (this.data.expectingFirstListItemValue) {
      const B = this.stack[this.stack.length - 2];
      B.start = Number.parseInt(this.sliceSerialize(N), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.lang = N;
  }
  function y() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.meta = N;
  }
  function x() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function b() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = N.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = N.replace(/(\r?\n|\r)$/g, "");
  }
  function I(N) {
    const B = this.resume(), j = this.stack[this.stack.length - 1];
    j.label = B, j.identifier = rn(this.sliceSerialize(N)).toLowerCase();
  }
  function C() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = N;
  }
  function M() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = N;
  }
  function L(N) {
    const B = this.stack[this.stack.length - 1];
    if (!B.depth) {
      const j = this.sliceSerialize(N).length;
      B.depth = j;
    }
  }
  function v() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function S(N) {
    const B = this.stack[this.stack.length - 1];
    B.depth = this.sliceSerialize(N).codePointAt(0) === 61 ? 1 : 2;
  }
  function P() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function E(N) {
    const j = this.stack[this.stack.length - 1].children;
    let Z = j[j.length - 1];
    (!Z || Z.type !== "text") && (Z = Ii(), Z.position = {
      start: He(N.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, j.push(Z)), this.stack.push(Z);
  }
  function R(N) {
    const B = this.stack.pop();
    B.value += this.sliceSerialize(N), B.position.end = He(N.end);
  }
  function k(N) {
    const B = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const j = B.children[B.children.length - 1];
      j.position.end = He(N.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(B.type) && (E.call(this, N), R.call(this, N));
  }
  function A() {
    this.data.atHardBreak = !0;
  }
  function T() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = N;
  }
  function D() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = N;
  }
  function $() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = N;
  }
  function U() {
    const N = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      N.type += "Reference", N.referenceType = B, delete N.url, delete N.title;
    } else
      delete N.identifier, delete N.label;
    this.data.referenceType = void 0;
  }
  function G() {
    const N = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      N.type += "Reference", N.referenceType = B, delete N.url, delete N.title;
    } else
      delete N.identifier, delete N.label;
    this.data.referenceType = void 0;
  }
  function ce(N) {
    const B = this.sliceSerialize(N), j = this.stack[this.stack.length - 2];
    j.label = qa(B), j.identifier = rn(B).toLowerCase();
  }
  function fe() {
    const N = this.stack[this.stack.length - 1], B = this.resume(), j = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, j.type === "link") {
      const Z = N.children;
      j.children = Z;
    } else
      j.alt = B;
  }
  function g() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = N;
  }
  function z() {
    const N = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = N;
  }
  function V() {
    this.data.inReference = void 0;
  }
  function f() {
    this.data.referenceType = "collapsed";
  }
  function W(N) {
    const B = this.resume(), j = this.stack[this.stack.length - 1];
    j.label = B, j.identifier = rn(this.sliceSerialize(N)).toLowerCase(), this.data.referenceType = "full";
  }
  function ee(N) {
    this.data.characterReferenceType = N.type;
  }
  function X(N) {
    const B = this.sliceSerialize(N), j = this.data.characterReferenceType;
    let Z;
    j ? (Z = Qr(B, j === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Z = wt(B);
    const ne = this.stack[this.stack.length - 1];
    ne.value += Z;
  }
  function pe(N) {
    const B = this.stack.pop();
    B.position.end = He(N.end);
  }
  function we(N) {
    R.call(this, N);
    const B = this.stack[this.stack.length - 1];
    B.url = this.sliceSerialize(N);
  }
  function Re(N) {
    R.call(this, N);
    const B = this.stack[this.stack.length - 1];
    B.url = "mailto:" + this.sliceSerialize(N);
  }
  function Ke() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function _n() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function wi() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ci() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function vi() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function St() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Nt() {
    return {
      type: "break"
    };
  }
  function Lt() {
    return {
      type: "html",
      value: ""
    };
  }
  function xi() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function At() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Tt(N) {
    return {
      type: "list",
      ordered: N.type === "listOrdered",
      start: null,
      spread: N._spread,
      children: []
    };
  }
  function bi(N) {
    return {
      type: "listItem",
      spread: N._spread,
      checked: null,
      children: []
    };
  }
  function _i() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function ki() {
    return {
      type: "strong",
      children: []
    };
  }
  function Ii() {
    return {
      type: "text",
      value: ""
    };
  }
  function Ei() {
    return {
      type: "thematicBreak"
    };
  }
}
function He(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function li(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const r = n[t];
    Array.isArray(r) ? li(e, r) : Qa(e, r);
  }
}
function Qa(e, n) {
  let t;
  for (t in n)
    if (ii.call(n, t))
      switch (t) {
        case "canContainEols": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "transforms": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = n[t];
          r && Object.assign(e[t], r);
          break;
        }
      }
}
function nr(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + mn({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + mn({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + mn({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function Ya(e) {
  const n = this;
  n.parser = t;
  function t(r) {
    return Za(r, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function Ka(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Xa(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function Ja(e, n) {
  const t = n.value ? n.value + `
` : "", r = {};
  n.lang && (r.className = ["language-" + n.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (i.data = { meta: n.meta }), e.patch(n, i), i = e.applyData(n, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(n, i), i;
}
function Ga(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function es(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function ns(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(n.identifier).toUpperCase(), i = an(r.toLowerCase()), l = e.footnoteOrder.indexOf(r);
  let o, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = l + 1, a += 1, e.footnoteCounts.set(r, a);
  const s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + i,
      id: t + "fnref-" + i + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(n, s);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(n, c), e.applyData(n, c);
}
function ts(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function rs(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function oi(e, n) {
  const t = n.referenceType;
  let r = "]";
  if (t === "collapsed" ? r += "[]" : t === "full" && (r += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + r }];
  const i = e.all(n), l = i[0];
  l && l.type === "text" ? l.value = "[" + l.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function is(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return oi(e, n);
  const i = { src: an(r.url || ""), alt: n.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(n, l), e.applyData(n, l);
}
function ls(e, n) {
  const t = { src: an(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, r), e.applyData(n, r);
}
function os(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, r), e.applyData(n, r);
}
function as(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return oi(e, n);
  const i = { href: an(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(n)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function ss(e, n) {
  const t = { href: an(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function cs(e, n, t) {
  const r = e.all(n), i = t ? us(t) : ai(n), l = {}, o = [];
  if (typeof n.checked == "boolean") {
    const u = r[0];
    let d;
    u && u.type === "element" && u.tagName === "p" ? d = u : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), l.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const u = r[a];
    (i || a !== 0 || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !i ? o.push(...u.children) : o.push(u);
  }
  const s = r[r.length - 1];
  s && (i || s.type !== "element" || s.tagName !== "p") && o.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: l, children: o };
  return e.patch(n, c), e.applyData(n, c);
}
function us(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let r = -1;
    for (; !n && ++r < t.length; )
      n = ai(t[r]);
  }
  return n;
}
function ai(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function ps(e, n) {
  const t = {}, r = e.all(n);
  let i = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const l = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(r, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function ds(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function hs(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function fs(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function ms(e, n) {
  const t = e.all(n), r = t.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(n.children[0], o), i.push(o);
  }
  if (t.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, a = ft(n.children[1]), s = Hr(n.children[n.children.length - 1]);
    a && s && (o.position = { start: a, end: s }), i.push(o);
  }
  const l = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function gs(e, n, t) {
  const r = t ? t.children : void 0, l = (r ? r.indexOf(n) : 1) === 0 ? "th" : "td", o = t && t.type === "table" ? t.align : void 0, a = o ? o.length : n.children.length;
  let s = -1;
  const c = [];
  for (; ++s < a; ) {
    const d = n.children[s], h = {}, p = o ? o[s] : void 0;
    p && (h.align = p);
    let y = { type: "element", tagName: l, properties: h, children: [] };
    d && (y.children = e.all(d), e.patch(d, y), y = e.applyData(d, y)), c.push(y);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function ys(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const tr = 9, rr = 32;
function ws(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let r = t.exec(n), i = 0;
  const l = [];
  for (; r; )
    l.push(
      ir(n.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = t.exec(n);
  return l.push(ir(n.slice(i), i > 0, !1)), l.join("");
}
function ir(e, n, t) {
  let r = 0, i = e.length;
  if (n) {
    let l = e.codePointAt(r);
    for (; l === tr || l === rr; )
      r++, l = e.codePointAt(r);
  }
  if (t) {
    let l = e.codePointAt(i - 1);
    for (; l === tr || l === rr; )
      i--, l = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function Cs(e, n) {
  const t = { type: "text", value: ws(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function vs(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const xs = {
  blockquote: Ka,
  break: Xa,
  code: Ja,
  delete: Ga,
  emphasis: es,
  footnoteReference: ns,
  heading: ts,
  html: rs,
  imageReference: is,
  image: ls,
  inlineCode: os,
  linkReference: as,
  link: ss,
  listItem: cs,
  list: ps,
  paragraph: ds,
  // @ts-expect-error: root is different, but hard to type.
  root: hs,
  strong: fs,
  table: ms,
  tableCell: ys,
  tableRow: gs,
  text: Cs,
  thematicBreak: vs,
  toml: In,
  yaml: In,
  definition: In,
  footnoteDefinition: In
};
function In() {
}
const si = -1, $n = 0, Pn = 1, Fn = 2, xt = 3, bt = 4, _t = 5, kt = 6, ci = 7, ui = 8, lr = typeof self == "object" ? self : globalThis, bs = (e, n) => {
  const t = (i, l) => (e.set(l, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [l, o] = n[i];
    switch (l) {
      case $n:
      case si:
        return t(o, i);
      case Pn: {
        const a = t([], i);
        for (const s of o)
          a.push(r(s));
        return a;
      }
      case Fn: {
        const a = t({}, i);
        for (const [s, c] of o)
          a[r(s)] = r(c);
        return a;
      }
      case xt:
        return t(new Date(o), i);
      case bt: {
        const { source: a, flags: s } = o;
        return t(new RegExp(a, s), i);
      }
      case _t: {
        const a = t(/* @__PURE__ */ new Map(), i);
        for (const [s, c] of o)
          a.set(r(s), r(c));
        return a;
      }
      case kt: {
        const a = t(/* @__PURE__ */ new Set(), i);
        for (const s of o)
          a.add(r(s));
        return a;
      }
      case ci: {
        const { name: a, message: s } = o;
        return t(new lr[a](s), i);
      }
      case ui:
        return t(BigInt(o), i);
      case "BigInt":
        return t(Object(BigInt(o)), i);
    }
    return t(new lr[l](o), i);
  };
  return r;
}, or = (e) => bs(/* @__PURE__ */ new Map(), e)(0), Je = "", { toString: _s } = {}, { keys: ks } = Object, pn = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [$n, n];
  const t = _s.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [Pn, Je];
    case "Object":
      return [Fn, Je];
    case "Date":
      return [xt, Je];
    case "RegExp":
      return [bt, Je];
    case "Map":
      return [_t, Je];
    case "Set":
      return [kt, Je];
  }
  return t.includes("Array") ? [Pn, t] : t.includes("Error") ? [ci, t] : [Fn, t];
}, En = ([e, n]) => e === $n && (n === "function" || n === "symbol"), Is = (e, n, t, r) => {
  const i = (o, a) => {
    const s = r.push(o) - 1;
    return t.set(a, s), s;
  }, l = (o) => {
    if (t.has(o))
      return t.get(o);
    let [a, s] = pn(o);
    switch (a) {
      case $n: {
        let u = o;
        switch (s) {
          case "bigint":
            a = ui, u = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + s);
            u = null;
            break;
          case "undefined":
            return i([si], o);
        }
        return i([a, u], o);
      }
      case Pn: {
        if (s)
          return i([s, [...o]], o);
        const u = [], d = i([a, u], o);
        for (const h of o)
          u.push(l(h));
        return d;
      }
      case Fn: {
        if (s)
          switch (s) {
            case "BigInt":
              return i([s, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([s, o.valueOf()], o);
          }
        if (n && "toJSON" in o)
          return l(o.toJSON());
        const u = [], d = i([a, u], o);
        for (const h of ks(o))
          (e || !En(pn(o[h]))) && u.push([l(h), l(o[h])]);
        return d;
      }
      case xt:
        return i([a, o.toISOString()], o);
      case bt: {
        const { source: u, flags: d } = o;
        return i([a, { source: u, flags: d }], o);
      }
      case _t: {
        const u = [], d = i([a, u], o);
        for (const [h, p] of o)
          (e || !(En(pn(h)) || En(pn(p)))) && u.push([l(h), l(p)]);
        return d;
      }
      case kt: {
        const u = [], d = i([a, u], o);
        for (const h of o)
          (e || !En(pn(h))) && u.push(l(h));
        return d;
      }
    }
    const { message: c } = o;
    return i([a, { name: s, message: c }], o);
  };
  return l;
}, ar = (e, { json: n, lossy: t } = {}) => {
  const r = [];
  return Is(!(n || t), !!n, /* @__PURE__ */ new Map(), r)(e), r;
}, Rn = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? or(ar(e, n)) : structuredClone(e)
) : (e, n) => or(ar(e, n));
function Es(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function Ss(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function Ns(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || Es, r = e.options.footnoteBackLabel || Ss, i = e.options.footnoteLabel || "Footnotes", l = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let s = -1;
  for (; ++s < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[s]
    );
    if (!c)
      continue;
    const u = e.all(c), d = String(c.identifier).toUpperCase(), h = an(d.toLowerCase());
    let p = 0;
    const y = [], x = e.footnoteCounts.get(d);
    for (; x !== void 0 && ++p <= x; ) {
      y.length > 0 && y.push({ type: "text", value: " " });
      let I = typeof t == "string" ? t : t(s, p);
      typeof I == "string" && (I = { type: "text", value: I }), y.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(s, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(I) ? I : [I]
      });
    }
    const b = u[u.length - 1];
    if (b && b.type === "element" && b.tagName === "p") {
      const I = b.children[b.children.length - 1];
      I && I.type === "text" ? I.value += " " : b.children.push({ type: "text", value: " " }), b.children.push(...y);
    } else
      u.push(...y);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(c, w), a.push(w);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: l,
          properties: {
            ...Rn(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const pi = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return Ms;
    if (typeof e == "function")
      return On(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Ls(e) : As(e);
    if (typeof e == "string")
      return Ts(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Ls(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = pi(e[t]);
  return On(r);
  function r(...i) {
    let l = -1;
    for (; ++l < n.length; )
      if (n[l].apply(this, i)) return !0;
    return !1;
  }
}
function As(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return On(t);
  function t(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let l;
    for (l in e)
      if (i[l] !== n[l]) return !1;
    return !0;
  }
}
function Ts(e) {
  return On(n);
  function n(t) {
    return t && t.type === e;
  }
}
function On(e) {
  return n;
  function n(t, r, i) {
    return !!(Ps(t) && e.call(
      this,
      t,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function Ms() {
  return !0;
}
function Ps(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const di = [], Fs = !0, sr = !1, Rs = "skip";
function Bs(e, n, t, r) {
  let i;
  typeof n == "function" && typeof t != "function" ? (r = t, t = n) : i = n;
  const l = pi(i), o = r ? -1 : 1;
  a(e, void 0, [])();
  function a(s, c, u) {
    const d = (
      /** @type {Record<string, unknown>} */
      s && typeof s == "object" ? s : {}
    );
    if (typeof d.type == "string") {
      const p = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (s.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let p = di, y, x, b;
      if ((!n || l(s, c, u[u.length - 1] || void 0)) && (p = Ds(t(s, u)), p[0] === sr))
        return p;
      if ("children" in s && s.children) {
        const w = (
          /** @type {UnistParent} */
          s
        );
        if (w.children && p[0] !== Rs)
          for (x = (r ? w.children.length : -1) + o, b = u.concat(w); x > -1 && x < w.children.length; ) {
            const I = w.children[x];
            if (y = a(I, x, b)(), y[0] === sr)
              return y;
            x = typeof y[1] == "number" ? y[1] : x + o;
          }
      }
      return p;
    }
  }
}
function Ds(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Fs, e] : e == null ? di : [e];
}
function hi(e, n, t, r) {
  let i, l, o;
  typeof n == "function" && typeof t != "function" ? (l = void 0, o = n, i = t) : (l = n, o = t, i = r), Bs(e, l, a, i);
  function a(s, c) {
    const u = c[c.length - 1], d = u ? u.children.indexOf(s) : void 0;
    return o(s, d, u);
  }
}
const st = {}.hasOwnProperty, $s = {};
function Os(e, n) {
  const t = n || $s, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), o = { ...xs, ...t.handlers }, a = {
    all: c,
    applyData: Hs,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: l,
    footnoteOrder: [],
    handlers: o,
    one: s,
    options: t,
    patch: zs,
    wrap: js
  };
  return hi(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const d = u.type === "definition" ? r : i, h = String(u.identifier).toUpperCase();
      d.has(h) || d.set(h, u);
    }
  }), a;
  function s(u, d) {
    const h = u.type, p = a.handlers[h];
    if (st.call(a.handlers, h) && p)
      return p(a, u, d);
    if (a.options.passThrough && a.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: x, ...b } = u, w = Rn(b);
        return w.children = a.all(u), w;
      }
      return Rn(u);
    }
    return (a.options.unknownHandler || Vs)(a, u, d);
  }
  function c(u) {
    const d = [];
    if ("children" in u) {
      const h = u.children;
      let p = -1;
      for (; ++p < h.length; ) {
        const y = a.one(h[p], u);
        if (y) {
          if (p && h[p - 1].type === "break" && (!Array.isArray(y) && y.type === "text" && (y.value = cr(y.value)), !Array.isArray(y) && y.type === "element")) {
            const x = y.children[0];
            x && x.type === "text" && (x.value = cr(x.value));
          }
          Array.isArray(y) ? d.push(...y) : d.push(y);
        }
      }
    }
    return d;
  }
}
function zs(e, n) {
  e.position && (n.position = vl(e));
}
function Hs(e, n) {
  let t = n;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, l = e.data.hProperties;
    if (typeof r == "string")
      if (t.type === "element")
        t.tagName = r;
      else {
        const o = "children" in t ? t.children : [t];
        t = { type: "element", tagName: r, properties: {}, children: o };
      }
    t.type === "element" && l && Object.assign(t.properties, Rn(l)), "children" in t && t.children && i !== null && i !== void 0 && (t.children = i);
  }
  return t;
}
function Vs(e, n) {
  const t = n.data || {}, r = "value" in n && !(st.call(t, "hProperties") || st.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function js(e, n) {
  const t = [];
  let r = -1;
  for (n && t.push({ type: "text", value: `
` }); ++r < e.length; )
    r && t.push({ type: "text", value: `
` }), t.push(e[r]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function cr(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function ur(e, n) {
  const t = Os(e, n), r = t.one(e, void 0), i = Ns(t), l = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && l.children.push({ type: "text", value: `
` }, i), l;
}
function qs(e, n) {
  return e && "run" in e ? async function(t, r) {
    const i = (
      /** @type {HastRoot} */
      ur(t, { file: r, ...n })
    );
    await e.run(i, r);
  } : function(t, r) {
    return (
      /** @type {HastRoot} */
      ur(t, { file: r, ...n || e })
    );
  };
}
function pr(e) {
  if (e)
    throw e;
}
var Mn = Object.prototype.hasOwnProperty, fi = Object.prototype.toString, dr = Object.defineProperty, hr = Object.getOwnPropertyDescriptor, fr = function(n) {
  return typeof Array.isArray == "function" ? Array.isArray(n) : fi.call(n) === "[object Array]";
}, mr = function(n) {
  if (!n || fi.call(n) !== "[object Object]")
    return !1;
  var t = Mn.call(n, "constructor"), r = n.constructor && n.constructor.prototype && Mn.call(n.constructor.prototype, "isPrototypeOf");
  if (n.constructor && !t && !r)
    return !1;
  var i;
  for (i in n)
    ;
  return typeof i > "u" || Mn.call(n, i);
}, gr = function(n, t) {
  dr && t.name === "__proto__" ? dr(n, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : n[t.name] = t.newValue;
}, yr = function(n, t) {
  if (t === "__proto__")
    if (Mn.call(n, t)) {
      if (hr)
        return hr(n, t).value;
    } else return;
  return n[t];
}, Ws = function e() {
  var n, t, r, i, l, o, a = arguments[0], s = 1, c = arguments.length, u = !1;
  for (typeof a == "boolean" && (u = a, a = arguments[1] || {}, s = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); s < c; ++s)
    if (n = arguments[s], n != null)
      for (t in n)
        r = yr(a, t), i = yr(n, t), a !== i && (u && i && (mr(i) || (l = fr(i))) ? (l ? (l = !1, o = r && fr(r) ? r : []) : o = r && mr(r) ? r : {}, gr(a, { name: t, newValue: e(u, o, i) })) : typeof i < "u" && gr(a, { name: t, newValue: i }));
  return a;
};
const qn = /* @__PURE__ */ il(Ws);
function ct(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Zs() {
  const e = [], n = { run: t, use: r };
  return n;
  function t(...i) {
    let l = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    a(null, ...i);
    function a(s, ...c) {
      const u = e[++l];
      let d = -1;
      if (s) {
        o(s);
        return;
      }
      for (; ++d < i.length; )
        (c[d] === null || c[d] === void 0) && (c[d] = i[d]);
      i = c, u ? Us(u, a)(...c) : o(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), n;
  }
}
function Us(e, n) {
  let t;
  return r;
  function r(...o) {
    const a = e.length > o.length;
    let s;
    a && o.push(i);
    try {
      s = e.apply(this, o);
    } catch (c) {
      const u = (
        /** @type {Error} */
        c
      );
      if (a && t)
        throw u;
      return i(u);
    }
    a || (s && s.then && typeof s.then == "function" ? s.then(l, i) : s instanceof Error ? i(s) : l(s));
  }
  function i(o, ...a) {
    t || (t = !0, n(o, ...a));
  }
  function l(o) {
    i(null, o);
  }
}
const Pe = { basename: Qs, dirname: Ys, extname: Ks, join: Xs, sep: "/" };
function Qs(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  bn(e);
  let t = 0, r = -1, i = e.length, l;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (l) {
          t = i + 1;
          break;
        }
      } else r < 0 && (l = !0, r = i + 1);
    return r < 0 ? "" : e.slice(t, r);
  }
  if (n === e)
    return "";
  let o = -1, a = n.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (l) {
        t = i + 1;
        break;
      }
    } else
      o < 0 && (l = !0, o = i + 1), a > -1 && (e.codePointAt(i) === n.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = o));
  return t === r ? r = o : r < 0 && (r = e.length), e.slice(t, r);
}
function Ys(e) {
  if (bn(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, r;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (r) {
        n = t;
        break;
      }
    } else r || (r = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function Ks(e) {
  bn(e);
  let n = e.length, t = -1, r = 0, i = -1, l = 0, o;
  for (; n--; ) {
    const a = e.codePointAt(n);
    if (a === 47) {
      if (o) {
        r = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (o = !0, t = n + 1), a === 46 ? i < 0 ? i = n : l !== 1 && (l = 1) : i > -1 && (l = -1);
  }
  return i < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  l === 0 || // The (right-most) trimmed path component is exactly `..`.
  l === 1 && i === t - 1 && i === r + 1 ? "" : e.slice(i, t);
}
function Xs(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    bn(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : Js(t);
}
function Js(e) {
  bn(e);
  const n = e.codePointAt(0) === 47;
  let t = Gs(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function Gs(e, n) {
  let t = "", r = 0, i = -1, l = 0, o = -1, a, s;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      a = e.codePointAt(o);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(i === o - 1 || l === 1)) if (i !== o - 1 && l === 2) {
        if (t.length < 2 || r !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (s = t.lastIndexOf("/"), s !== t.length - 1) {
              s < 0 ? (t = "", r = 0) : (t = t.slice(0, s), r = t.length - 1 - t.lastIndexOf("/")), i = o, l = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", r = 0, i = o, l = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", r = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(i + 1, o) : t = e.slice(i + 1, o), r = o - i - 1;
      i = o, l = 0;
    } else a === 46 && l > -1 ? l++ : l = -1;
  }
  return t;
}
function bn(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const ec = { cwd: nc };
function nc() {
  return "/";
}
function ut(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function tc(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!ut(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return rc(e);
}
function rc(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const r = n.codePointAt(t + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(n);
}
const Wn = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class mi {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? ut(n) ? t = { path: n } : typeof n == "string" || ic(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : ec.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < Wn.length; ) {
      const l = Wn[r];
      l in t && t[l] !== void 0 && t[l] !== null && (this[l] = l === "history" ? [...t[l]] : t[l]);
    }
    let i;
    for (i in t)
      Wn.includes(i) || (this[i] = t[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Pe.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Un(n, "basename"), Zn(n, "basename"), this.path = Pe.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Pe.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    wr(this.basename, "dirname"), this.path = Pe.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Pe.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Zn(n, "extname"), wr(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Pe.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    ut(n) && (n = tc(n)), Un(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Pe.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Un(n, "stem"), Zn(n, "stem"), this.path = Pe.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, r) {
    const i = this.message(n, t, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, r) {
    const i = this.message(n, t, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, r) {
    const i = new de(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Zn(e, n) {
  if (e && e.includes(Pe.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Pe.sep + "`"
    );
}
function Un(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function wr(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function ic(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const lc = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], l = function() {
      return i.apply(l, arguments);
    };
    return Object.setPrototypeOf(l, r), l;
  }
), oc = {}.hasOwnProperty;
class It extends lc {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Zs();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new It()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const r = this.attachers[t];
      n.use(...r);
    }
    return n.data(qn(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (Kn("data", this.frozen), this.namespace[n] = t, this) : oc.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Kn("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = t.call(n, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = Sn(n), r = this.parser || this.Parser;
    return Qn("parse", r), r(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const r = this;
    return this.freeze(), Qn("process", this.parser || this.Parser), Yn("process", this.compiler || this.Compiler), t ? i(void 0, t) : new Promise(i);
    function i(l, o) {
      const a = Sn(n), s = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(s, a, function(u, d, h) {
        if (u || !d || !h)
          return c(u);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), y = r.stringify(p, h);
        cc(y) ? h.value = y : h.result = y, c(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function c(u, d) {
        u || !d ? o(u) : l ? l(d) : t(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, r;
    return this.freeze(), Qn("processSync", this.parser || this.Parser), Yn("processSync", this.compiler || this.Compiler), this.process(n, i), vr("processSync", "process", t), r;
    function i(l, o) {
      t = !0, pr(l), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, r) {
    Cr(n), this.freeze();
    const i = this.transformers;
    return !r && typeof t == "function" && (r = t, t = void 0), r ? l(void 0, r) : new Promise(l);
    function l(o, a) {
      const s = Sn(t);
      i.run(n, s, c);
      function c(u, d, h) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || n
        );
        u ? a(u) : o ? o(p) : r(void 0, p, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let r = !1, i;
    return this.run(n, t, l), vr("runSync", "run", r), i;
    function l(o, a) {
      pr(o), i = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const r = Sn(t), i = this.compiler || this.Compiler;
    return Yn("stringify", i), Cr(n), i(n, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const r = this.attachers, i = this.namespace;
    if (Kn("use", this.frozen), n != null) if (typeof n == "function")
      s(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? a(n) : o(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function l(c) {
      if (typeof c == "function")
        s(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [u, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          s(u, d);
        } else
          o(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(c.plugins), c.settings && (i.settings = qn(!0, i.settings, c.settings));
    }
    function a(c) {
      let u = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++u < c.length; ) {
          const d = c[u];
          l(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function s(c, u) {
      let d = -1, h = -1;
      for (; ++d < r.length; )
        if (r[d][0] === c) {
          h = d;
          break;
        }
      if (h === -1)
        r.push([c, ...u]);
      else if (u.length > 0) {
        let [p, ...y] = u;
        const x = r[h][1];
        ct(x) && ct(p) && (p = qn(!0, x, p)), r[h] = [c, p, ...y];
      }
    }
  }
}
const ac = new It().freeze();
function Qn(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Yn(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Kn(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Cr(e) {
  if (!ct(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function vr(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Sn(e) {
  return sc(e) ? e : new mi(e);
}
function sc(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function cc(e) {
  return typeof e == "string" || uc(e);
}
function uc(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const pc = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", xr = [], br = { allowDangerousHtml: !0 }, dc = /^(https?|ircs?|mailto|xmpp)$/i, hc = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Cn(e) {
  const n = e.allowedElements, t = e.allowElement, r = e.children || "", i = e.className, l = e.components, o = e.disallowedElements, a = e.rehypePlugins || xr, s = e.remarkPlugins || xr, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...br } : br, u = e.skipHtml, d = e.unwrapDisallowed, h = e.urlTransform || fc, p = ac().use(Ya).use(s).use(qs, c).use(a), y = new mi();
  typeof r == "string" && (y.value = r);
  for (const I of hc)
    Object.hasOwn(e, I.from) && ("" + I.from + (I.to ? "use `" + I.to + "` instead" : "remove it") + pc + I.id, void 0);
  const x = p.parse(y);
  let b = p.runSync(x, y);
  return i && (b = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      b.type === "root" ? b.children : [b]
    )
  }), hi(b, w), El(b, {
    Fragment: Oe,
    components: l,
    ignoreInvalidStyle: !0,
    jsx: m,
    jsxs: O,
    passKeys: !0,
    passNode: !0
  });
  function w(I, C, M) {
    if (I.type === "raw" && M && typeof C == "number")
      return u ? M.children.splice(C, 1) : M.children[C] = { type: "text", value: I.value }, C;
    if (I.type === "element") {
      let L;
      for (L in Hn)
        if (Object.hasOwn(Hn, L) && Object.hasOwn(I.properties, L)) {
          const v = I.properties[L], S = Hn[L];
          (S === null || S.includes(I.tagName)) && (I.properties[L] = h(String(v || ""), L, I));
        }
    }
    if (I.type === "element") {
      let L = n ? !n.includes(I.tagName) : o ? o.includes(I.tagName) : !1;
      if (!L && t && typeof C == "number" && (L = !t(I, C, M)), L && M && typeof C == "number")
        return d && I.children ? M.children.splice(C, 1, ...I.children) : M.children.splice(C, 1), C;
    }
  }
}
function fc(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && n > i || t > -1 && n > t || r > -1 && n > r || // It is a protocol, it should be allowed.
    dc.test(e.slice(0, n)) ? e : ""
  );
}
const mc = (e) => {
  const { message: n, className: t, children: r, ...i } = e;
  let l = n ? /* @__PURE__ */ m(Cn, { rehypePlugins: [yn], children: n }) : r;
  return !n && r && typeof r == "string" && (l = /* @__PURE__ */ m(Cn, { rehypePlugins: [yn], children: r })), /* @__PURE__ */ m("div", { className: `${Oi.message} ${t ?? ""}`, ...i, children: l });
}, gc = "_message_1h1j1_76", yc = {
  message: gc
}, wc = (e) => {
  const { message: n, className: t, children: r, ...i } = e;
  let l = n ? /* @__PURE__ */ m(Cn, { rehypePlugins: [yn], children: n }) : r;
  return !n && r && typeof r == "string" && (l = /* @__PURE__ */ m(Cn, { rehypePlugins: [yn], children: r })), /* @__PURE__ */ m("div", { className: `${yc.message} ${t ?? ""}`, ...i, children: l });
}, Cc = "_questions_1aht7_76", vc = "_question_1aht7_76", Xn = {
  questions: Cc,
  question: vc
}, Pd = (e) => {
  const { questions: n } = e;
  return /* @__PURE__ */ O("div", { className: Xn.questions, children: [
    n.map((t) => /* @__PURE__ */ m("div", { className: Xn.question, children: t.question }, t.id)),
    /* @__PURE__ */ m("div", { className: Xn.addQuestion, onClick: e.onAddQuestion, children: "Add your own question" })
  ] });
}, xc = "_chatInputContainer_vijay_76", bc = "_chatInput_vijay_76", _c = "_disabled_vijay_96", kc = "_inputs_vijay_100", Ic = "_message_vijay_111", Ec = "_files_vijay_134", Sc = "_fileInput_vijay_143", Nc = "_attachButton_vijay_146", Lc = "_sendButton_vijay_178", $e = {
  chatInputContainer: xc,
  chatInput: bc,
  disabled: _c,
  inputs: kc,
  message: Ic,
  files: Ec,
  fileInput: Sc,
  attachButton: Nc,
  sendButton: Lc
}, Ac = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M3.35355 8.35356C3.26306 8.44404 3.13807 8.5 3 8.5C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.85955 2.55791 7.73263 2.65115 7.64181L7.64181 2.65115C7.73263 2.55791 7.85955 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73264 13.5 7.85956 13.5 8C13.5 8.27614 13.2761 8.5 13 8.5C12.8619 8.5 12.7369 8.44404 12.6465 8.35356L8.5 4.20717L8.5 13C8.5 13.2761 8.27614 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13L7.5 4.20717L3.35355 8.35356Z", fill: "#0E5FE3" })), Tc = (e) => /* @__PURE__ */ _.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.42829 3.57115C7.42829 3.33446 7.23641 3.14258 6.99972 3.14258C6.76303 3.14258 6.57115 3.33446 6.57115 3.57115V6.57115H3.57115C3.33446 6.57115 3.14258 6.76303 3.14258 6.99972C3.14258 7.23642 3.33446 7.42829 3.57115 7.42829H6.57115V10.4283C6.57115 10.665 6.76303 10.8569 6.99972 10.8569C7.23642 10.8569 7.42829 10.665 7.42829 10.4283V7.42829H10.4283C10.665 7.42829 10.8569 7.23641 10.8569 6.99972C10.8569 6.76303 10.665 6.57115 10.4283 6.57115H7.42829V3.57115Z", fill: "#999999" })), Mc = "_chips_1n5z2_95", Pc = "_fileChip_1n5z2_101", Fc = "_uploaded_1n5z2_124", Rc = "_fileName_1n5z2_127", Bc = "_crossCircleIcon_1n5z2_130", Dc = "_folderIconContainer_1n5z2_133", $c = "_folderIcon_1n5z2_133", Oc = "_loading_1n5z2_182", zc = "_loadingIcon_1n5z2_195", Hc = "_rotateSpinner_1n5z2_1", Vc = "_dash_1n5z2_1", Ve = {
  chips: Mc,
  fileChip: Pc,
  uploaded: Fc,
  fileName: Rc,
  crossCircleIcon: Bc,
  folderIconContainer: Dc,
  folderIcon: $c,
  loading: Oc,
  loadingIcon: zc,
  rotateSpinner: Hc,
  dash: Vc
}, jc = (e) => /* @__PURE__ */ _.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "#666666", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/file-generic" }, /* @__PURE__ */ _.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M11.8438 4.12926L11.8921 4.17752C12.0528 4.33827 12.1431 4.55628 12.1431 4.78361V12.1429C12.1431 12.6162 11.7594 13 11.286 13H2.71456C2.24118 13 1.85742 12.6162 1.85742 12.1429V1.85714C1.85742 1.38376 2.24118 1 2.71456 1H8.35952C8.58685 1 8.80487 1.09031 8.96562 1.25105L9.01381 1.29924C9.01508 1.30049 9.01635 1.30174 9.01761 1.303L11.8401 4.12548C11.8413 4.12674 11.8426 4.128 11.8438 4.12926ZM11.286 12.1429H2.71456L2.71456 1.85714H8.28599V4.42853C8.28599 4.66522 8.47787 4.8571 8.71457 4.8571H11.286V12.1429Z" }))), qc = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#CCCCCC", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M8.78038 16.2803C8.64465 16.416 8.45713 16.5 8.25 16.5C7.83579 16.5 7.5 16.1642 7.5 15.75C7.5 15.5412 7.58535 15.3523 7.72308 15.2163L10.9394 12L7.72672 8.78729C7.58686 8.65105 7.5 8.46067 7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.45711 7.5 8.64462 7.58395 8.78034 7.71968L12.0001 10.9393L15.2163 7.72308C15.3523 7.58535 15.5412 7.5 15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.45708 16.4161 8.64456 16.2804 8.78028L13.0607 12L16.2804 15.2196C16.4161 15.3554 16.5 15.5429 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.5393 16.5 15.349 16.4131 15.2127 16.2733L12.0001 13.0606L8.78038 16.2803Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25Z" })), Wc = (e) => /* @__PURE__ */ _.createElement("svg", { className: "spinner", viewBox: "0 0 50 50", fill: "none", ...e }, /* @__PURE__ */ _.createElement("circle", { className: "path", cx: 25, cy: 25, r: 20, strokeWidth: 5 })), Zc = (e) => {
  const { filename: n, disabled: t, removeFile: r } = e;
  return /* @__PURE__ */ O(
    "button",
    {
      className: `${Ve.fileChip} ${t === !1 ? Ve.uploaded : ""}`,
      onClick: r,
      disabled: t,
      children: [
        /* @__PURE__ */ m("div", { className: Ve.folderIconContainer, children: /* @__PURE__ */ m(jc, { className: Ve.folderIcon }) }),
        /* @__PURE__ */ m("div", { className: Ve.fileName, children: n }),
        /* @__PURE__ */ m(qc, { className: Ve.crossCircleIcon }),
        t && /* @__PURE__ */ m("div", { className: Ve.loading, children: /* @__PURE__ */ m(Wc, { className: Ve.loadingIcon }) })
      ]
    }
  );
}, _r = (e) => {
  const n = e.name.replace(/([^a-zA-Z0-9-_. ])/g, "_");
  return new File([e], n, { type: e.type });
}, Uc = ie((e, n) => {
  const { onSendMessage: t, className: r, inputsClassName: i, disabled: l } = e, { t: o } = Te(), a = ue(null), [s, c] = _.useState(""), u = ue(null), [d, h] = _.useState([]), p = ue(null), y = _.useRef(null), x = (S = void 0) => {
    S == null || S.preventDefault(), S == null || S.stopPropagation(), l || (t({ text: s, files: d }), c(""), h([]));
  }, b = (S) => {
    S.key === "Enter" && !S.shiftKey && (S.preventDefault(), x());
  };
  le(() => {
    w();
  }, [s]);
  const w = () => {
    const S = y.current;
    S && (S.style.height = "auto", S.style.height = `${S.scrollHeight}px`), S && p.current && (S.style.height = "auto", S.style.height = `${S.scrollHeight}px`);
  }, I = (S) => {
    S.preventDefault(), u.current && u.current.click();
  }, C = Y(
    (S) => {
      var E;
      const P = (E = S.clipboardData) == null ? void 0 : E.items;
      if (P) {
        const R = [];
        for (let k = 0; k < P.length; k++)
          if (P[k].kind === "file") {
            const A = P[k].getAsFile();
            A && R.push(A);
          }
        R.length && (h([...d, ...R]), S.preventDefault());
      }
    },
    [d, h]
  ), M = Y(
    (S) => {
      if (u.current) {
        const P = S.map(_r);
        h([...d, ...P]);
      }
    },
    [d]
  );
  Bn(
    n,
    () => ({
      ...a.current,
      // Spread the HTMLDivElement properties
      inputContainerRef: a,
      addFiles: M,
      setMessage: c
    })
  );
  const L = Y(
    (S) => {
      const P = [...d];
      P.splice(S, 1), h(P);
    },
    [d, h]
  );
  le(() => {
    var S;
    l ? (c(""), h([])) : (S = y.current) == null || S.focus({
      preventScroll: !0
    });
  }, [l]);
  const v = Y((S) => {
    const P = Array.from(S.target.files ?? []).map(_r);
    h((E) => [...E, ...P]);
  }, []);
  return /* @__PURE__ */ m("div", { className: `${$e.chatInputContainer} ${r ?? ""}`, children: /* @__PURE__ */ O(
    "div",
    {
      className: `${$e.chatInput} ${l ? $e.disabled : ""}`,
      id: "chat-input",
      ref: a,
      children: [
        /* @__PURE__ */ m(
          "input",
          {
            ref: u,
            type: "file",
            className: $e.fileInput,
            multiple: !0,
            onChange: v,
            disabled: l
          }
        ),
        /* @__PURE__ */ m("button", { className: $e.attachButton, onClick: I, children: /* @__PURE__ */ m(Tc, {}) }),
        /* @__PURE__ */ O(
          "div",
          {
            ref: p,
            className: `${$e.inputs} ${i ?? ""}`,
            children: [
              /* @__PURE__ */ m(
                "textarea",
                {
                  ref: y,
                  className: $e.message,
                  value: s,
                  onChange: (S) => c(S.target.value),
                  onKeyDown: b,
                  rows: 1,
                  placeholder: o("chat.input-placeholder"),
                  autoFocus: !0,
                  onPaste: C,
                  disabled: l
                }
              ),
              d && (d == null ? void 0 : d.length) > 0 ? /* @__PURE__ */ m("div", { className: $e.files, children: d.map((S, P) => /* @__PURE__ */ m(
                Zc,
                {
                  filename: S.name,
                  removeFile: () => L(P)
                },
                S.name
              )) }) : null
            ]
          }
        ),
        /* @__PURE__ */ m("button", { className: $e.sendButton, onClick: x, children: /* @__PURE__ */ m(Ac, {}) })
      ]
    }
  ) });
}), Qc = "_chat_1jt8x_76", Yc = "_messages_1jt8x_85", Kc = "_messageWithAction_1jt8x_111", Xc = "_message_1jt8x_85", Jc = "_input_1jt8x_123", Gc = "_messageWrapper_1jt8x_127", eu = "_timestamp_1jt8x_132", nu = "_right_1jt8x_150", tu = "_show_1jt8x_155", Ie = {
  chat: Qc,
  messages: Yc,
  messageWithAction: Kc,
  message: Xc,
  input: Jc,
  messageWrapper: Gc,
  timestamp: eu,
  right: nu,
  show: tu
}, ru = (e, n) => {
  const t = n || vn().language || navigator.language, r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: r
  }).format(e);
}, Fd = (e, n) => {
  const t = n || vn().language || navigator.language, r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: r
  }).format(e);
}, Rd = (e, n) => {
  const t = n || vn().language || navigator.language, r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: r
  }).format(e);
}, Bd = (e, n) => {
  const t = n || vn().language || navigator.language, r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: r
  }).format(e);
}, iu = (e, n) => {
  const t = n || vn().language || navigator.language;
  return new Intl.DateTimeFormat(t, {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: !0
  }).format(e);
}, Dd = ie(
  (e, n) => {
    const {
      onSendMessage: t,
      messages: r,
      isLoading: i,
      children: l,
      inputClassName: o,
      withHover: a,
      ...s
    } = e, c = ue(null), { stayScrolled: u } = Li(c), d = ue(null), h = ue(null);
    return Si(() => {
      u();
    }, [r, u]), Bn(n, () => ({
      inputRef: d ?? null,
      chatRef: h
    })), /* @__PURE__ */ O(
      "div",
      {
        ...s,
        className: `${Ie.chat} ${e.className || ""}`,
        ref: h,
        children: [
          /* @__PURE__ */ O("div", { ref: c, className: Ie.messages, children: [
            l,
            r.map((p, y) => /* @__PURE__ */ m(
              lu,
              {
                message: p,
                hoverDelay: 200,
                withHover: a
              },
              y
            )),
            i && /* @__PURE__ */ m("div", { className: `${Ie.message} ${Ie.lawyer}`, children: "typing.." })
          ] }),
          /* @__PURE__ */ m(
            Uc,
            {
              onSendMessage: t,
              ref: d,
              className: `${Ie.input} ${o}`
            }
          )
        ]
      }
    );
  }
), lu = (e) => {
  const { message: n, withHover: t } = e, r = e.hoverDelay ?? 200, [i, l] = J(!1), o = n.from === "lawyer" ? wc : mc, a = ue(null), s = Y(() => {
    a.current && (clearTimeout(a.current), a.current = null), l(!0);
  }, []), c = Y(() => {
    a.current = setTimeout(() => {
      l(!1);
    }, r);
  }, [r]);
  return /* @__PURE__ */ O("div", { className: Ie.messageWrapper, children: [
    /* @__PURE__ */ m(
      o,
      {
        message: typeof n.content == "string" ? n.content : "",
        timestamp: n.createdAt,
        className: Ie.message,
        onMouseEnter: s,
        onMouseLeave: c
      }
    ),
    t && /* @__PURE__ */ m(
      "div",
      {
        className: `${Ie.timestamp}
          ${i ? Ie.show : Ie.hide}
          ${n.from === "lawyer" ? Ie.left : Ie.right}`,
        children: iu(n.createdAt ?? Date.now())
      }
    )
  ] });
}, ou = "_yesNoInput_1kvr6_76", au = "_actionButton_1kvr6_83", su = "_dot_1kvr6_100", cu = "_disabled_1kvr6_106", uu = "_active_1kvr6_110", je = {
  yesNoInput: ou,
  actionButton: au,
  dot: su,
  disabled: cu,
  active: uu
}, pu = ie(
  (e, n) => {
    var s;
    const {
      value: t,
      disabled: r,
      onChange: i,
      language: l
    } = e, { t: o } = Te(void 0, { lng: l }), a = Y((c) => (u) => {
      u.preventDefault(), r || i(c);
    }, [r, i]);
    return /* @__PURE__ */ O(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${je.yesNoInput} ${r ? je.disabled : ""} ${(s = e.props) == null ? void 0 : s.className}`,
        children: [
          /* @__PURE__ */ O(
            "button",
            {
              className: `${je.actionButton} ${(t == null ? void 0 : t.toLocaleLowerCase()) === "yes" ? je.active : ""}`,
              onClick: a("yes"),
              disabled: r,
              children: [
                /* @__PURE__ */ m("div", { className: je.dot }),
                o("confirm.yes")
              ]
            }
          ),
          /* @__PURE__ */ O(
            "button",
            {
              className: `${je.actionButton} ${(t == null ? void 0 : t.toLocaleLowerCase()) === "no" ? je.active : ""}`,
              onClick: a("no"),
              disabled: r,
              children: [
                /* @__PURE__ */ m("div", { className: je.dot }),
                o("confirm.no")
              ]
            }
          )
        ]
      }
    );
  }
), du = "_progressBar_igb8q_76", hu = "_cover_igb8q_85", kr = {
  progressBar: du,
  cover: hu
}, fu = ie((e, n) => {
  const {
    value: t,
    ...r
    // this must be last and is the div props
  } = e;
  return /* @__PURE__ */ m("div", { ref: n, ...r, className: `${kr.progressBar} ${r.className}`, children: /* @__PURE__ */ m("div", { className: kr.cover, style: { width: `${100 - t}%` } }) });
}), mu = "_textInput_19ofa_76", gu = {
  textInput: mu
}, $d = ie((e, n) => {
  var i;
  const { value: t, onChange: r } = e;
  return /* @__PURE__ */ m(
    "input",
    {
      ref: n,
      ...e.props,
      className: `${gu.textInput} ${((i = e.props) == null ? void 0 : i.className) || ""}`,
      type: "text",
      value: t || "",
      onChange: (l) => r(l.target.value)
    }
  );
}), yu = "_radioInputLabel_1we1s_76", wu = "_radioInput_1we1s_76", Ir = {
  radioInputLabel: yu,
  radioInput: wu
}, Cu = ie((e, n) => {
  var c;
  const { checked: t = !1, value: r, name: i, label: l, disabled: o, onChange: a } = e, s = Y((u) => {
    o || a(u.target.checked ? u.target.value : "");
  }, [o, a]);
  return /* @__PURE__ */ O("label", { className: Ir.radioInputLabel, htmlFor: `${i}-${r}`, children: [
    /* @__PURE__ */ m(
      "input",
      {
        id: `${i}-${r}`,
        ref: n,
        ...e.props,
        className: `${Ir.radioInput} ${((c = e.props) == null ? void 0 : c.className) || ""}`,
        type: "radio",
        name: i,
        value: r,
        checked: t,
        onChange: s,
        disabled: o
      }
    ),
    l
  ] });
}), vu = "_checkboxInputLabel_1umgz_76", xu = "_checkboxInput_1umgz_76", Er = {
  checkboxInputLabel: vu,
  checkboxInput: xu
}, bu = ie((e, n) => {
  var s;
  const { checked: t = !1, value: r, label: i, disabled: l, onChange: o } = e, a = Y((c) => {
    l || o(c.target.value, c.target.checked);
  }, [l, o]);
  return /* @__PURE__ */ O("label", { className: Er.checkboxInputLabel, htmlFor: `checkbox-${r}`, children: [
    /* @__PURE__ */ m(
      "input",
      {
        id: `checkbox-${r}`,
        ref: n,
        ...e.props,
        className: `${Er.checkboxInput} ${((s = e.props) == null ? void 0 : s.className) || ""}`,
        type: "checkbox",
        value: r,
        checked: t,
        onChange: a,
        disabled: l
      }
    ),
    i
  ] });
}), _u = "_dateInputWrapper_11ugy_76", ku = "_dateInput_11ugy_76", Iu = "_calendarIcon_11ugy_111", Jn = {
  dateInputWrapper: _u,
  dateInput: ku,
  calendarIcon: Iu
}, Eu = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/calendar" }, /* @__PURE__ */ _.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M5.49631 3.5H7.49631V3C7.49631 2.72386 7.72016 2.5 7.99631 2.5C8.27245 2.5 8.49631 2.72386 8.49631 3V3.5H10.4963V3C10.4963 2.72386 10.7202 2.5 10.9963 2.5C11.2724 2.5 11.4963 2.72386 11.4963 3V3.5H13.4963C14.0486 3.5 14.4963 3.94772 14.4963 4.5V13.5C14.4963 14.0523 14.0486 14.5 13.4963 14.5H2.49631C1.94402 14.5 1.49631 14.0523 1.49631 13.5V4.5C1.49631 3.94772 1.94402 3.5 2.49631 3.5H4.49631V3C4.49631 2.72386 4.72016 2.5 4.99631 2.5C5.27245 2.5 5.49631 2.72386 5.49631 3V3.5ZM10.4963 5C10.4963 5.27614 10.7202 5.5 10.9963 5.5C11.2724 5.5 11.4963 5.27614 11.4963 5V4.5H13.4963V6.5H2.49631V4.5H4.49631V5C4.49631 5.27614 4.72017 5.5 4.99631 5.5C5.27245 5.5 5.49631 5.27614 5.49631 5V4.5H7.49631V5C7.49631 5.27614 7.72017 5.5 7.99631 5.5C8.27245 5.5 8.49631 5.27614 8.49631 5V4.5H10.4963V5ZM2.49631 13.5L2.49631 7.5H13.4963V13.5H2.49631Z", fill: "#666666" }))), Su = ie((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, l = Y((a) => {
    r || i(new Date(a.target.value).getTime());
  }, [r, i]);
  return /* @__PURE__ */ O("div", { className: Jn.dateInputWrapper, children: [
    /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${Jn.dateInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "date",
        value: t && !isNaN(t) ? new Date(t).toISOString().split("T")[0] : "",
        onChange: l,
        disabled: r
      }
    ),
    /* @__PURE__ */ m("div", { className: Jn.calendarIcon, children: /* @__PURE__ */ m(Eu, {}) })
  ] });
}), Nu = "_dateTimeInputWrapper_14lt0_76", Lu = "_dateTimeInput_14lt0_76", Au = "_calendarIcon_14lt0_110", Gn = {
  dateTimeInputWrapper: Nu,
  dateTimeInput: Lu,
  calendarIcon: Au
}, Tu = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/calendar" }, /* @__PURE__ */ _.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M5.49631 3.5H7.49631V3C7.49631 2.72386 7.72016 2.5 7.99631 2.5C8.27245 2.5 8.49631 2.72386 8.49631 3V3.5H10.4963V3C10.4963 2.72386 10.7202 2.5 10.9963 2.5C11.2724 2.5 11.4963 2.72386 11.4963 3V3.5H13.4963C14.0486 3.5 14.4963 3.94772 14.4963 4.5V13.5C14.4963 14.0523 14.0486 14.5 13.4963 14.5H2.49631C1.94402 14.5 1.49631 14.0523 1.49631 13.5V4.5C1.49631 3.94772 1.94402 3.5 2.49631 3.5H4.49631V3C4.49631 2.72386 4.72016 2.5 4.99631 2.5C5.27245 2.5 5.49631 2.72386 5.49631 3V3.5ZM10.4963 5C10.4963 5.27614 10.7202 5.5 10.9963 5.5C11.2724 5.5 11.4963 5.27614 11.4963 5V4.5H13.4963V6.5H2.49631V4.5H4.49631V5C4.49631 5.27614 4.72017 5.5 4.99631 5.5C5.27245 5.5 5.49631 5.27614 5.49631 5V4.5H7.49631V5C7.49631 5.27614 7.72017 5.5 7.99631 5.5C8.27245 5.5 8.49631 5.27614 8.49631 5V4.5H10.4963V5ZM2.49631 13.5L2.49631 7.5H13.4963V13.5H2.49631Z", fill: "#666666" }))), Mu = ie((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, l = Y((a) => {
    r || i(a.target.value);
  }, [r, i]);
  return /* @__PURE__ */ O("div", { className: Gn.dateTimeInputWrapper, children: [
    /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${Gn.dateTimeInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "datetime-local",
        value: t ? new Date(t).toISOString().slice(0, 16) : "",
        onChange: l,
        disabled: r
      }
    ),
    /* @__PURE__ */ m("div", { className: Gn.calendarIcon, children: /* @__PURE__ */ m(Tu, {}) })
  ] });
}), Pu = "_timeInputWrapper_1y16t_76", Fu = "_timeInput_1y16t_76", Ru = "_clockIcon_1y16t_110", et = {
  timeInputWrapper: Pu,
  timeInput: Fu,
  clockIcon: Ru
}, Bu = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/clock" }, /* @__PURE__ */ _.createElement("g", { id: "Union" }, /* @__PURE__ */ _.createElement("path", { d: "M10.5 10.5C10.5 10.7761 10.2761 11 10 11C9.85956 11 9.73264 10.9421 9.64182 10.8489L7.65114 8.85819C7.55791 8.76737 7.5 8.64045 7.5 8.5V5.5C7.5 5.22386 7.72386 5 8 5C8.27614 5 8.5 5.22386 8.5 5.5V8.29283L10.3536 10.1464C10.4441 10.2369 10.5 10.3619 10.5 10.5Z", fill: "#666666" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.5899 15 14.5 12.0899 14.5 8.5C14.5 4.91015 11.5899 2 8 2C4.41015 2 1.5 4.91015 1.5 8.5C1.5 12.0899 4.41015 15 8 15ZM8 14C11.0376 14 13.5 11.5376 13.5 8.5C13.5 5.46243 11.0376 3 8 3C4.96243 3 2.5 5.46243 2.5 8.5C2.5 11.5376 4.96243 14 8 14Z", fill: "#666666" })))), Du = ie((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, l = Y((a) => {
    r || i(a.target.value);
  }, [r, i]);
  return /* @__PURE__ */ O("div", { className: et.timeInputWrapper, children: [
    /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${et.timeInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "time",
        value: t,
        onChange: l,
        disabled: r
      }
    ),
    /* @__PURE__ */ m("div", { className: et.clockIcon, children: /* @__PURE__ */ m(Bu, {}) })
  ] });
}), $u = "_inputLabel_6zi10_76", Ou = "_desktop_6zi10_92", zu = "_mobile_6zi10_96", Hu = "_textWithEmail_6zi10_133", dn = {
  inputLabel: $u,
  desktop: Ou,
  mobile: zu,
  textWithEmail: Hu
}, Vu = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3V2C12 1.44772 11.5523 1 11 1H3C2.44772 1 2 1.44772 2 2V12C2 12.5523 2.44772 13 3 13H4V14C4 14.5523 4.44772 15 5 15H13C13.5523 15 14 14.5523 14 14V4C14 3.44772 13.5523 3 13 3H12ZM11 2H3V12H4V4C4 3.44772 4.44772 3 5 3H11V2ZM5 4V14H13V4H5Z", fill: "#666666" })), ju = ie(
  (e, n) => {
    var s;
    const { text: t, language: r } = e, { t: i } = Te(void 0, { lng: r }), [l, o] = J(null);
    le(() => {
      if (typeof t == "string") {
        const c = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, u = t.match(c);
        u && o(u[0]);
      }
    }, [t]);
    const a = Y((c) => {
      l && (c.preventDefault(), Ai(l), Ti.success(i("chat.copied-link")));
    }, [l, i]);
    return le(() => {
      var c;
      return (c = document.getElementById("email-files")) == null || c.addEventListener("click", a), () => {
        var u;
        (u = document.getElementById("email-files")) == null || u.removeEventListener("click", a);
      };
    }, [a, l]), /* @__PURE__ */ m(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${dn.inputLabel} ${((s = e.props) == null ? void 0 : s.className) || ""}`,
        children: typeof t == "string" && l ? /* @__PURE__ */ O(Oe, { children: [
          /* @__PURE__ */ m("div", { className: dn.mobile, children: /* @__PURE__ */ m("div", { className: dn.mobileFileLabel, dangerouslySetInnerHTML: { __html: i("chat.questionnaire-upload-mobile") } }) }),
          /* @__PURE__ */ O("div", { className: dn.desktop, children: [
            i("chat.questionnaire-upload-desktop"),
            /* @__PURE__ */ m("div", { style: { display: "inline-block" }, children: /* @__PURE__ */ O("div", { className: dn.textWithEmail, onClick: a, children: [
              /* @__PURE__ */ O("div", { children: [
                /* @__PURE__ */ m("span", { children: l }),
                "."
              ] }),
              /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(Vu, {}) })
            ] }) })
          ] })
        ] }) : t
      }
    );
  }
), qu = "_inputDescription_ofy9q_76", Wu = {
  inputDescription: qu
}, Nn = ie((e, n) => {
  var r;
  const { text: t } = e;
  return /* @__PURE__ */ m("div", { ref: n, ...e.props, className: `${Wu.inputDescription} ${((r = e.props) == null ? void 0 : r.className) || ""}`, children: t });
}), Zu = "_fileInput_4saxo_84", Uu = "_fileInputLabel_4saxo_95", Qu = "_dragging_4saxo_120", Yu = "_fileList_4saxo_126", Ku = "_fileChips_4saxo_144", Xu = "_fileChip_4saxo_144", Ju = "_uploaded_4saxo_166", Gu = "_uploading_4saxo_170", e1 = "_active_4saxo_185", n1 = "_rotate_4saxo_1", t1 = "_fileIcon_4saxo_191", r1 = "_fileRemoveIcon_4saxo_203", Le = {
  fileInput: Zu,
  fileInputLabel: Uu,
  dragging: Qu,
  fileList: Yu,
  fileChips: Ku,
  fileChip: Xu,
  uploaded: Ju,
  uploading: Gu,
  active: e1,
  rotate: n1,
  fileIcon: t1,
  fileRemoveIcon: r1
}, i1 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { width: 32, height: 32, rx: 16, fill: "#EEEEEE" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.458 12.1724L22.5224 12.2367C22.7367 12.451 22.8571 12.7417 22.8571 13.0448V22.8571C22.8571 23.4883 22.3454 24 21.7143 24H10.2857C9.6545 24 9.14282 23.4883 9.14282 22.8571V9.14286C9.14282 8.51168 9.6545 8 10.2857 8H17.8123C18.1154 8 18.4061 8.12041 18.6204 8.33474L18.6847 8.39899C18.6864 8.40065 18.6881 8.40232 18.6897 8.404L22.453 12.1673C22.4547 12.169 22.4564 12.1707 22.458 12.1724ZM21.7143 22.8571H10.2857L10.2857 9.14286H17.7143V12.5714C17.7143 12.887 17.9701 13.1428 18.2857 13.1428H21.7143V22.8571Z", fill: "#666666" })), l1 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#CCCCCC", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M8.78038 16.2803C8.64465 16.416 8.45713 16.5 8.25 16.5C7.83579 16.5 7.5 16.1642 7.5 15.75C7.5 15.5412 7.58535 15.3523 7.72308 15.2163L10.9394 12L7.72672 8.78729C7.58686 8.65105 7.5 8.46067 7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.45711 7.5 8.64462 7.58395 8.78034 7.71968L12.0001 10.9393L15.2163 7.72308C15.3523 7.58535 15.5412 7.5 15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.45708 16.4161 8.64456 16.2804 8.78028L13.0607 12L16.2804 15.2196C16.4161 15.3554 16.5 15.5429 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.5393 16.5 15.349 16.4131 15.2127 16.2733L12.0001 13.0606L8.78038 16.2803Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25Z" })), o1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGYSURBVHgB1VRLUsJAFJwEizVHiCdQb8ANgBNgNlCs0BOIJ1BXFGSReILoCeQG6gmMN4jbfO2mJhT5SUiykK6CN4HJ6zc9/Z4Qpw7l0AbTNHue510rinKBRy2O49fpdPooKuKs7I/lcql1Op07JuczEjsgccSRKDyBYRj9KIpsrhGfEKzZbOaIGsgRrFarIYKNaj/CMBzVTVxIQFlUVX3jutvtXum67oqGSN0BNYfWGmQ5byM5sTuBrP4L0liTyUQXLUHdW/f5Bd3vRYvYEUCeAYLb9FJLCYAenSMaYr1ez+HEmyKCtjBEoYMcAdzzTQeJhkCOS7jwJ0cAUB4Ns0cTNUEnIvTgxpccARrLYkxmTx2wjxjhxE2OQDbWMz5zWclR4DuQh1M3NbdSlwztFrISm2NaVAT3yhHjZPsoRUBmkIx4UZDqvcpJuMf3fSbn3ttsHxWOazlRH/gSj8yqsi/SDEEQjFHQ1vMsDHs22VzKX5Xh2Assx/InN2lEaWdtm6CkgIME+0QIfZANkCy5Fwckn3ReW1P3/+IX0T/GHCkkTN4AAAAASUVORK5CYII=", a1 = ie(
  (e, n) => {
    var b;
    const { value: t = [], onChange: r, disabled: i, language: l } = e, { t: o } = Te(void 0, { lng: l }), a = ue(null), [s, c] = J(!1), u = Y(() => {
      i || c(!0);
    }, [i]), d = Y(() => {
      i || c(!1);
    }, [i]), h = (w) => {
      w.target.files && !i && r([...t || [], ...Array.from(w.target.files)]);
    }, p = (w) => {
      w.preventDefault(), w.dataTransfer.files && !i && r([...t || [], ...Array.from(w.dataTransfer.files)]), c(!1);
    }, y = (w) => {
      var I;
      w.preventDefault(), i || (I = a.current) == null || I.click();
    }, x = (w) => {
      i || r((t || []).filter((I, C) => C !== w));
    };
    return le(() => {
      var w;
      return (w = document.getElementById("browse-file")) == null || w.addEventListener("click", y), () => {
        var I;
        (I = document.getElementById("browse-file")) == null || I.removeEventListener("click", y);
      };
    }, []), Bn(n, () => ({
      click: y
    })), /* @__PURE__ */ O(
      "div",
      {
        ...e.props,
        className: `${Le.fileInput} ${s ? Le.dragging : ""} ${((b = e.props) == null ? void 0 : b.className) || ""}`,
        onDrop: p,
        onDragOver: (w) => w.preventDefault(),
        onDragEnter: u,
        onDragLeave: d,
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              className: Le.fileInputLabel,
              dangerouslySetInnerHTML: { __html: o("chat.browse-or-drop") }
            }
          ),
          /* @__PURE__ */ m("input", { ref: a, type: "file", onChange: h }),
          t.length > 0 ? /* @__PURE__ */ m("div", { className: Le.fileList, children: /* @__PURE__ */ m("div", { className: Le.fileChips, children: t.map((w, I) => /* @__PURE__ */ O(
            "div",
            {
              className: `${Le.fileChip} ${!(w instanceof File) && w.id ? Le.uploaded : ""}`,
              children: [
                /* @__PURE__ */ m("div", { className: `${Le.uploading} ${w.uploading ? Le.active : ""}`, children: /* @__PURE__ */ m("img", { src: o1, alt: "loading" }) }),
                /* @__PURE__ */ m("div", { className: Le.fileIcon, children: /* @__PURE__ */ m(i1, {}) }),
                w.name || "file",
                "id" in w && !w.attachedToMessage || !("id" in w) ? /* @__PURE__ */ m(
                  "div",
                  {
                    className: Le.fileRemoveIcon,
                    onClick: () => x(I),
                    title: "Remove file",
                    children: /* @__PURE__ */ m(l1, {})
                  }
                ) : null
              ]
            },
            I
          )) }) }) : null
        ]
      }
    );
  }
), s1 = "_numericInput_7mmzb_76", c1 = {
  numericInput: s1
}, u1 = ie(
  (e, n) => {
    var o;
    const { value: t, disabled: r, onChange: i } = e, l = Y((a) => {
      a.preventDefault(), a.stopPropagation(), r || i(a.target.value);
    }, [r, i]);
    return /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${c1.numericInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "number",
        value: t,
        onChange: l
      }
    );
  }
), p1 = "_inputSeparator_1f8xb_76", d1 = {
  inputSeparator: p1
}, gi = ie((e, n) => {
  var t;
  return /* @__PURE__ */ m("div", { ref: n, ...e.props, className: `${d1.inputSeparator} ${(t = e.props) == null ? void 0 : t.className}` });
}), h1 = "_questionWrapper_1q0qs_76", f1 = "_multiPartQuestion_1q0qs_87", m1 = "_childQuestionWrapper_1q0qs_93", hn = {
  questionWrapper: h1,
  multiPartQuestion: f1,
  childQuestionWrapper: m1
}, g1 = "_tabList_1eqw8_1", y1 = "_tabItems_1eqw8_7", w1 = "_tabItem_1eqw8_7", C1 = "_reverse_1eqw8_31", v1 = "_active_1eqw8_40", x1 = "_tabAdd_1eqw8_44", b1 = "_tab_1eqw8_1", _1 = "_tabRemove_1eqw8_90", ve = {
  tabList: g1,
  tabItems: y1,
  tabItem: w1,
  reverse: C1,
  active: v1,
  tabAdd: x1,
  tab: b1,
  tabRemove: _1
}, Sr = (e) => /* @__PURE__ */ _.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, stroke: "#0E5FE3" }), /* @__PURE__ */ _.createElement("path", { d: "M9.5 5C9.5 4.72386 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.72386 8.5 5V8.5H5C4.72386 8.5 4.5 8.72386 4.5 9C4.5 9.27614 4.72386 9.5 5 9.5H8.5V13C8.5 13.2761 8.72386 13.5 9 13.5C9.27614 13.5 9.5 13.2761 9.5 13V9.5H13C13.2761 9.5 13.5 9.27614 13.5 9C13.5 8.72386 13.2761 8.5 13 8.5H9.5V5Z", fill: "#0E5FE3" })), k1 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, stroke: "#BB1600" }), /* @__PURE__ */ _.createElement("path", { d: "M12.75 4.875C12.9571 4.875 13.125 5.04289 13.125 5.25C13.125 5.35354 13.083 5.44728 13.0152 5.51514L9.53036 8.99998L13.0152 12.4848C13.0831 12.5527 13.125 12.6464 13.125 12.75C13.125 12.9571 12.9571 13.125 12.75 13.125C12.6447 13.125 12.5495 13.0816 12.4814 13.0117L9.00003 9.53031L5.51519 13.0151C5.44733 13.083 5.35356 13.125 5.25 13.125C5.04289 13.125 4.875 12.9571 4.875 12.75C4.875 12.6456 4.91768 12.5511 4.98654 12.4831L8.4697 8.99998L4.98835 5.51864C4.91843 5.45052 4.875 5.35533 4.875 5.25C4.875 5.04289 5.04289 4.875 5.25 4.875C5.35356 4.875 5.44731 4.91698 5.51517 4.98484L9.00003 8.46965L12.4831 4.98654C12.5511 4.91768 12.6456 4.875 12.75 4.875Z", fill: "#BB1600" })), I1 = (e) => {
  var p, y, x;
  const { questions: n, question: t, onChange: r, disabled: i = !1, language: l } = e, { t: o } = Te(), [a, s] = J(0), c = (b) => (w) => {
    w.preventDefault(), s(b);
  }, u = (b) => {
    b.stopPropagation(), b.preventDefault();
    const w = {
      ...t,
      answer: [
        ...t.answer || [],
        t.questions
      ]
    };
    r(w), s(w.answer && w.answer.length > 0 ? w.answer.length - 1 : 0);
  }, d = (b) => (w) => {
    var C;
    w.stopPropagation(), w.preventDefault();
    const I = {
      ...t,
      answer: (C = t.answer) == null ? void 0 : C.filter(
        (M, L) => L !== b
      )
    };
    r(I), s(b - 1 > 0 ? b - 1 : 0);
  }, h = (b) => (w) => {
    const I = { ...t };
    I.answer && I.answer[b] && (I.answer[b] = I.answer[b].map((C) => C.id === w.id ? w : C)), r(I);
  };
  return le(() => {
    t.answer || u(new MouseEvent("click"));
  }, []), /* @__PURE__ */ O("div", { className: ve.tabList, children: [
    /* @__PURE__ */ O("div", { className: ve.tabItems, children: [
      (p = t.answer) == null ? void 0 : p.map((b, w) => {
        var C;
        const I = (C = b.find((M) => M.id === t.label)) == null ? void 0 : C.answer;
        return /* @__PURE__ */ m(
          "button",
          {
            onClick: c(w),
            className: `${ve.tabItem} ${w === a ? ve.active : ""}`,
            children: t.label && I && typeof I != "object" ? I || o("prematter.new") : `#${w + 1}`
          },
          w
        );
      }),
      /* @__PURE__ */ O("button", { onClick: u, className: ve.tabAdd, disabled: i, children: [
        /* @__PURE__ */ m(Sr, {}),
        " ",
        o("prematter.add")
      ] })
    ] }),
    (y = t.answer) == null ? void 0 : y.map((b, w) => /* @__PURE__ */ O(
      "div",
      {
        className: `${ve.tab} ${w === a ? ve.active : ""}`,
        children: [
          b.map((I, C) => /* @__PURE__ */ m(
            ln,
            {
              questions: n,
              question: I,
              onChange: h(w),
              disabled: i,
              language: l
            },
            C
          )),
          /* @__PURE__ */ m(gi, {}),
          /* @__PURE__ */ O("button", { onClick: d(w), className: ve.tabRemove, children: [
            /* @__PURE__ */ m(k1, {}),
            " ",
            o("prematter.remove")
          ] })
        ]
      },
      w
    )),
    /* @__PURE__ */ O("div", { className: ve.tabItems, children: [
      (x = t.answer) == null ? void 0 : x.map((b, w) => {
        var C;
        const I = (C = b.find((M) => M.id === t.label)) == null ? void 0 : C.answer;
        return /* @__PURE__ */ m(
          "button",
          {
            onClick: c(w),
            className: `${ve.tabItem} ${ve.reverse} ${w === a ? ve.active : ""}`,
            children: typeof I != "object" && I || o("prematter.new")
          },
          w
        );
      }),
      /* @__PURE__ */ O("button", { onClick: u, className: ve.tabAdd, disabled: i, children: [
        /* @__PURE__ */ m(Sr, {}),
        " ",
        o("prematter.add")
      ] })
    ] })
  ] });
}, E1 = "_scaleInputContainer_8ilmq_76", S1 = "_scaleInput_8ilmq_76", N1 = "_scaleInputLabels_8ilmq_139", L1 = "_labelWrapper_8ilmq_147", A1 = "_currentValue_8ilmq_154", T1 = "_label_8ilmq_147", Ge = {
  scaleInputContainer: E1,
  scaleInput: S1,
  scaleInputLabels: N1,
  labelWrapper: L1,
  currentValue: A1,
  label: T1
}, M1 = ie(
  (e, n) => {
    var p, y;
    const { value: t, labels: r = [], min: i, max: l, onChange: o, disabled: a } = e, [s, c] = J(t), [u, d] = J(void 0);
    le(() => {
      if (s !== void 0)
        for (let x = 0; x < r.length; x++) {
          const b = r[x];
          if (b.lower && b.upper && s >= b.lower && s <= b.upper) {
            d(b.text);
            break;
          } else if (b.lower && !b.upper && s >= b.lower) {
            d(b.text);
            break;
          } else if (!b.lower && b.upper && s <= b.upper) {
            d(b.text);
            break;
          }
        }
    }, [s, r]);
    const h = (x) => {
      c(x), o(x);
    };
    return le(() => {
      c(t);
    }, [t]), /* @__PURE__ */ O("div", { className: Ge.scaleInputContainer, children: [
      /* @__PURE__ */ m(
        "input",
        {
          ref: n,
          ...e.props,
          className: `${Ge.scaleInput} ${((p = e.props) == null ? void 0 : p.className) || ""}`,
          type: "range",
          value: s === void 0 ? i : s,
          min: i,
          max: l,
          onChange: (x) => h(parseInt(x.target.value)),
          style: {
            ...(y = e.props) == null ? void 0 : y.style,
            ...s ? {
              "--percentage": s === void 0 ? 0 : ((s || 0) - i) / (l - i) * 100 + "%"
            } : {}
          },
          disabled: a
        }
      ),
      /* @__PURE__ */ O("div", { className: Ge.scaleInputLabels, children: [
        /* @__PURE__ */ m("div", { children: i }),
        /* @__PURE__ */ O("div", { className: Ge.labelWrapper, children: [
          /* @__PURE__ */ m("div", { className: Ge.currentValue, children: s }),
          u ? /* @__PURE__ */ m("div", { className: Ge.label, children: u }) : null
        ] }),
        /* @__PURE__ */ m("div", { children: l })
      ] })
    ] });
  }
), P1 = "_splitDateInputWrapper_1mi99_76", F1 = "_splitDateInput_1mi99_76", Ln = {
  splitDateInputWrapper: P1,
  splitDateInput: F1
}, R1 = ie(
  (e, n) => {
    var C;
    const { value: t = {}, onChange: r, disabled: i } = e, [l, o] = J(t.year || ""), [a, s] = J(t.month || ""), [c, u] = J(t.day || ""), [d, h] = J([
      "day",
      "month",
      "year"
    ]);
    le(() => {
      w();
    }, []);
    const p = (M, L) => new Date(M, L, 0).getDate(), y = (M) => {
      const L = M.target.value, v = parseInt(L, 10), S = parseInt(l, 10), P = parseInt(a, 10);
      if (!isNaN(v) && !isNaN(S) && !isNaN(P)) {
        const E = p(S, P);
        v >= 1 && v <= E && (u(L), r({ year: l, month: a, day: L }));
      } else (L === "" || !isNaN(v) && v < 31 && !l && !a) && (u(L), r({ year: l, month: a, day: L }));
    }, x = (M) => {
      const L = M.target.value, v = parseInt(L, 10), S = parseInt(l, 10), P = parseInt(c, 10);
      if (!isNaN(v) && v >= 1 && v <= 12) {
        s(L), r({ year: l, month: L, day: c });
        const E = p(S, v);
        !isNaN(P) && P > E && (u(E.toString()), r({ year: l, month: L, day: E.toString() }));
      } else L === "" && (s(L), r({ year: l, month: L, day: c }));
    }, b = (M) => {
      const L = M.target.value, v = parseInt(L, 10), S = parseInt(a, 10), P = parseInt(c, 10);
      if (isNaN(v))
        L === "" && (o(L), r({ year: L, month: a, day: c }));
      else {
        o(L), r({ year: L, month: a, day: c });
        const E = p(v, S);
        !isNaN(P) && P > E && (u(E.toString()), r({ year: L, month: a, day: E.toString() }));
      }
    }, w = () => {
      const v = new Date(1999, 11, 31).toLocaleDateString().split(/\D/);
      parseInt(v[0], 10) === 31 ? h(["day", "month", "year"]) : parseInt(v[0], 10) === 1999 ? h(["year", "month", "day"]) : h(["month", "day", "year"]);
    }, I = () => d.map((M, L) => M === "day" ? /* @__PURE__ */ m(
      "input",
      {
        type: "text",
        value: c,
        onChange: y,
        placeholder: "Day",
        className: Ln.splitDateInput,
        disabled: i
      },
      L
    ) : M === "month" ? /* @__PURE__ */ O("select", { value: a, onChange: x, className: Ln.splitDateInput, disabled: i, children: [
      /* @__PURE__ */ m("option", { value: "", children: "Month" }),
      /* @__PURE__ */ m("option", { value: "1", children: "January" }),
      /* @__PURE__ */ m("option", { value: "2", children: "February" }),
      /* @__PURE__ */ m("option", { value: "3", children: "March" }),
      /* @__PURE__ */ m("option", { value: "4", children: "April" }),
      /* @__PURE__ */ m("option", { value: "5", children: "May" }),
      /* @__PURE__ */ m("option", { value: "6", children: "June" }),
      /* @__PURE__ */ m("option", { value: "7", children: "July" }),
      /* @__PURE__ */ m("option", { value: "8", children: "August" }),
      /* @__PURE__ */ m("option", { value: "9", children: "September" }),
      /* @__PURE__ */ m("option", { value: "10", children: "October" }),
      /* @__PURE__ */ m("option", { value: "11", children: "November" }),
      /* @__PURE__ */ m("option", { value: "12", children: "December" })
    ] }, L) : M === "year" ? /* @__PURE__ */ m(
      "input",
      {
        type: "text",
        value: l,
        onChange: b,
        placeholder: "Year",
        className: Ln.splitDateInput,
        disabled: i
      },
      L
    ) : null);
    return /* @__PURE__ */ m(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Ln.splitDateInputWrapper} ${(C = e.props) == null ? void 0 : C.className}`,
        children: I()
      }
    );
  }
), Et = (e, n) => {
  for (const t of n) {
    if (t.id === e)
      return t;
    if (t.type === Q.MultiPart) {
      const r = Et(e, t.questions);
      if (r)
        return r;
    }
  }
  return null;
}, Ze = (e, n) => {
  var l;
  const t = /{{(.*?)(?:, *(.*?))?}}/g;
  let r, i = e;
  for (; r = t.exec(e); ) {
    const a = r[1].trim().split("."), s = a[0], c = (l = r[2]) == null ? void 0 : l.trim(), u = Et(s, n);
    if (u && u.answer)
      if (typeof u.answer == "object") {
        const d = u.answer;
        a.length > 1 ? i = i.replace(
          r[0],
          d[a[1]] || c || ""
        ) : i = i.replace(r[0], u.answer);
      } else
        i = i.replace(r[0], u.answer);
    else c ? i = i.replace(r[0], c) : i = i.replace(r[0], "");
  }
  return i;
}, ln = ie(
  (e, n) => {
    var c, u, d, h;
    const { questions: t, question: r, onChange: i, disabled: l = !1, language: o } = e, a = (p) => {
      if (!l) {
        const y = {
          ...r,
          answer: p,
          answeredAt: Date.now()
        };
        i(y);
      }
    };
    let s = null;
    switch (r.type) {
      case Q.Text:
      case Q.FreeText: {
        s = /* @__PURE__ */ m(
          Di,
          {
            value: r.answer || "",
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case Q.YesNo: {
        const p = (y) => {
          a(y === "yes");
        };
        s = /* @__PURE__ */ m(
          pu,
          {
            value: r.answer === void 0 || r.answer === null ? void 0 : r.answer ? "yes" : "no",
            onChange: p,
            disabled: l,
            language: o
          }
        );
        break;
      }
      case Q.Scale: {
        s = /* @__PURE__ */ m(
          M1,
          {
            value: r.answer,
            labels: r.labels,
            min: r.lowerBound,
            max: r.upperBound,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case Q.Financial:
      case Q.Numeric: {
        s = /* @__PURE__ */ m(
          u1,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case Q.Time: {
        s = /* @__PURE__ */ m(
          Du,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case Q.Date: {
        s = /* @__PURE__ */ m(
          Su,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case Q.SplitDate: {
        s = /* @__PURE__ */ m(
          R1,
          {
            value: r.answer,
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case Q.File: {
        s = /* @__PURE__ */ m(
          a1,
          {
            value: r.answer,
            onChange: a,
            disabled: l,
            language: o
          }
        );
        break;
      }
      case Q.DateTime: {
        s = /* @__PURE__ */ m(
          Mu,
          {
            value: r.answer || Date.now(),
            onChange: a,
            disabled: l
          }
        );
        break;
      }
      case Q.Radio: {
        s = /* @__PURE__ */ m(Oe, { children: (c = r == null ? void 0 : r.options) == null ? void 0 : c.map((p, y) => {
          var x;
          return /* @__PURE__ */ O(nt, { children: [
            /* @__PURE__ */ m(
              Cu,
              {
                checked: r.answer === p.value,
                value: p.value,
                label: Ze(p.label, t),
                name: r.id,
                onChange: a,
                disabled: l
              }
            ),
            r.answer === p.value && p.description ? /* @__PURE__ */ m(
              Nn,
              {
                text: Ze(p.description, t)
              }
            ) : null,
            r.answer === p.value && p.questions ? (x = p.questions) == null ? void 0 : x.map((b, w) => /* @__PURE__ */ m(
              ln,
              {
                questions: t,
                question: b,
                onChange: (I) => {
                  var M;
                  const C = { ...r };
                  C.options = (M = C.options) == null ? void 0 : M.map((L) => {
                    var S;
                    const v = { ...L };
                    return v.value === p.value && (v.questions = (S = v.questions) == null ? void 0 : S.map((P) => P.id === I.id ? I : P)), v;
                  }), i({
                    ...C,
                    answeredAt: Date.now()
                  });
                },
                disabled: l,
                language: o,
                props: {
                  style: { paddingLeft: "20px" },
                  className: hn.childQuestionWrapper
                }
              },
              w
            )) : null
          ] }, y);
        }) });
        break;
      }
      case Q.Checkbox: {
        const p = (y, x) => {
          const b = [...r.answer || []];
          if (x)
            b.push(y);
          else {
            const w = b.indexOf(y);
            w !== -1 && b.splice(w, 1);
          }
          a(b);
        };
        s = /* @__PURE__ */ m(Oe, { children: (u = r == null ? void 0 : r.options) == null ? void 0 : u.map((y) => {
          var x, b, w;
          return /* @__PURE__ */ O(nt, { children: [
            /* @__PURE__ */ m(
              bu,
              {
                checked: (x = r.answer) == null ? void 0 : x.includes(y.value),
                value: y.value,
                label: Ze(y.label, t),
                onChange: p,
                disabled: l
              },
              y.value
            ),
            (b = r.answer) != null && b.includes(y.value) ? /* @__PURE__ */ O(Oe, { children: [
              y.description ? /* @__PURE__ */ m(
                Nn,
                {
                  text: Ze(
                    y.description,
                    t
                  )
                }
              ) : null,
              (w = y.questions) != null && w.length ? /* @__PURE__ */ m(Oe, { children: y.questions.map((I, C) => /* @__PURE__ */ m(
                ln,
                {
                  questions: t,
                  question: I,
                  onChange: (M) => {
                    var v;
                    const L = { ...r };
                    L.options = (v = L.options) == null ? void 0 : v.map(
                      (S) => {
                        var E;
                        const P = { ...S };
                        return P.value === y.value && (P.questions = (E = P.questions) == null ? void 0 : E.map((R) => R.id === M.id ? M : R)), P;
                      }
                    ), i({
                      ...L,
                      answeredAt: Date.now()
                    });
                  },
                  disabled: l,
                  language: o,
                  props: {
                    style: { paddingLeft: "20px" },
                    className: hn.childQuestionWrapper
                  }
                },
                C
              )) }) : null
            ] }) : null
          ] }, y.value);
        }) });
        break;
      }
      case Q.Items: {
        s = /* @__PURE__ */ m(
          I1,
          {
            questions: t,
            question: r,
            onChange: i,
            disabled: l,
            language: o
          }
        );
        break;
      }
      case Q.MultiPart: {
        const p = (y) => (x) => {
          const b = { ...r, questions: [...r.questions] };
          b.questions[y] = { ...x, answeredAt: Date.now() }, i(b);
        };
        s = /* @__PURE__ */ m("div", { className: hn.multiPartQuestion, children: (d = r == null ? void 0 : r.questions) == null ? void 0 : d.map((y, x) => {
          if (y.onlyAvailableIf) {
            const b = y.onlyAvailableIf, w = Et(
              b.questionId,
              t
            );
            if (w && w.answer !== (b == null ? void 0 : b.answer))
              return null;
          }
          return /* @__PURE__ */ m(
            ln,
            {
              questions: t,
              question: y,
              onChange: p(x),
              disabled: l,
              props: {
                className: hn.childQuestionWrapper
              }
            },
            x
          );
        }) });
        break;
      }
    }
    return /* @__PURE__ */ Ni(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${hn.questionWrapper} ${(h = e.props) == null ? void 0 : h.className}`,
        key: r.id
      },
      r.question && (r.question || "").trim().length > 0 ? /* @__PURE__ */ m(
        ju,
        {
          text: Ze(r.question, t),
          language: o
        }
      ) : null,
      r.description ? /* @__PURE__ */ m(
        Nn,
        {
          text: /* @__PURE__ */ m(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: Ze(r.description, t)
              }
            }
          )
        }
      ) : null,
      s,
      r.information ? /* @__PURE__ */ m(
        Nn,
        {
          text: Ze(r.information, t)
        }
      ) : null
    );
  }
), B1 = "_complete_bo832_76", D1 = "_inlineForm_bo832_86", $1 = "_inlineFormTitle_bo832_94", O1 = "_formFooter_bo832_102", z1 = "_formFooterLeft_bo832_109", H1 = "_formFooterRight_bo832_134", V1 = "_inlineFormError_bo832_159", en = {
  complete: B1,
  inlineForm: D1,
  inlineFormTitle: $1,
  formFooter: O1,
  formFooterLeft: z1,
  formFooterRight: H1,
  inlineFormError: V1
}, j1 = ie(
  (e, n) => {
    var $, U, G, ce, fe, g;
    const {
      title: t,
      form: r,
      onChange: i,
      onComplete: l,
      complete: o,
      onFileUpload: a,
      onFileRemove: s,
      files: c,
      onBack: u,
      language: d
    } = e, { t: h } = Te(void 0, { lng: d }), [p, y] = J(r.questions), [x, b] = J([]), [w, I] = J(0), [C, M] = J(0), [L, v] = J(), [S, P] = J(!1), E = p[C].type === Q.File && (($ = p[C].answer) == null ? void 0 : $.some((z) => !("id" in z)));
    le(() => {
      const z = p.map((V) => V.type === Q.File && c ? {
        ...V,
        answer: [
          ...c,
          ...(V.answer || []).filter(
            (f) => !("id" in f) && !c.some((W) => W.name === f.name)
          )
        ]
      } : V);
      y(z);
    }, [c]), le(() => {
      i && w > 0 && i(p);
    }, [w]), le(() => {
      o && (I(100), P(!0));
    }, [o]);
    const R = Y((z) => {
      if (z > p.length - 1)
        return null;
      const V = p[z + 1];
      if (!V)
        return null;
      if (V.onlyAvailableIf) {
        const f = V.onlyAvailableIf, W = (X, pe) => {
          for (const we of pe) {
            if (we.id === X)
              return we;
            if (we.type === Q.MultiPart) {
              const Re = W(X, we.questions);
              if (Re)
                return Re;
            }
          }
          return null;
        }, ee = W(
          f.questionId,
          p
        );
        if (ee) {
          if (Array.isArray(f.answer)) {
            if (!f.answer.includes(
              ee.answer
            ))
              return R(z + 1);
          } else if (ee.answer !== (f == null ? void 0 : f.answer))
            return R(z + 1);
        }
      }
      return V;
    }, [p]), k = Y((z) => {
      if (z && z.type === Q.File) {
        const f = p.find((X) => X.id === z.id).answer || [], W = z.answer || [], ee = [];
        f.forEach((X) => {
          "id" in X && (W.filter((pe) => "id" in pe).some((pe) => X.id === pe.id) || (s && s(X), ee.push(X)));
        }), ee.length > 0 && (z.answer = [...z.answer || [], ...ee]);
      }
      y((V) => {
        const f = V.findIndex((ee) => ee.id === z.id), W = [...V];
        return W[f] = { ...z, answeredAt: Date.now() }, W;
      }), v("");
    }, [s, p]), A = Y(
      (z) => {
        z && z.preventDefault();
        const V = p[C];
        if (V && V.required && (V.answer === void 0 || V.answer === "" || V.answer === null)) {
          v(h("toast.answer-question"));
          return;
        } else if (V.type === Q.SplitDate && V.answer && (V.answer.year === "" || V.answer.year === void 0 || V.answer === null)) {
          v(h("toast.answer-question"));
          return;
        }
        const f = R(C);
        if (f) {
          k({ ...V, answeredAt: Date.now() }), b([...x, V.id]), v("");
          const W = p.findIndex(
            (ee) => ee.id === f.id
          );
          M(W), I(W / p.length * 100), P(!1);
        } else {
          const W = {
            ...V,
            answeredAt: Date.now()
          };
          k(W);
          const X = p.filter(
            (pe) => pe.type !== Q.File
          ).map((pe) => pe.id == V.id ? W : pe);
          l && l(X), I(100), P(!0);
        }
      },
      [p, C, R, h, k, x, l]
    ), T = (z) => {
      z.preventDefault();
      const V = x[x.length - 1], f = p.find(
        (W) => W.id === V
      );
      if (f) {
        const W = p.findIndex(
          (ee) => ee.id === f.id
        );
        b(x.slice(0, x.length - 1)), M(W), I(W / p.length * 100), v("");
      }
    }, D = (z) => (V) => {
      if (V.preventDefault(), z.type === Q.File && z.answer) {
        const f = z.answer.filter(
          (W) => !("id" in W)
        );
        if (f.length > 0) {
          const W = z.answer.map((ee) => ("id" in ee || (ee.uploading = !0), ee));
          k({
            ...z,
            answer: W,
            answeredAt: Date.now()
          }), a && a(f);
        }
      }
    };
    return le(() => {
      const z = (V) => {
        V.key === "Enter" && (V.preventDefault(), V.stopPropagation(), A());
      };
      return window.addEventListener("keydown", z), () => {
        window.removeEventListener("keydown", z);
      };
    }, [A]), /* @__PURE__ */ O(
      "form",
      {
        ref: n,
        ...e.props,
        className: `${en.inlineForm} ${(U = e.props) == null ? void 0 : U.className}`,
        children: [
          /* @__PURE__ */ m("div", { className: en.inlineFormTitle, children: t || r.name }),
          /* @__PURE__ */ m(fu, { value: w }),
          S ? null : /* @__PURE__ */ O(Oe, { children: [
            p && p[C] ? /* @__PURE__ */ m(
              ln,
              {
                questions: p,
                question: p[C],
                onChange: k,
                language: d
              },
              p[C].id
            ) : null,
            /* @__PURE__ */ O("div", { className: en.formFooter, children: [
              /* @__PURE__ */ m("div", { className: en.formFooterLeft, children: C > 0 || u ? /* @__PURE__ */ m(
                "button",
                {
                  onClick: C > 0 ? T : u,
                  disabled: x.length === 0 && !u,
                  children: h("chat.back")
                }
              ) : null }),
              /* @__PURE__ */ O("div", { className: en.formFooterRight, children: [
                ((G = p[C]) == null ? void 0 : G.type) === Q.File ? /* @__PURE__ */ m(
                  "button",
                  {
                    onClick: D(p[C]),
                    disabled: !E || !((ce = p[C].answer) != null && ce.filter((z) => !("id" in z)).length) || ((fe = p[C].answer) == null ? void 0 : fe.filter(
                      (z) => !("id" in z) && z.uploading
                    ).length) > 0,
                    children: h("prematter.upload")
                  }
                ) : (g = p[C]) != null && g.required ? null : /* @__PURE__ */ m("button", { onClick: A, children: h("chat.dunno") }),
                /* @__PURE__ */ m(
                  "button",
                  {
                    onClick: A,
                    disabled: !!L || E,
                    children: R(C) ? h("chat.next") : h("chat.finish")
                  }
                )
              ] })
            ] }),
            L ? /* @__PURE__ */ m("div", { className: en.inlineFormError, children: L }) : null
          ] })
        ]
      }
    );
  }
), q1 = "_complete_1imrz_76", W1 = "_overviewForm_1imrz_86", Z1 = "_overviewFormTitle_1imrz_99", U1 = "_overviewQuestions_1imrz_107", Q1 = "_uploadButton_1imrz_114", Y1 = "_overviewFormError_1imrz_140", K1 = "_submitButton_1imrz_151", nn = {
  complete: q1,
  overviewForm: W1,
  overviewFormTitle: Z1,
  overviewQuestions: U1,
  uploadButton: Q1,
  overviewFormError: Y1,
  submitButton: K1
}, X1 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z", fill: "#0E5FE3" })), Od = ie(
  (e, n) => {
    var R;
    const {
      title: t,
      form: r,
      onChange: i,
      onSubmit: l,
      onSubmitLabel: o,
      disabled: a = !1,
      hideFileUpload: s = !1,
      onFileUpload: c,
      onFileRemove: u,
      files: d,
      language: h,
      hideConditionalQuestions: p
    } = e, y = ue(d || []), { t: x } = Te(), [b, w] = J(r.questions), [I, C] = J(), M = b.filter(
      (k) => {
        var A;
        return k.type === Q.File && ((A = k.answer) == null ? void 0 : A.some((T) => !("id" in T)));
      }
    ).length > 0;
    le(() => {
      if (d && d.length !== y.current.length) {
        const k = b.map((A) => A.type === Q.File && d ? {
          ...A,
          answer: [
            ...d,
            ...(A.answer || []).filter(
              (T) => !("id" in T) && !d.some((D) => D.name === T.name)
            )
          ]
        } : A);
        w(k);
      }
    }, [d]);
    const L = (k) => {
      if (k && k.type === Q.File) {
        const T = b.find((U) => U.id === k.id).answer || [], D = k.answer || [], $ = [];
        T.forEach((U) => {
          "id" in U && (D.filter((G) => "id" in G).some((G) => U.id === G.id) || (u && u(U), $.push(U)));
        }), $.length > 0 && (k.answer = [...k.answer || [], ...$]);
      }
      w((A) => {
        const T = A.findIndex(($) => $.id === k.id), D = [...A];
        return D[T] = { ...k }, D;
      }), i && i(b), C("");
    }, v = (k, A) => {
      for (const T of A) {
        if (T.id === k)
          return T;
        if (T.type === Q.MultiPart) {
          const D = v(k, T.questions);
          if (D)
            return D;
        }
      }
      return null;
    }, S = () => {
      const k = (A) => A != null && A !== "";
      for (const A of b)
        if (A.required && !k(A.answer)) {
          if (A.onlyAvailableIf) {
            const T = A.onlyAvailableIf, D = v(
              T.questionId,
              b
            );
            if (D && !k(D.answer))
              return C(`${x("toast.answer-question")}: ${A.question}`), !1;
          }
          return C(`${x("toast.answer-question")}: ${A.question}`), !1;
        }
      return !0;
    }, P = (k) => {
      k.preventDefault();
      const A = S();
      if (!a && A) {
        const T = b.filter(
          (D) => D.type !== Q.File
        );
        l && l(T);
      }
    }, E = (k) => (A) => {
      if (A.preventDefault(), k.type === Q.File && k.answer) {
        const T = k.answer.filter(
          (D) => !("id" in D)
        );
        if (T.length > 0) {
          const D = k.answer.map(($) => ("id" in $ || ($.uploading = !0), $));
          L({ ...k, answer: D }), c && c(T);
        }
      }
    };
    return /* @__PURE__ */ O(
      "form",
      {
        ref: n,
        ...e.props,
        className: `${nn.overviewForm} ${(R = e.props) == null ? void 0 : R.className}`,
        children: [
          t ? /* @__PURE__ */ m("div", { className: nn.overviewFormTitle, children: t }) : null,
          /* @__PURE__ */ O("div", { className: nn.overviewQuestions, children: [
            b.map((k) => {
              var A, T;
              if (s && k.type === Q.File || p && k.hideConditionally)
                return null;
              if (k.onlyAvailableIf) {
                const D = k.onlyAvailableIf, $ = v(
                  D.questionId,
                  b
                );
                if ($) {
                  if (Array.isArray(D.answer)) {
                    if (!D.answer.includes(
                      $.answer
                    ))
                      return null;
                  } else if ($.answer !== (D == null ? void 0 : D.answer))
                    return null;
                }
              }
              return /* @__PURE__ */ O(nt, { children: [
                /* @__PURE__ */ m(
                  ln,
                  {
                    questions: b,
                    question: k,
                    onChange: L,
                    disabled: a,
                    language: h
                  }
                ),
                k.type === Q.File && /* @__PURE__ */ m(
                  "button",
                  {
                    className: nn.uploadButton,
                    onClick: E(k),
                    disabled: a || !((A = k.answer) != null && A.filter((D) => !("id" in D)).length) || ((T = k.answer) == null ? void 0 : T.filter(
                      (D) => !("id" in D) && D.uploading
                    ).length) > 0,
                    children: x("prematter.upload")
                  }
                ),
                /* @__PURE__ */ m(gi, {})
              ] }, k.id);
            }),
            I ? /* @__PURE__ */ m("div", { className: nn.overviewFormError, children: I }) : null
          ] }),
          /* @__PURE__ */ O(
            "button",
            {
              className: nn.submitButton,
              type: "submit",
              onClick: P,
              disabled: !!I || a || M,
              children: [
                o || x("chat.submit"),
                /* @__PURE__ */ m(X1, {})
              ]
            }
          )
        ]
      }
    );
  }
), J1 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 7.5, stroke: "#666666" }), /* @__PURE__ */ _.createElement("path", { d: "M12.375 4.25C12.7202 4.25 13 4.52982 13 4.875C13 5.04757 12.9301 5.2038 12.817 5.3169L6.56699 11.5669C6.45388 11.68 6.29761 11.75 6.125 11.75C5.94944 11.75 5.79079 11.6776 5.67726 11.5611L3.18893 9.07274C3.07238 8.95921 3 8.80056 3 8.625C3 8.27982 3.27982 8 3.625 8C3.79759 8 3.95385 8.06996 4.06695 8.18307L6.12505 10.2411L11.9302 4.4359C12.0436 4.32113 12.201 4.25 12.375 4.25Z", fill: "#666666" })), G1 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#999999", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/warning circle" }, /* @__PURE__ */ _.createElement("g", { id: "Union" }, /* @__PURE__ */ _.createElement("path", { d: "M12.75 7.5V13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5V7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5Z" }), /* @__PURE__ */ _.createElement("path", { d: "M12.75 16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5C11.25 16.0858 11.5858 15.75 12 15.75C12.4142 15.75 12.75 16.0858 12.75 16.5Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12Z" })))), e2 = "_tickIcon_1saim_76", n2 = "_toastWrapper_1saim_86", t2 = "_toast_1saim_86", r2 = "_body_1saim_132", fn = {
  tickIcon: e2,
  toastWrapper: n2,
  toast: t2,
  body: r2
}, zd = (e) => /* @__PURE__ */ m(
  Mi,
  {
    position: "bottom-center",
    autoClose: 4e3,
    hideProgressBar: !0,
    newestOnTop: !0,
    closeOnClick: !0,
    rtl: !1,
    pauseOnFocusLoss: !1,
    draggable: !1,
    pauseOnHover: !1,
    icon: (t) => {
      if (t.type === "success")
        return /* @__PURE__ */ m(J1, { className: fn.tickIcon });
      if (t.type === "error")
        return /* @__PURE__ */ m(G1, { className: fn.tickIcon });
    },
    closeButton: !1,
    toastClassName: fn.toast,
    bodyClassName: fn.body,
    className: fn.toastWrapper,
    limit: 3,
    ...e
  }
), i2 = "_container_vbx1z_76", l2 = "_clickable_vbx1z_100", o2 = "_hideMobile_vbx1z_104", a2 = "_rowButton_vbx1z_104", s2 = "_timestamp_vbx1z_105", c2 = "_newDot_vbx1z_109", u2 = "_detailsContainer_vbx1z_122", p2 = "_lawyerName_vbx1z_128", d2 = "_prematterName_vbx1z_129", h2 = "_buttonLabel_vbx1z_181", f2 = "_ended_vbx1z_199", _e = {
  container: i2,
  clickable: l2,
  hideMobile: o2,
  rowButton: a2,
  timestamp: s2,
  newDot: c2,
  detailsContainer: u2,
  lawyerName: p2,
  prematterName: d2,
  buttonLabel: h2,
  ended: f2
}, m2 = "_contextMenuWrapper_17tfd_76", g2 = "_open_17tfd_86", y2 = "_menuIcon_17tfd_89", w2 = "_contextMenu_17tfd_76", C2 = "_show_17tfd_118", v2 = "_fixedPositioning_17tfd_122", x2 = "_leftPositioning_17tfd_127", b2 = "_contextMenuItem_17tfd_138", _2 = "_disabled_17tfd_154", k2 = "_label_17tfd_161", I2 = "_icon_17tfd_167", ke = {
  contextMenuWrapper: m2,
  open: g2,
  menuIcon: y2,
  contextMenu: w2,
  show: C2,
  fixedPositioning: v2,
  leftPositioning: x2,
  contextMenuItem: b2,
  disabled: _2,
  label: k2,
  icon: I2
}, E2 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M12 7.5C12.8284 7.5 13.5 6.82843 13.5 6C13.5 5.17157 12.8284 4.5 12 4.5C11.1716 4.5 10.5 5.17157 10.5 6C10.5 6.82843 11.1716 7.5 12 7.5Z", fill: "#777777" }), /* @__PURE__ */ _.createElement("path", { d: "M13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12Z", fill: "#777777" }), /* @__PURE__ */ _.createElement("path", { d: "M13.5 18C13.5 18.8284 12.8284 19.5 12 19.5C11.1716 19.5 10.5 18.8284 10.5 18C10.5 17.1716 11.1716 16.5 12 16.5C12.8284 16.5 13.5 17.1716 13.5 18Z", fill: "#777777" })), S2 = (e, n) => {
  le(
    () => {
      const t = (r) => {
        e.some((i) => !i.current || i.current.contains(r.target)) || n(r);
      };
      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [e, n]
  );
}, yi = (e) => {
  const {
    items: n,
    className: t,
    activeClassName: r,
    menuItemsClassName: i,
    fixedPositioning: l,
    positioning: o
  } = e, [a, s] = Tr.useState(!1), c = ue(null), u = ue(null);
  S2([c, u], () => s(!1));
  const d = Y(
    (p) => {
      if (p.preventDefault(), p.stopPropagation(), s((y) => !y), l && u.current && c.current) {
        const { top: y, height: x, left: b, width: w } = c.current.getBoundingClientRect();
        u.current.style.top = `${y + x}px`, u.current.style.setProperty(
          "--context-menu-parent-width",
          `${w}px`
        ), u.current.style.setProperty(
          "--context-menu-left-position",
          `${b}px`
        );
      }
    },
    [l]
  );
  le(() => {
    if (l) {
      const p = () => s(!1);
      return window.addEventListener("scroll", p), () => window.removeEventListener("scroll", p);
    }
  }, [l]);
  const h = /* @__PURE__ */ m(
    "div",
    {
      className: `${ke.contextMenu} 
    ${l ? ke.fixedPositioning : ""} 
     ${o === "left" ? ke.leftPositioning : ""} 
    ${a ? ke.show : ""} 
    ${i ?? ""}
  `,
      ref: u,
      children: n.map((p, y) => /* @__PURE__ */ O(
        "div",
        {
          className: `${ke.contextMenuItem} ${p.disabled ? ke.disabled : ""} ${t ?? ""}`,
          onClick: (x) => {
            x.preventDefault(), x.stopPropagation(), p.disabled || (s(!1), p.onClick(x));
          },
          children: [
            /* @__PURE__ */ m("div", { className: ke.label, children: p.label }),
            p.icon && /* @__PURE__ */ m("div", { className: ke.icon, children: p.icon })
          ]
        },
        y
      ))
    }
  );
  return /* @__PURE__ */ O(
    "div",
    {
      className: `${ke.contextMenuWrapper} ${t ?? ""} ${a ? `${ke.open} ${l ? ke.fixedPositioning : ""} ${r ?? ""}` : ""}`,
      onClick: d,
      ref: c,
      children: [
        /* @__PURE__ */ m(E2, { className: ke.menuIcon }),
        l ? Fi(h, document.body) : h
      ]
    }
  );
}, Hd = (e) => {
  const {
    isNew: n,
    isEnded: t,
    Image: r,
    description: i,
    timestamp: l,
    title: o,
    button: a,
    items: s,
    showAllMobile: c,
    onClick: u
  } = e;
  return /* @__PURE__ */ O(
    "div",
    {
      className: `${_e.container} ${c ? "" : _e.hideMobile} ${t ? _e.ended : ""} ${u ? _e.clickable : ""}`,
      onClick: u ?? (() => {
      }),
      children: [
        n && /* @__PURE__ */ m("div", { className: _e.newDot }),
        r,
        /* @__PURE__ */ O("div", { className: _e.detailsContainer, children: [
          /* @__PURE__ */ m("div", { className: _e.lawyerName, children: o }),
          /* @__PURE__ */ m("div", { className: _e.prematterName, children: i })
        ] }),
        l && /* @__PURE__ */ m("div", { className: _e.timestamp, children: ru(l) }),
        a ? /* @__PURE__ */ O(
          "button",
          {
            onClick: a.onClick,
            className: `${_e.rowButton} ${a.className ?? ""}`,
            children: [
              /* @__PURE__ */ m("div", { className: _e.buttonLabel, children: a.label }),
              a.icon
            ]
          }
        ) : null,
        s != null && s.length ? /* @__PURE__ */ m(yi, { className: _e.menuIcon, items: s }) : null
      ]
    }
  );
}, N2 = "_container_wcic1_76", L2 = "_cardsContainer_wcic1_76", A2 = "_cards_wcic1_76", T2 = "_actionBar_wcic1_111", M2 = "_scrollBar_wcic1_124", P2 = "_scrolledPosition_wcic1_132", F2 = "_actionButtonContainer_wcic1_140", R2 = "_actionButton_wcic1_140", B2 = "_actionIcon_wcic1_162", D2 = "_active_wcic1_167", Ae = {
  container: N2,
  cardsContainer: L2,
  cards: A2,
  actionBar: T2,
  scrollBar: M2,
  scrolledPosition: P2,
  actionButtonContainer: F2,
  actionButton: R2,
  actionIcon: B2,
  active: D2
}, $2 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#777777", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M12.5303 5.03032C12.6661 4.8946 12.75 4.7071 12.75 4.5C12.75 4.08579 12.4142 3.75 12 3.75C11.7893 3.75 11.5989 3.83686 11.4627 3.97672L3.97672 11.4627C3.83686 11.5989 3.75 11.7893 3.75 12C3.75 12.2107 3.83686 12.4011 3.97672 12.5373L11.4627 20.0233C11.599 20.1631 11.7893 20.25 12 20.25C12.4142 20.25 12.75 19.9142 12.75 19.5C12.75 19.2929 12.6661 19.1054 12.5303 18.9697L6.31075 12.75H19.5C19.9142 12.75 20.25 12.4142 20.25 12C20.25 11.5858 19.9142 11.25 19.5 11.25H6.31075L12.5303 5.03032Z" })), O2 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "#0E5FE3", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z" })), z2 = (e) => {
  const {
    classNames: n,
    disabledLeftButton: t,
    disabledRightButton: r,
    onLeftButtonClick: i,
    onRightButtonClick: l,
    scrollWidth: o,
    leftPosition: a
  } = e;
  return /* @__PURE__ */ O("div", { className: `${Ae.actionBar}  ${(n == null ? void 0 : n.actionBar) ?? ""}`, children: [
    /* @__PURE__ */ m("div", { className: Ae.scrollBar, children: /* @__PURE__ */ m(
      "div",
      {
        className: Ae.scrolledPosition,
        style: {
          width: `${o * 100}%`,
          left: `${a}%`
        }
      }
    ) }),
    /* @__PURE__ */ O(
      "div",
      {
        className: `${Ae.actionButtonContainer} ${(n == null ? void 0 : n.arrowButtonContainer) ?? ""}`,
        children: [
          /* @__PURE__ */ m(
            "button",
            {
              className: Ae.actionButton,
              onClick: i,
              disabled: t,
              children: /* @__PURE__ */ m($2, { className: Ae.actionIcon })
            }
          ),
          /* @__PURE__ */ m(
            "button",
            {
              className: Ae.actionButton,
              disabled: r,
              onClick: l,
              children: /* @__PURE__ */ m(O2, { className: Ae.actionIcon })
            }
          )
        ]
      }
    )
  ] });
}, H2 = 30, Vd = ie((e, n) => {
  const {
    showProgressBar: t,
    items: r,
    offsetWidth: i,
    classNames: l,
    debug: o,
    cardWidth: a,
    columnCount: s
  } = e, c = kn(() => i ?? 20, [i]), [u, d] = J(0), [h, p] = J(
    a ?? 0
  ), [y, x] = J(s ?? 0), b = ue(null), w = ue(null), I = ue(null), C = kn(
    () => r != null && r.length && y ? 1 / (r.length + 1 - y) : 0,
    [y, r == null ? void 0 : r.length]
  ), M = kn(() => y && u != null && r.length != null && C != null && r.length + 1 - y > 0 ? u * C * 100 : 0, [u, y, r.length, C]), L = Y(
    (T) => {
      I.current && (clearTimeout(I.current), I.current = null), b.current && (o && (console.log("new Index ", T), console.log(
        "scrolling to ",
        T * h + c * T
      )), b.current.scrollTo({
        left: T * h + c * T,
        behavior: "smooth"
      }), d(T));
    },
    [o, c, h]
  ), v = Y(() => {
    u > 0 && L(u - 1);
  }, [u, L]), S = Y(() => {
    u < r.length && L(u + 1);
  }, [u, r == null ? void 0 : r.length, L]), P = Y(() => {
    I.current && (clearTimeout(I.current), I.current = null), I.current = setTimeout(() => {
      var T, D, $;
      if (w.current && ((T = b.current) == null ? void 0 : T.scrollLeft) != null) {
        o && console.log(
          "on scroll handling set active",
          ((D = b.current) == null ? void 0 : D.scrollLeft) / (h + c)
        );
        const U = (($ = b.current) == null ? void 0 : $.scrollLeft) / (h + c);
        r.length - y === Math.ceil(U) ? d(r.length - y) : d(Math.round(U));
      }
      I.current = null;
    }, H2);
  }, [o, h, c, r.length, y]), E = Y(
    (T) => {
      var D, $;
      if ((D = w == null ? void 0 : w.current) != null && D.clientWidth)
        return Math.floor(
          ((($ = w == null ? void 0 : w.current) == null ? void 0 : $.clientWidth) + c) / (T + c)
        );
    },
    [c]
  ), R = Y(
    (T) => {
      var D, $;
      if ((D = b == null ? void 0 : b.current) != null && D.clientWidth) {
        const U = window.getComputedStyle(b.current), G = U.getPropertyValue("padding-left"), ce = U.getPropertyValue("padding-right"), fe = G ? parseInt(G) : 0, g = ce ? parseInt(ce) : 0;
        return ((($ = b == null ? void 0 : b.current) == null ? void 0 : $.clientWidth) - fe - g - c * (T - 1)) / T;
      }
    },
    [c]
  ), k = Y(() => {
    if (a) {
      const T = E(a);
      T && x(T), a !== h && p(a);
    } else if (s) {
      const T = R(s);
      T && p(T), s !== y && x(s);
    }
  }, [
    a,
    s,
    E,
    h,
    R,
    y
  ]);
  le(() => {
    k();
  }, [k]), le(() => (k(), window.addEventListener("resize", k), () => window.removeEventListener("resize", k)), [k]), Bn(n, () => ({
    cardsScrollRef: b,
    getExpectedCards: E
  })), le(() => {
    o && console.log("expectedCards", y);
  }, [o, y]), le(() => {
    o && console.log("cardWidth", a);
  }, [o, a]), le(() => {
    o && console.log("offsetWidth", c);
  }, [o, c]), le(() => {
    o && console.log("activeIndex", u);
  }, [o, u]);
  const A = kn(() => {
    const T = {
      gap: `0 ${c}px`
    };
    return h && (T.gridTemplateColumns = `repeat(auto-fill, minmax(${h}px, 1fr)`, T.gridAutoColumns = `minmax(${h}px, 1fr)`), T;
  }, [h, c]);
  return /* @__PURE__ */ O(
    "div",
    {
      className: `${Ae.container} ${(l == null ? void 0 : l.container) ?? ""}`,
      ref: w,
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: `${Ae.cardsContainer} ${(l == null ? void 0 : l.cardsPosition) ?? ""}`,
            children: /* @__PURE__ */ m(
              "div",
              {
                ref: b,
                className: `${Ae.cards} ${(l == null ? void 0 : l.cardsContainer) ?? ""}`,
                onScroll: P,
                style: A,
                children: r.map((T) => T)
              }
            )
          }
        ),
        t ? /* @__PURE__ */ m(
          z2,
          {
            classNames: l,
            disabledLeftButton: u <= 0,
            disabledRightButton: u >= r.length - y,
            onLeftButtonClick: v,
            onRightButtonClick: S,
            scrollWidth: C,
            leftPosition: M
          }
        ) : null
      ]
    }
  );
}), V2 = "_sectionedForm_1qcpe_76", j2 = "_title_1qcpe_83", q2 = "_section_1qcpe_76", W2 = "_sectionTitle_1qcpe_105", Z2 = "_available_1qcpe_121", U2 = "_sectionTitleText_1qcpe_125", Q2 = "_complete_1qcpe_128", Y2 = "_caret_1qcpe_129", K2 = "_submitButton_1qcpe_137", he = {
  sectionedForm: V2,
  title: j2,
  section: q2,
  sectionTitle: W2,
  available: Z2,
  sectionTitleText: U2,
  complete: Q2,
  caret: Y2,
  submitButton: K2
}, Nr = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.71966 5.03032C7.58394 4.8946 7.5 4.7071 7.5 4.5C7.5 4.08579 7.83579 3.75 8.25 3.75C8.46067 3.75 8.65105 3.83686 8.78729 3.97672L16.2733 11.4627C16.4131 11.5989 16.5 11.7893 16.5 12C16.5 12.2107 16.4131 12.4011 16.2733 12.5373L8.78728 20.0233C8.65105 20.1631 8.46067 20.25 8.25 20.25C7.83579 20.25 7.5 19.9142 7.5 19.5C7.5 19.2929 7.58394 19.1054 7.71966 18.9697L14.6892 12L7.71966 5.03032Z", fill: "#666666" })), Lr = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M21.75 5.25C21.75 4.83579 21.4142 4.5 21 4.5C20.7912 4.5 20.6023 4.58535 20.4663 4.72308L7.50006 17.6893L3.53039 13.7196C3.39466 13.5839 3.20711 13.5 3 13.5C2.58579 13.5 2.25 13.8358 2.25 14.25C2.25 14.4607 2.33686 14.6511 2.47672 14.7873L6.96272 19.2733C7.09896 19.4131 7.28934 19.5 7.5 19.5C7.70713 19.5 7.89465 19.416 8.03038 19.2803L21.5304 5.7803C21.6661 5.64458 21.75 5.45708 21.75 5.25Z", fill: "#666666" })), X2 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z", fill: "#0E5FE3" })), jd = ie(
  (e, n) => {
    var I;
    const { title: t, form: r, onChange: i, onSubmit: l, disabled: o, onSubmitLabel: a } = e, { t: s } = Te(void 0, { lng: e.language ?? void 0 });
    le(() => {
      console.log("language changed", e.language);
    }, [e.language]);
    const [c, u] = J([]), [d, h] = J(null), p = c.every((C) => C.complete);
    le(() => {
      const C = r.questions.reduce(
        (E, R) => {
          var k, A;
          if (R.section) {
            const T = R.section.split("/");
            if (T.length > 1) {
              E[T[0]] || (E[T[0]] = {
                id: T[0],
                title: T[0],
                questions: [],
                children: [],
                complete: !1
              });
              const D = E[T[0]], $ = (k = D.children) == null ? void 0 : k.find(
                (U) => U.title === T[1]
              );
              $ ? $.questions.push(R) : (A = D.children) == null || A.push({
                id: R.section,
                title: T[1],
                questions: [R],
                children: [],
                complete: !1
              });
            } else
              E[T[0]] ? E[T[0]].questions.push(R) : E[T[0]] = {
                id: R.section,
                title: T[0],
                questions: [R],
                children: [],
                complete: !1
              };
          }
          return E;
        },
        {}
      ), M = (E, R) => {
        for (const k of R) {
          if (k.id === E)
            return k;
          if (k.type === Q.MultiPart) {
            const A = M(E, k.questions);
            if (A)
              return A;
          }
        }
        return null;
      }, L = (E) => E != null && E !== "", v = (E) => {
        if (E.answeredAt)
          return !0;
        if (E.onlyAvailableIf) {
          const R = E.onlyAvailableIf, k = M(
            R.questionId,
            r.questions
          );
          if (k)
            return Array.isArray(R.answer) ? R.answer.includes(
              k.answer
            ) ? !0 : null : k.answer !== (R == null ? void 0 : R.answer) ? null : E.required && !L(E.answer) ? !1 : !E.required && E.answer === null;
        }
        return E.required && !L(E.answer) ? !1 : !E.required && E.answer === null;
      };
      let S = !1;
      const P = Object.values(C).map(
        (E) => {
          if (Object.keys(C).indexOf(E.id) > 0 && !S)
            return E.complete = !1, E;
          let k = !1;
          if (E.children && E.children.length > 0) {
            const T = E.children.map((D) => D.questions.map(($) => v($))).filter((D) => D !== null).map((D) => D.filter(($) => $ !== null).every(($) => $));
            k = T.every((D) => D), E.children = E.children.map((D, $) => (D.complete = T[$], D));
          } else
            k = E.questions.map((T) => v(T)).filter((T) => T !== null).every((T) => T);
          return k ? (E.complete = !0, S = !0) : S = !1, E;
        }
      );
      u(P);
    }, [r.questions]);
    const y = (C) => (M) => {
      M.preventDefault(), o || h(C);
    }, x = (C) => {
      if (!d || o)
        return;
      const M = {
        ...d,
        questions: C
      };
      h(M);
      const L = c.map((S) => {
        var E;
        if (S.id === M.id)
          return M;
        const P = d.id.split("/");
        return P.length > 1 && S.id === P[0] ? {
          ...S,
          children: (E = S.children) == null ? void 0 : E.map((R) => R.id === d.id ? M : R)
        } : S;
      }), v = L.reduce((S, P) => P.children && P.children.length > 0 ? S.concat(
        P.children.reduce(
          (E, R) => E.concat(R.questions),
          []
        )
      ) : S.concat(P.questions), []);
      i && i(v), u(L);
    }, b = (C) => {
      if (!d || o)
        return;
      const M = {
        ...d,
        questions: C,
        complete: !0
      }, L = c.map((S) => {
        var E;
        if (S.id === M.id)
          return M;
        const P = d.id.split("/");
        return P.length > 1 && S.id === P[0] ? {
          ...S,
          children: (E = S.children) == null ? void 0 : E.map((R) => R.id === d.id ? M : R)
        } : S;
      }), v = L.reduce((S, P) => P.children && P.children.length > 0 ? S.concat(
        P.children.reduce(
          (E, R) => E.concat(R.questions),
          []
        )
      ) : S.concat(P.questions), []);
      i && i(v), u(L), console.log(L), h(null);
    }, w = (C) => {
      if (C.preventDefault(), p && !o) {
        const M = c.reduce((L, v) => v.children && v.children.length > 0 ? L.concat(
          v.children.reduce(
            (S, P) => S.concat(P.questions),
            []
          )
        ) : L.concat(v.questions), []);
        l && l(M);
      }
    };
    return /* @__PURE__ */ O(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${he.sectionedForm} ${(I = e.props) == null ? void 0 : I.className}`,
        children: [
          d ? null : /* @__PURE__ */ O(Oe, { children: [
            t ? /* @__PURE__ */ m("div", { className: he.title, children: t }) : null,
            c.map((C, M) => {
              var v, S;
              const L = M === 0 || C.complete || M > 0 && c[M - 1].complete;
              return /* @__PURE__ */ O("div", { className: he.section, children: [
                C.title && /* @__PURE__ */ O(
                  "div",
                  {
                    className: `${he.sectionTitle} ${L ? he.available : ""}`,
                    style: {
                      cursor: !o && C.children && (C.children.length >= 0 && L || L && C.children.length === 0) ? "pointer" : "default"
                    },
                    onClick: !C.children || C.children.length === 0 && L ? y(C) : void 0,
                    children: [
                      /* @__PURE__ */ m("div", { className: he.sectionTitleText, children: s(`intake.${r.source}.section.${C.title}`) }),
                      C.complete ? /* @__PURE__ */ m("div", { className: he.complete, children: /* @__PURE__ */ m(Lr, {}) }) : null,
                      !C.children || C.children.length === 0 ? /* @__PURE__ */ m("div", { className: he.caret, children: /* @__PURE__ */ m(Nr, {}) }) : null
                    ]
                  }
                ),
                C.children && ((v = C.children) == null ? void 0 : v.length) > 0 ? /* @__PURE__ */ m("div", { className: he.section, children: (S = C.children) == null ? void 0 : S.map((P, E) => {
                  const R = M === 0 && E === 0 || P.complete || M > 0 && c[M - 1].complete && (E === 0 || E > 0 && C.children && C.children[E - 1].complete);
                  return /* @__PURE__ */ O(
                    "div",
                    {
                      className: `${he.sectionTitle} ${R ? he.available : ""}`,
                      onClick: !o && (!P.children || P.children.length === 0 && R) ? y(P) : void 0,
                      children: [
                        /* @__PURE__ */ m("div", { className: he.sectionTitleText, children: s(`intake.${r.source}.section.${P.title}`) }),
                        P.complete ? /* @__PURE__ */ m("div", { className: he.complete, children: /* @__PURE__ */ m(Lr, {}) }) : null,
                        /* @__PURE__ */ m("div", { className: he.caret, children: /* @__PURE__ */ m(Nr, {}) })
                      ]
                    },
                    E
                  );
                }) }) : null
              ] }, M);
            }),
            /* @__PURE__ */ O(
              "button",
              {
                className: he.submitButton,
                type: "submit",
                onClick: w,
                disabled: !p || o,
                children: [
                  a || s("chat.submit"),
                  /* @__PURE__ */ m(X2, {})
                ]
              }
            )
          ] }),
          d ? /* @__PURE__ */ m(
            j1,
            {
              form: {
                id: d.id,
                name: s(`intake.${r.source}.section.${d.id}`),
                questions: d.questions
              },
              onChange: x,
              onComplete: b,
              onBack: () => h(null),
              language: e.language
            }
          ) : null
        ]
      }
    );
  }
), J2 = "_messageWrapper_1vq6f_76", G2 = "_left_1vq6f_88", ep = "_message_1vq6f_76", np = "_right_1vq6f_95", tp = "_relativeWrapper_1vq6f_104", rp = "_relativeContainer_1vq6f_109", ip = "_timestampContainer_1vq6f_117", lp = "_show_1vq6f_131", op = "_timestamp_1vq6f_117", ap = "_senderContainer_1vq6f_185", sp = "_withExternalBody_1vq6f_210", cp = "_expandMargin_1vq6f_214", up = "_noExternalBody_1vq6f_231", pp = "_avatarIconContainer_1vq6f_260", oe = {
  messageWrapper: J2,
  left: G2,
  message: ep,
  right: np,
  relativeWrapper: tp,
  relativeContainer: rp,
  timestampContainer: ip,
  show: lp,
  timestamp: op,
  senderContainer: ap,
  withExternalBody: sp,
  expandMargin: cp,
  noExternalBody: up,
  avatarIconContainer: pp
}, dp = "_fileTextContainer_r9p13_76", hp = "_fileName_r9p13_82", fp = "_full_r9p13_88", mp = "_icon_r9p13_91", gp = "_loadingContainer_r9p13_95", yp = "_loadingIconContainer_r9p13_101", wp = "_loadingIcon_r9p13_101", Cp = "_rotateSpinner_r9p13_1", vp = "_dash_r9p13_1", xp = "_text_r9p13_122", bp = "_receiver_r9p13_152", _p = "_filePreviewContainer_r9p13_165", kp = "_contextMenuContainer_r9p13_175", Ip = "_contextMenu_r9p13_175", Ep = "_fileImageContainer_r9p13_186", Sp = "_fileImage_r9p13_186", Np = "_textContent_r9p13_204", Lp = "_sender_r9p13_219", Ap = "_noPreviewContainer_r9p13_241", Tp = "_bgOverlay_r9p13_249", ae = {
  fileTextContainer: dp,
  fileName: hp,
  full: fp,
  icon: mp,
  loadingContainer: gp,
  loadingIconContainer: yp,
  loadingIcon: wp,
  rotateSpinner: Cp,
  dash: vp,
  text: xp,
  receiver: bp,
  filePreviewContainer: _p,
  contextMenuContainer: kp,
  contextMenu: Ip,
  fileImageContainer: Ep,
  fileImage: Sp,
  textContent: Np,
  sender: Lp,
  noPreviewContainer: Ap,
  bgOverlay: Tp
}, Mp = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#103F91", fillRule: "evenodd", d: "M13 21.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185ABD", fillRule: "evenodd", d: "M13 18.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#2B7CD3", fillRule: "evenodd", d: "M13 15.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#41A5EE", fillRule: "evenodd", d: "M13 12.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185ABD", d: "M3.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H3.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#F9F7F7", d: "M6.66125 17.9114h.0165C6.6845 17.8129 7.5275 13 7.5275 13h.9795s.855 4.5883.88125 4.9029H9.401c.01125-.216.708-4.9029.708-4.9029H11l-1.0965 6H8.86175s-.86475-4.74-.8715-4.824h-.0135C7.96925 14.2729 7.1645 19 7.1645 19H6.107L5 13h.9075s.75 4.806.75375 4.9114Z" }))), Pp = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10.4545 12c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091ZM10 15.5c0-.2761.2035-.5.4545-.5h9.091c.251 0 .4545.2239.4545.5s-.2035.5-.4545.5h-9.091c-.251 0-.4545-.2239-.4545-.5Zm.4545 2.5c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Zm0 3c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Z", clipRule: "evenodd" }))), Fp = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M4.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H4.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M13.7143 23H4.28571c-.60621 0-1.18759-.2408-1.61624-.6695C2.24082 21.9019 2 21.3205 2 20.7143v-9.4286c0-.6062.24082-1.1876.66947-1.61623C3.09812 9.24082 3.67951 9 4.28571 9h9.42859c.6062 0 1.1876.24082 1.6162.66947.4287.42863.6695 1.01003.6695 1.61623v9.4286c0 .6062-.2408 1.1876-.6695 1.6162-.4286.4287-1.01.6695-1.6162.6695Zm0-1H4.28571c-.34099 0-.66801-.1355-.90913-.3766C3.13546 21.3823 3 21.0553 3 20.7143v-9.4286c0-.341.13546-.668.37658-.9091.24112-.2411.56814-.3766.90913-.3766h9.42859c.341 0 .668.1355.9091.3766.2411.2411.3766.5681.3766.9091v9.4286c0 .341-.1355.668-.3766.9091-.2411.2411-.5681.3766-.9091.3766Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#A6CCC3", d: "m9.86848 16.228-.84379 1.1999-1.35011-1.8089c-.02779-.0372-.06282-.0672-.10255-.0877-.03972-.0206-.08315-.0313-.12714-.0313-.04398 0-.08741.0107-.12713.0313-.03973.0205-.07476.0505-.10255.0877l-2.15248 2.8836c-.15021.2019-.01371.4974.22983.4974h6.41484c.2398 0 .3774-.2872.2348-.4901l-1.6041-2.2819c-.0277-.0393-.0632-.0712-.1039-.0931-.0407-.0219-.0855-.0333-.1309-.0333-.0454 0-.0902.0114-.13096.0333-.04071.0219-.07625.0538-.10386.0931Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#FF9810", d: "M11.5 15c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z" }))), Rp = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#D65532", d: "M4.91667 22h4.85416c.06078 0 .11907-.0101.16205-.0492.04298-.0391.06712-.0681.06712-.1234v-4.5833c0-.0553-.02414-.1455-.06712-.1845C9.8899 17.0205 9.83161 17 9.77083 17H4.91667c-.24312 0-.47628.0878-.64818.2441-.17191.1563-.26849.3682-.26849.5892v3.3334c0 .221.09658.4329.26849.5892.1719.1563.40506.2441.64818.2441Zm20.16663-5h-4.8541c-.0608 0-.1191.0219-.1621.061-.043.0391-.0671.0921-.0671.1473v4.5834c0 .115.1027.2083.2292.2083h4.8541c.2431 0 .4763-.0878.6482-.2441S26 21.3877 26 21.1667v-3.3334c0-.221-.0966-.4329-.2685-.5892-.1719-.1563-.4051-.2441-.6482-.2441Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#D65532", fillRule: "evenodd", d: "M11 17.5848C11 16.7095 11.613 16 12.3691 16h5.2618C18.387 16 19 16.7095 19 17.5848v3.8304C19 22.2905 18.387 23 17.6309 23h-5.2618C11.613 23 11 22.2905 11 21.4152v-3.8304ZM12.4564 17c-.2521 0-.4564.293-.4564.5848v3.8304c0 .2918.2043.5848.4564.5848h5.1745c.252 0 .3691-.293.3691-.5848v-3.8304c0-.2918-.1171-.5848-.3691-.5848h-5.1745Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10.4545 11c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Zm0 3c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Z", clipRule: "evenodd" }))), Bp = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#134A2C", fillRule: "evenodd", d: "M17 21.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#21A366", fillRule: "evenodd", d: "M17 18.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#33C481", fillRule: "evenodd", d: "M17 15.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Zm0-3c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185C37", fillRule: "evenodd", d: "M13 21.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#107C41", fillRule: "evenodd", d: "M13 18.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#21A366", fillRule: "evenodd", d: "M13 15.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Zm0-3c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#107C41", d: "M3.09091 22h9.81819c.2893 0 .5668-.1149.7714-.3195S14 21.1984 14 20.9091v-9.8182c0-.2893-.1149-.5668-.3195-.7714S13.1984 10 12.9091 10H3.09091c-.28933 0-.56681.1149-.77139.3195-.20459.2046-.31952.4821-.31952.7714v9.8182c0 .2893.11493.5668.31952.7714.20458.2046.48206.3195.77139.3195Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#F9F7F7", d: "m5.00056 19 2.17305-3.0085L5.18283 13h1.60199l1.08681 1.9125c.09987.181.16815.3165.20596.4055h.01411c.07166-.145.14671-.286.22458-.4225L9.4787 13h1.47l-2.04275 2.975L11 19H9.43581l-1.25552-2.1c-.05906-.0894-.1091-.1833-.14954-.2805h-.01862c-.03636.0952-.08502.1863-.14502.2715L6.57434 19H5h.00056Z" }))), Dp = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486H23c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-4.6549c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10 11.5c0-.2761.2239-.5.5-.5h9c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-9c-.2761 0-.5-.2239-.5-.5Zm0 3c0-.2761.2239-.5.5-.5h9c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-9c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185ABD", d: "M5 17c0-.5523.44772-1 1-1h12.9847c.5523 0 1 .4477 1 1v5.0431c0 .5523-.4477 1-1 1H6c-.55228 0-1-.4477-1-1V17Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M7.89258 17.9h1.54651c.03942.0306.15135.1604.15135.6298 0 .3601-.07468.5081-.10844.5538l-.00359.0048H7.89258V17.9Zm-.4-.8h2.01048c.50544.0133.88734.548.88734 1.4298 0 .4531-.0913.7941-.265 1.0292-.17149.2322-.41693.3457-.65033.3294h-.4855l1.29653 1.3239c.1546.1578.1519.4111-.0059.5656-.1578.1546-.4111.152-.56567-.0059l-1.82195-1.8604V21.5c0 .2209-.17908.4-.4.4-.22091 0-.4-.1791-.4-.4v-2.005l-.00005-.0066.00005-.0067v-1.9751L7.09253 17.5c0-.2209.17909-.4.4-.4h.00005Zm6.50002.8c.2209 0 .4-.1791.4-.4s-.1791-.4-.4-.4h-3c-.2209 0-.4.1791-.4.4s.1791.4.4.4h1.1002v3.6c0 .2209.1791.4.4.4s.4-.1791.4-.4v-3.6h1.0998Zm3.9-.4c0 .2209-.1791.4-.4.4h-1.5998v1.2h1.5998c.2209 0 .4.1791.4.4s-.1791.4-.4.4h-1.5998v1.6c0 .2209-.1791.4-.4.4s-.4-.1791-.4-.4v-1.9874l-.0002-.0126.0002-.0127v-1.9747l-.0002-.0126c0-.2209.1791-.4.4-.4h2c.2209 0 .4.1791.4.4Z", clipRule: "evenodd" }))), $p = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2H18v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141C18.509 3.08592 18.2021 3.00005 18 3V2c.4897.00011 1.0579.20883 1.3822.55575m0 0 4.1249 4.41129c.3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#ED6C47", d: "M16.1818 16.625 15.5455 16h-1.9091L13 16.625v3.24c.7686.7287 1.7954 1.1356 2.8636 1.135 1.0971 0 2.1492-.428 2.9249-1.1899C19.5642 19.0483 20 18.0149 20 16.9375v-.3125h-3.8182Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#FF8F6B", d: "M15.7 13c-1.0077-.0009-1.9762.4343-2.7 1.2133V17h3v-4h-.3Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#FFC7B5", d: "M17 12v4h4c0-1.0609-.4214-2.0783-1.1716-2.8284C19.0783 12.4214 18.0609 12 17 12Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#C43E1C", d: "M3.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H3.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M8.45259 13c.8238 0 1.45349.1877 1.89181.5614.4365.3746.6556.9167.6556 1.6263 0 .4562-.1038.8649-.3202 1.2193-.2156.3553-.5277.6263-.92667.8228-.39893.1974-.85599.3-1.38104.3H7.05993L7.05546 20H6v-7h2.45259Zm-1.39713 3.4912H8.5c.44991 0 .79159-.1035 1.02236-.3096.23077-.207.39446-.5746.39446-.972 0-.771-.49017-1.35-1.37478-1.35H7.05546v2.6316Z" }))), Op = "_fileIconContainer_1mrbn_1", zp = {
  fileIconContainer: Op
}, Hp = (e) => {
  const { file: n, className: t, noContainer: r, containerClassName: i } = e;
  let l = "";
  if (n != null && n.id)
    l = n == null ? void 0 : n.mime;
  else {
    const a = e == null ? void 0 : e.file;
    l = a == null ? void 0 : a.type;
  }
  let o = null;
  if (l != null && l.startsWith("image/"))
    o = /* @__PURE__ */ m(Fp, { className: t ?? "" });
  else
    switch (l) {
      case "application/pdf":
        o = /* @__PURE__ */ m(Rp, { className: t ?? "" });
        break;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        o = /* @__PURE__ */ m(Mp, { className: t ?? "" });
        break;
      case "application/rtf":
        o = /* @__PURE__ */ m(Dp, { className: t ?? "" });
        break;
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        o = /* @__PURE__ */ m(Bp, { className: t ?? "" });
        break;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        o = /* @__PURE__ */ m($p, { className: t ?? "" });
        break;
      default:
        o = /* @__PURE__ */ m(Pp, { className: t ?? "" });
        break;
    }
  return r ? o : /* @__PURE__ */ m("div", { className: `${zp.fileIconContainer} ${i ?? ""}`, children: o });
}, Vp = (e) => /* @__PURE__ */ _.createElement("svg", { width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/download export" }, /* @__PURE__ */ _.createElement("g", { id: "Union" }, /* @__PURE__ */ _.createElement("path", { d: "M6.5 13V23C6.5 23.5523 6.94772 24 7.5 24H25.5C26.0523 24 26.5 23.5523 26.5 23V13C26.5 12.4477 26.9477 12 27.5 12C28.0523 12 28.5 12.4477 28.5 13V23C28.5 24.6569 27.1569 26 25.5 26H7.5C5.84315 26 4.5 24.6569 4.5 23L4.5 13C4.5 12.4477 4.94772 12 5.5 12C6.05229 12 6.5 12.4477 6.5 13Z", fill: "#333333" }), /* @__PURE__ */ _.createElement("path", { d: "M22.5 14C22.5 14.2814 22.3838 14.5357 22.1967 14.7174L17.2184 19.6957C17.2147 19.6995 17.2109 19.7033 17.2071 19.7071C16.8166 20.0977 16.1834 20.0977 15.7929 19.7071L10.7929 14.7071C10.6932 14.6074 10.619 14.4919 10.5702 14.3687C10.5249 14.2546 10.5 14.1302 10.5 14C10.5 13.859 10.5292 13.7248 10.5818 13.6032C10.6231 13.5076 10.68 13.4172 10.7525 13.3358C10.7793 13.3056 10.8079 13.2771 10.8381 13.2504C10.9142 13.1831 10.998 13.1294 11.0865 13.0892C11.2125 13.0319 11.3525 13 11.5 13C11.6475 13 11.7875 13.0319 11.9135 13.0892C12.002 13.1294 12.0858 13.1831 12.1619 13.2504C12.179 13.2655 12.1955 13.2811 12.2116 13.2974L15.5 16.5858V7C15.5 6.44772 15.9477 6 16.5 6C17.0523 6 17.5 6.44772 17.5 7V16.5856L20.7928 13.2928C20.9738 13.1119 21.2239 13 21.5 13C22.0523 13 22.5 13.4477 22.5 14Z", fill: "#333333" })))), jp = (e) => {
  var b;
  const {
    file: n,
    receiver: t,
    className: r,
    previewClassName: i,
    receiverOverlayClassName: l,
    senderOverlayClassName: o,
    fixedPositioning: a,
    toggleTimestamp: s
  } = e, { t: c } = Te(), [u, d] = Tr.useState(null), h = Y((w) => w.replace(/(?:\r\n|\r|\n)/g, " "), []), p = Y(() => {
    var I;
    const w = ((I = n.url) == null ? void 0 : I.path) ?? "";
    if (w) {
      const C = document.createElement("a");
      C.href = w, C.download = "", document.body.appendChild(C), C.click(), document.body.removeChild(C);
    } else
      console.error("File URL is missing.");
  }, [(b = n == null ? void 0 : n.url) == null ? void 0 : b.path]);
  if (!n)
    return null;
  let y = null;
  const x = /* @__PURE__ */ m(
    "div",
    {
      className: `${ae.textContent} ${ae.noPreviewContainer} ${t ? ae.receiver : ae.sender}`,
      children: /* @__PURE__ */ m("div", { className: ae.noPreview, children: c("chat.no-preview") })
    }
  );
  return u ? y = x : n.mime.startsWith("image/") && n.url ? y = /* @__PURE__ */ m(
    "div",
    {
      className: `${ae.fileImageContainer}
        ${t ? ae.receiver : ""}`,
      children: /* @__PURE__ */ m(
        "img",
        {
          src: n.url.path,
          alt: n.name,
          className: ae.fileImage,
          onError: () => d(!0)
        }
      )
    }
  ) : n.textContent ? y = /* @__PURE__ */ O(
    "div",
    {
      className: `${ae.textContent} ${t ? ae.receiver : ae.sender}`,
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: `${ae.bgOverlay} ${t ? l : o}`
          }
        ),
        h(n.textContent)
      ]
    }
  ) : y = x, /* @__PURE__ */ O(Oe, { children: [
    /* @__PURE__ */ O(
      "div",
      {
        className: `
        ${ae.fileName}
        ${t ? ae.receiver : ""}
        ${r ?? ""}
      `,
        onClick: s,
        children: [
          /* @__PURE__ */ m(Hp, { file: n, className: ae.icon }),
          n == null ? void 0 : n.name
        ]
      }
    ),
    !u && /* @__PURE__ */ O(
      "div",
      {
        className: `
        ${ae.filePreviewContainer}
        ${t ? ae.receiver : ""}
        ${i ?? ""}
      `,
        children: [
          y,
          n.url ? /* @__PURE__ */ m("div", { className: ae.contextMenuContainer, children: /* @__PURE__ */ m(
            yi,
            {
              items: [
                {
                  label: c("prematter.download"),
                  onClick: () => p(),
                  icon: /* @__PURE__ */ m(Vp, { className: ae.downloadIcon })
                }
              ],
              className: ae.contextMenu,
              fixedPositioning: a,
              positioning: a ? t ? "left" : "right" : void 0
            }
          ) }) : null
        ]
      }
    )
  ] });
};
var qp = /* @__PURE__ */ ((e) => (e.Receiver = "Receiver", e.Sender = "Sender", e))(qp || {});
const Wp = (e) => /* @__PURE__ */ m("a", { href: e.href, target: "_blank", rel: "noreferrer", children: e.children }), qd = (e) => {
  const {
    externalBody: n,
    messageBody: t,
    sender: r,
    avatarLeft: i,
    avatarRight: l,
    avatarClassName: o,
    type: a,
    className: s,
    wrapperClassName: c,
    timestamp: u,
    timestampClassName: d,
    files: h,
    fileClassName: p,
    filePreviewClassName: y,
    systemFormMessage: x,
    senderOverlayClassName: b,
    receiverOverlayClassName: w,
    fixedPositioning: I,
    ...C
  } = e, [M, L] = J(!1), v = ue(null), S = Y(() => {
    L && (M ? L(!1) : (v.current && clearTimeout(v.current), v.current = setTimeout(() => {
      L(!1), v.current = null;
    }, 2e3), L(!0)));
  }, [M, L]), P = t && typeof t == "string" ? /* @__PURE__ */ m(
    Cn,
    {
      rehypePlugins: [yn],
      components: { a: Wp },
      children: t
    }
  ) : t;
  return /* @__PURE__ */ O(
    "div",
    {
      className: `${oe.messageWrapper} ${a === "Sender" ? oe.right : oe.left} ${c ?? ""}`,
      children: [
        i ? /* @__PURE__ */ m("div", { className: `${o ?? ""}`, children: i }) : null,
        /* @__PURE__ */ O("div", { className: oe.relativeWrapper, children: [
          /* @__PURE__ */ O("div", { className: `${oe.relativeContainer} ${n ? oe.withExternalBody : oe.noExternalBody}
          ${M ? oe.show : oe.hide}
          `, children: [
            r ? /* @__PURE__ */ m("div", { className: `${oe.senderContainer}
            ${a === "Receiver" ? oe.left : oe.right}`, children: r }) : null,
            P ? /* @__PURE__ */ m(
              "div",
              {
                className: `${oe.message} ${x ? oe.systemFormMessage : a === "Sender" ? oe.messageRight : oe.messageLeft} ${s ?? ""}`,
                ...C,
                onClick: S,
                children: P
              }
            ) : null,
            h == null ? void 0 : h.map((E, R) => /* @__PURE__ */ m(
              jp,
              {
                file: E,
                receiver: a === "Receiver",
                className: p,
                previewClassName: y,
                toggleTimestamp: S,
                senderOverlayClassName: b,
                receiverOverlayClassName: w,
                fixedPositioning: I
              },
              (E == null ? void 0 : E.id) ?? R
            )),
            u ? /* @__PURE__ */ m("div", { className: `${oe.timestampContainer}
              ${M ? oe.show : oe.hide}`, children: /* @__PURE__ */ m(
              "div",
              {
                className: `${oe.timestamp} ${d ?? ""}
                ${a === "Receiver" ? oe.left : oe.right}
                ${n ? oe.withExternalBody : oe.noExternalBody}`,
                children: u
              }
            ) }) : null
          ] }),
          n
        ] }),
        l ? /* @__PURE__ */ m("div", { className: `${o ?? ""}`, children: l }) : null
      ]
    }
  );
};
var pt, An = Pi;
if (process.env.NODE_ENV === "production")
  pt = An.createRoot, An.hydrateRoot;
else {
  var Ar = An.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  pt = function(e, n) {
    Ar.usingClientEntryPoint = !0;
    try {
      return An.createRoot(e, n);
    } finally {
      Ar.usingClientEntryPoint = !1;
    }
  };
}
const Zp = "_confirmModalWrapper_155go_76", Up = "_confirmModal_155go_76", Qp = "_confirmModalHeader_155go_100", Yp = "_confirmModalTitle_155go_109", Kp = "_confirmModalDescription_155go_121", Xp = "_confirmModalFooter_155go_132", Jp = "_disabled_155go_175", Ue = {
  confirmModalWrapper: Zp,
  confirmModal: Up,
  confirmModalHeader: Qp,
  confirmModalTitle: Yp,
  confirmModalDescription: Kp,
  confirmModalFooter: Xp,
  disabled: Jp
}, Gp = ie(
  (e, n) => {
    const { t } = Te();
    return /* @__PURE__ */ O("div", { className: Ue.confirmModalWrapper, children: [
      /* @__PURE__ */ O("div", { ref: n, className: Ue.confirmModal, children: [
        /* @__PURE__ */ O("div", { className: Ue.confirmModalHeader, children: [
          /* @__PURE__ */ m("div", { className: Ue.confirmModalTitle, children: e.title }),
          /* @__PURE__ */ m("div", { className: Ue.confirmModalDescription, children: e.description })
        ] }),
        /* @__PURE__ */ O("div", { className: Ue.confirmModalFooter, children: [
          /* @__PURE__ */ m("button", { onClick: e.onCancel, children: t("confirm.cancel") }),
          /* @__PURE__ */ m("button", { onClick: e.onConfirm, children: t("confirm.yes") })
        ] })
      ] }),
      /* @__PURE__ */ m("div", { className: Ue.confirmModalBackground })
    ] });
  }
), Wd = ({
  title: e,
  description: n,
  onConfirm: t
}) => {
  const r = document.createElement("div");
  document.body.appendChild(r);
  const i = pt(r);
  document.body.style.overflow = "hidden";
  const l = () => {
    t(), a();
  }, o = () => {
    a();
  }, a = () => {
    i.unmount(), document.body.removeChild(r), document.body.style.overflow = "auto";
  };
  i.render(
    /* @__PURE__ */ m(
      Gp,
      {
        title: e,
        description: n,
        onConfirm: l,
        onCancel: o
      }
    )
  );
}, ed = "_aiLawyerSelectorWrapper_97wkv_76", nd = "_aiLawyerIconContainer_97wkv_84", td = "_aiLawyerIcon_97wkv_84", rd = "_hoverEnabled_97wkv_116", id = "_popupOverlay_97wkv_120", ld = "_aiLawyerPickerWrapper_97wkv_127", od = "_aiLawyerPickerItem_97wkv_138", ad = "_aiLawyerPickerImage_97wkv_148", sd = "_selectedLawyer_97wkv_152", cd = "_topStart_97wkv_162", ud = "_topMiddle_97wkv_175", pd = "_bottomStart_97wkv_180", dd = "_bottomMiddle_97wkv_194", hd = "_noSelect_97wkv_256", me = {
  aiLawyerSelectorWrapper: ed,
  aiLawyerIconContainer: nd,
  aiLawyerIcon: td,
  hoverEnabled: rd,
  popupOverlay: id,
  aiLawyerPickerWrapper: ld,
  aiLawyerPickerItem: od,
  aiLawyerPickerImage: ad,
  selectedLawyer: sd,
  topStart: cd,
  topMiddle: ud,
  bottomStart: pd,
  bottomMiddle: dd,
  noSelect: hd
}, Zd = (e) => {
  const [n, t] = J(""), [r, i] = J(!1), { isSelectorEnabled: l, selectedAiLawyer: o, aiLawyers: a, onAiLawyerChange: s, headerContainerRef: c, chatContainerRef: u } = e, [d, h] = J(!1), p = ue(null), [y, x] = J("topMiddle"), b = 76, w = 312, I = ue(null), C = (E) => {
    s && s(E), h(!1);
  };
  le(() => {
    o && ((R) => {
      const k = a.find(
        (A) => A.aiLawyer === R
      );
      k && (t(k.image), i(!0));
    })(o);
  }, [o, a]);
  const M = () => {
    var E;
    if (I.current && clearTimeout(I.current), c && c.current && u && u.current) {
      const R = c.current.getBoundingClientRect(), k = u.current.getBoundingClientRect(), A = (E = p.current) == null ? void 0 : E.getBoundingClientRect();
      R && A && k && (R.bottom < A.top - b && k.left < A.left - w / 2 ? x("topMiddle") : R.bottom < A.top - b && k.left >= A.left - w / 2 ? x("topStart") : k.left < A.left - w / 2 ? x("bottomMiddle") : x("bottomStart"));
    }
    h(!0);
  }, L = () => {
    I.current = setTimeout(() => {
      h(!1);
    }, 300);
  }, v = () => {
    I.current && clearTimeout(I.current);
  }, S = () => {
    I.current = setTimeout(() => {
      h(!1);
    }, 300);
  }, P = () => {
    i(!1);
  };
  return /* @__PURE__ */ O("div", { className: me.aiLawyerSelectorWrapper, children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: `${me.aiLawyerIconContainer} ${me.noSelect} ${d && l ? me.hoverEnabled : ""} `,
        onMouseEnter: () => M(),
        onMouseLeave: () => L(),
        ref: p,
        children: r ? /* @__PURE__ */ m(
          "img",
          {
            className: `${me.aiLawyerIcon} ${me.noSelect}`,
            src: n,
            onError: P
          }
        ) : null
      }
    ),
    d && l && /* @__PURE__ */ m(
      "div",
      {
        className: `${me.popupOverlay} ${me.noSelect} ${me[y]}`,
        onMouseEnter: () => v(),
        onMouseLeave: () => S(),
        children: /* @__PURE__ */ m("div", { className: me.aiLawyerPickerWrapper, children: a.map((E) => /* @__PURE__ */ m(
          "div",
          {
            className: `${me.aiLawyerPickerItem} ${o === E.aiLawyer ? me.selectedLawyer : ""}`,
            onClick: () => C(E.aiLawyer),
            children: /* @__PURE__ */ m(
              "img",
              {
                className: `${me.aiLawyerPickerImage} ${me.noSelect}`,
                src: E.image
              }
            )
          },
          E.aiLawyer
        )) })
      }
    )
  ] });
}, fd = "_financialInput_dkbud_76", md = {
  financialInput: fd
}, Ud = ie(
  (e, n) => {
    var o;
    const { value: t, disabled: r, onChange: i } = e, l = Y((a) => {
      a.preventDefault(), a.stopPropagation(), r || i(a.target.value);
    }, [r, i]);
    return /* @__PURE__ */ m(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${md.numericInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "number",
        value: t,
        onChange: l
      }
    );
  }
), gd = "_onOffInputContainer_x4s2d_76", yd = "_onOffInputTitle_x4s2d_85", wd = "_onOffInputValue_x4s2d_92", Cd = "_switchButton_x4s2d_100", vd = "_switchButtonCircle_x4s2d_107", xd = "_on_x4s2d_76", bd = "_off_x4s2d_122", _d = "_disabled_x4s2d_127", Me = {
  onOffInputContainer: gd,
  onOffInputTitle: yd,
  onOffInputValue: wd,
  switchButton: Cd,
  switchButtonCircle: vd,
  on: xd,
  off: bd,
  disabled: _d
}, Qd = ie(
  (e, n) => {
    const {
      title: t,
      value: r,
      disabled: i,
      onChange: l,
      className: o
    } = e, { t: a } = Te(), s = () => {
      l(!r);
    };
    return /* @__PURE__ */ O(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Me.onOffInputContainer} ${o || ""}`,
        children: [
          /* @__PURE__ */ m("div", { className: `${Me.onOffInputTitle}`, children: t }),
          /* @__PURE__ */ m("div", { className: `${Me.onOffInputValue}`, children: a(r ? "confirm.on" : "confirm.off") }),
          /* @__PURE__ */ m("div", { className: `${Me.switchButton} ${r ? Me.on : Me.off} ${i ? Me.disabled : ""}`, onClick: s, children: /* @__PURE__ */ m("div", { className: `${Me.switchButtonCircle} ${r ? Me.on : Me.off}` }) })
        ]
      }
    );
  }
);
export {
  Zd as AiLawyerSelector,
  Vd as Carousel,
  Dd as ChatElement,
  Uc as ChatInput,
  qp as ChatMessageType,
  qd as ChatMessageWrapper,
  bu as CheckboxInput,
  Gp as ConfirmModal,
  yi as ContextMenu,
  Su as DateInput,
  Mu as DateTimeInput,
  a1 as FileInput,
  Ud as FinancialInput,
  j1 as InlineForm,
  Nn as InputDescription,
  ju as InputLabel,
  gi as InputSeparator,
  wc as LawyerChatMessage,
  Hd as MessageRow,
  u1 as NumericInput,
  Qd as OnOffInput,
  Od as OverviewForm,
  fu as ProgressBar,
  Pd as QuestionList,
  ln as QuestionWrapper,
  Cu as RadioInput,
  M1 as ScaleInput,
  jd as SectionedForm,
  R1 as SplitDateInput,
  $d as TextInput,
  Di as TextareaInput,
  Du as TimeInput,
  zd as Toast,
  mc as UserChatMessage,
  pu as YesNoInput,
  Wd as confirm,
  ru as formatDate,
  Rd as formatDateTime,
  iu as formatLongDateTime,
  Bd as formatMediumDateTime,
  Fd as formatTime
};
